import * as n from "react";
import { useRef as j, useEffect as U, Component as no, useState as D, useLayoutEffect as ge, isValidElement as kn, cloneElement as za, forwardRef as ns, useContext as ta, createContext as na, useMemo as _e, useCallback as oe, Fragment as as, Children as Aa, createRef as rs } from "react";
import { createPortal as Cn } from "react-dom";
import { c as os, a as ss, t as ao, f as ar, b as ls } from "./format-CVedM0M8.js";
const cs = "_page_uait6_5", is = "_inner_uait6_25", us = "_pageScroll_uait6_38", ms = "_innerScroll_uait6_39", Bn = {
  page: cs,
  inner: is,
  pageScroll: us,
  innerScroll: ms
}, nw = { width: 1920, height: 1080 }, aw = { width: 1280, height: 720 }, ds = 64, rw = { collapsed: 64, pinned: 240 }, ow = { width: 1856, height: 1016 }, sw = { width: 1216, height: 656 }, lw = { width: 1040, height: 656 }, Kn = 1024, ro = Kn;
function fs(e) {
  const t = e != null ? e : Kn;
  return !Number.isFinite(t) || t <= 0 ? Kn : Math.min(t, ro);
}
const ps = 48;
function _s(e) {
  const t = [], a = Math.round(e.contentBottom - e.boxBottom);
  return e.scroll === "grid" && a > 2 && t.push(`[AXErpPage] 본문이 페이지 바닥 아래로 ${a}px 넘쳐 잘린다 — scroll="grid"(기본)라 휠로 닿지 않는다. 입력 문서·여러 표가 쌓이는 화면은 <AXErpPage scroll="page">, 목록이면 표 하나만 AXErpGrid grow 로 — docs/ERP_화면_표준_사이즈.md R3`), e.squashedBoxes.length && t.push(`[AXErpPage] 스크롤 상자 ${e.squashedBoxes.length}개가 ${Math.round(Math.min(...e.squashedBoxes))}px 로 눌려 내용(표 행)이 거의 안 보인다 — 표 위 층(배너·안내·접기)이 높이를 다 썼다. 위를 접거나 scroll="page" 로 — docs/ERP_화면_표준_사이즈.md R3`), t;
}
const oo = () => typeof location != "undefined" && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname), rr = /* @__PURE__ */ new Set();
function ys(e, t) {
  oo() && (rr.has(e) || (rr.add(e), console.warn(`[AXErpPage] minWidth ${e} → ${t} (표준 상한 ${ro}). 넓은 표는 minWidth 가 아니라 그리드 스트립에 맡긴다 — docs/ERP_화면_표준_사이즈.md`)));
}
function hs(e, t) {
  var l;
  const a = e.firstElementChild;
  let r = -1 / 0;
  for (const c of Array.from((l = a == null ? void 0 : a.children) != null ? l : [])) {
    const i = getComputedStyle(c).position;
    i === "absolute" || i === "fixed" || (r = Math.max(r, c.getBoundingClientRect().bottom));
  }
  const o = [], s = e.getElementsByTagName("*");
  if (s.length <= 2e4)
    for (const c of Array.from(s)) {
      const i = c.clientHeight;
      if (i >= ps || c.scrollHeight <= i + 1 || /^(TEXTAREA|INPUT|SELECT)$/.test(c.tagName)) continue;
      const m = getComputedStyle(c).overflowY;
      (m === "auto" || m === "scroll") && c.getBoundingClientRect().width > 0 && o.push(i);
    }
  return { scroll: t, contentBottom: r, boxBottom: e.getBoundingClientRect().top + e.clientHeight, squashedBoxes: o };
}
const or = /* @__PURE__ */ new Set();
function Es(e, t) {
  U(() => {
    const a = e.current;
    if (!a || !oo() || typeof MutationObserver == "undefined") return;
    let r;
    const o = () => {
      r = void 0;
      for (const i of _s(hs(a, t))) {
        const m = `${location.pathname}|${i.slice(0, 24)}`;
        or.has(m) || (or.add(m), console.warn(i, a));
      }
    }, s = () => {
      r && clearTimeout(r), r = setTimeout(o, 800);
    };
    s();
    const l = new MutationObserver(s);
    l.observe(a, { childList: !0, subtree: !0 });
    const c = typeof ResizeObserver != "undefined" ? new ResizeObserver(s) : null;
    return c == null || c.observe(a), () => {
      r && clearTimeout(r), l.disconnect(), c == null || c.disconnect();
    };
  }, [e, t]);
}
function bs({
  gnbHeight: e = ds,
  minWidth: t = Kn,
  scroll: a = "grid",
  className: r = "",
  style: o,
  children: s
}) {
  const l = a === "page", c = j(null);
  Es(c, a);
  const i = fs(t);
  return i !== t && ys(t, i), /* @__PURE__ */ n.createElement(
    "main",
    {
      ref: c,
      className: [Bn.page, l && Bn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ n.createElement("div", { className: [Bn.inner, l && Bn.innerScroll].filter(Boolean).join(" "), style: { minWidth: i } }, s)
  );
}
const gs = "_body_1wgsn_4", vs = {
  body: gs
};
function cw({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [vs.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const ks = "_orbitPortalRoot_177qv_2", ws = {
  orbitPortalRoot: ks
};
class rn extends no {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || ws.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return Cn(this.props.children, this.getPortalRoot());
  }
}
const Ns = "_anchor_7h2m7_2", $s = "_tip_7h2m7_5", sr = {
  anchor: Ns,
  tip: $s
};
let xs = 0;
function zt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = D(!1), [u, d] = D({ top: 0, left: 0 }), _ = j(null), p = j(null), y = j(null), f = j("");
  f.current || (f.current = `axe-tip-${++xs}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, g = (k) => {
    b(), k <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), k);
  }, N = () => {
    b(), m(!1);
  };
  U(() => b, []), ge(() => {
    if (!i) return;
    const k = () => {
      const w = _.current, v = p.current;
      if (!w || !v) return;
      const A = w.getBoundingClientRect(), C = v.offsetHeight, M = v.offsetWidth;
      let B = a === "top" ? A.top - C - 6 : A.bottom + 6;
      a === "bottom" && B + C > window.innerHeight - 4 && A.top - C - 6 > 4 && (B = A.top - C - 6), a === "top" && B < 4 && A.bottom + 6 + C < window.innerHeight - 4 && (B = A.bottom + 6);
      const I = Math.max(4, Math.min(A.left + A.width / 2 - M / 2, window.innerWidth - M - 4));
      d((T) => T.top === B && T.left === I ? T : { top: B, left: I });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [i, a, e]), U(() => {
    if (!i) return;
    const k = (w) => {
      w.key !== "Escape" || w.isComposing || (w.preventDefault(), w.stopPropagation(), N());
    };
    return document.addEventListener("keydown", k, !0), () => document.removeEventListener("keydown", k, !0);
  }, [i]);
  const E = e != null && e !== !1 && e !== "";
  if (!E && !c) return t;
  const $ = E && kn(t) ? za(t, i && s ? { "aria-describedby": f.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: _,
      className: [sr.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        E && g(r);
      },
      onMouseLeave: N,
      onFocus: () => {
        E && g(0);
      },
      onBlur: N
    },
    $,
    E && i && /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: p,
        id: f.current,
        role: "tooltip",
        className: sr.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: N
      },
      e
    ))
  );
}
const As = "_bar_gkpv7_1", Ds = "_menu_gkpv7_17", Ss = "_title_gkpv7_27", Cs = "_info_gkpv7_29", Ms = "_badge_gkpv7_37", Ts = "_badge_muted_gkpv7_38", Bs = "_badge_ok_gkpv7_39", qs = "_badge_warn_gkpv7_40", Ls = "_meta_gkpv7_42", js = "_actions_gkpv7_26", Is = "_notice_gkpv7_59", Rs = "_notice_info_gkpv7_65", Ps = "_notice_ok_gkpv7_66", Xs = "_notice_err_gkpv7_67", Je = {
  bar: As,
  menu: Ds,
  title: Ss,
  info: Cs,
  badge: Ms,
  badge_muted: Ts,
  badge_ok: Bs,
  badge_warn: qs,
  meta: Ls,
  actions: js,
  notice: Is,
  notice_info: Rs,
  notice_ok: Ps,
  notice_err: Xs
};
function Os({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Je.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Je.title }, e), a && /* @__PURE__ */ n.createElement(zt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Je.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Je.badge, Je[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Je.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Je.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Je.notice, Je[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const zs = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  /* 분개 보기 전환 — 목록형(행 머리 점 + 줄) */
  list: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M9 6h11M9 12h11M9 18h11" }), /* @__PURE__ */ n.createElement("path", { d: "M4.5 6h.01M4.5 12h.01M4.5 18h.01" })),
  /* 분개 보기 전환 — T분개형(머리줄 아래 차변·대변 두 칸) */
  tAccount: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M3 6h18" }), /* @__PURE__ */ n.createElement("path", { d: "M12 6v14" }), /* @__PURE__ */ n.createElement("path", { d: "M5 10.5h4.5M5 14.5h4.5M14.5 10.5H19M14.5 14.5H19" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Hs = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Ws({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Hs[e]);
}
function wn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    zs[e]
  );
}
const Fs = "_btn_q02rt_1", Ks = "_sm_q02rt_18", Vs = "_primary_q02rt_21", Us = "_dark_q02rt_23", Gs = "_danger_q02rt_25", Ys = "_soon_q02rt_29", Qs = "_soonTag_q02rt_30", Js = "_blocked_q02rt_39", Zs = "_kbd_q02rt_51", el = "_iconBtn_q02rt_54", tl = "_link_q02rt_70", mt = {
  btn: Fs,
  sm: Ks,
  primary: Vs,
  dark: Us,
  danger: Gs,
  soon: Ys,
  soonTag: Qs,
  blocked: Js,
  kbd: Zs,
  iconBtn: el,
  link: tl
}, Fe = ns(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    icon: s,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: m,
    className: u = "",
    type: d = "button",
    onClick: _,
    title: p,
    disabled: y,
    ...f
  } = t, b = c || i || "", g = b !== "", N = "blockedReason" in t, E = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: d,
      className: [mt.btn, mt[r], o === "sm" ? mt.sm : "", c ? mt.soon : g ? mt.blocked : "", u].filter(Boolean).join(" "),
      "aria-disabled": g ? !0 : void 0,
      disabled: g ? void 0 : y,
      title: g ? void 0 : p,
      onClick: g ? ($) => $.preventDefault() : _,
      ...f
    },
    s && /* @__PURE__ */ n.createElement(wn, { name: s, size: o === "sm" ? 12 : 14 }),
    m,
    l && /* @__PURE__ */ n.createElement("kbd", { className: mt.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: mt.soonTag }, "준비 중")
  );
  return g || N ? /* @__PURE__ */ n.createElement(zt, { content: b, keepWrapper: N }, E) : E;
});
function Da({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(zt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [mt.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function Ha({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [mt.link, t].filter(Boolean).join(" "), ...r }, e);
}
const nl = "_wrap_10shm_1", al = "_btn_10shm_2", rl = "_on_10shm_6", ol = "_caret_10shm_8", sl = "_pop_10shm_9", ll = "_sec_10shm_14", cl = "_item_10shm_17", il = "_danger_10shm_24", ht = {
  wrap: nl,
  btn: al,
  on: rl,
  caret: ol,
  pop: sl,
  sec: ll,
  item: cl,
  danger: il
}, ul = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), iw = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function ml({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = D(!1), l = j(null), c = j(null), i = j(null), m = () => {
    var d, _;
    return Array.from((_ = (d = i.current) == null ? void 0 : d.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  U(() => {
    var d;
    o && ((d = m()[0]) == null || d.focus());
  }, [o]), U(() => {
    if (!o) return;
    const d = (p) => {
      l.current && !l.current.contains(p.target) && s(!1);
    }, _ = (p) => {
      var y;
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", _, !0);
    };
  }, [o]);
  const u = (d) => {
    const _ = m();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let y = -1;
    if (d.key === "ArrowDown") y = (p + 1) % _.length;
    else if (d.key === "ArrowUp") y = (p <= 0 ? _.length : p) - 1;
    else if (d.key === "Home") y = 0;
    else if (d.key === "End") y = _.length - 1;
    else if (d.key === "Tab") {
      s(!1);
      return;
    } else return;
    d.preventDefault(), _[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: ht.wrap, ref: l }, /* @__PURE__ */ n.createElement(zt, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [ht.btn, o ? ht.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((d) => !d),
      onKeyDown: (d) => {
        d.key === "ArrowDown" && !o && (d.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: ht.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: ht.pop, role: "menu", onKeyDown: u }, t.map((d) => d.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: d.key, className: ht.sec }, d.label, d.note && /* @__PURE__ */ n.createElement("small", null, d.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "menuitem",
      disabled: d.disabled,
      className: [ht.item, d.danger ? ht.danger : ""].join(" "),
      onClick: () => {
        var _;
        s(!1), (_ = c.current) == null || _.focus(), d.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, d.label),
    d.disabled && d.reason && /* @__PURE__ */ n.createElement("small", null, d.reason)
  ))));
}
const dl = "_pop_12uut_2", fl = "_auto_12uut_12", pl = "_head_12uut_13", _l = "_title_12uut_18", yl = "_close_12uut_19", hl = "_body_12uut_21", El = "_flush_12uut_22", bl = "_foot_12uut_23", Et = {
  pop: dl,
  auto: fl,
  head: pl,
  title: _l,
  close: yl,
  body: hl,
  flush: El,
  foot: bl
}, qn = 8;
function uw({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: o,
  children: s,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: m = !1,
  flush: u = !1,
  initialFocus: d,
  className: _
}) {
  const p = j(null), [y, f] = D({ left: e, top: t }), b = j(o);
  b.current = o;
  const g = () => {
    const E = p.current;
    if (!E) return;
    const $ = E.offsetWidth, k = E.offsetHeight, w = Math.max(qn, Math.min(e, window.innerWidth - $ - qn)), v = t + k > window.innerHeight - qn ? Math.max(qn, t - k - 32) : t;
    f((A) => A.left === w && A.top === v ? A : { left: w, top: v });
  };
  ge(g, [e, t]), U(() => {
    const E = p.current;
    if (!E || typeof ResizeObserver == "undefined") return;
    const $ = new ResizeObserver(g);
    return $.observe(E), () => $.disconnect();
  }, [e, t]), U(() => {
    const E = (v) => {
      p.current && !p.current.contains(v.target) && b.current(!1);
    }, $ = (v) => {
      v.key === "Escape" && (v.stopPropagation(), b.current(!0));
    }, k = (v) => {
      var A;
      (!(v.target instanceof Node) || !((A = p.current) != null && A.contains(v.target))) && b.current(!1);
    }, w = window.setTimeout(() => document.addEventListener("mousedown", E), 0);
    return document.addEventListener("keydown", $, !0), m && window.addEventListener("scroll", k, !0), () => {
      window.clearTimeout(w), document.removeEventListener("mousedown", E), document.removeEventListener("keydown", $, !0), window.removeEventListener("scroll", k, !0);
    };
  }, [m]), U(() => {
    var E, $;
    d && (($ = (E = p.current) == null ? void 0 : E.querySelector(d)) == null || $.focus());
  }, [d]);
  const N = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: p,
      className: `${Et.pop}${i ? "" : ` ${Et.auto}`}${_ ? ` ${_}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: Et.head }, /* @__PURE__ */ n.createElement("span", { className: Et.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: Et.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${Et.body}${u ? ` ${Et.flush}` : ""}` }, s),
    l != null && /* @__PURE__ */ n.createElement("div", { className: Et.foot }, l)
  );
  return typeof document == "undefined" ? N : Cn(N, document.body);
}
const gl = "_panel_pg53c_2", vl = "_head_pg53c_3", kl = "_kicker_pg53c_4", wl = "_actions_pg53c_5", Nl = "_link_pg53c_6", $l = "_menuHits_pg53c_8", xl = "_turns_pg53c_11", Al = "_turn_pg53c_11", Dl = "_q_pg53c_13", Sl = "_a_pg53c_5", Cl = "_aText_pg53c_15", Ml = "_step_pg53c_16", Tl = "_caret_pg53c_17", Bl = "_err_pg53c_19", Me = {
  panel: gl,
  head: vl,
  kicker: kl,
  actions: wl,
  link: Nl,
  menuHits: $l,
  turns: xl,
  turn: Al,
  q: Dl,
  a: Sl,
  aText: Cl,
  step: Ml,
  caret: Tl,
  err: Bl
};
function mw({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: o, onClose: s, labels: l }) {
  const c = j(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return U(() => {
    var m;
    (m = c.current) == null || m.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((m) => /* @__PURE__ */ n.createElement("button", { type: "button", key: m.path, onClick: () => r(m.path) }, m.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((m) => {
    var u;
    return /* @__PURE__ */ n.createElement("article", { key: m.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, m.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, m.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, m.answer), m.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (u = m.step) != null ? u : m.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), m.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, m.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function dw(e, t, a = !0) {
  const r = j(t);
  r.current = t, U(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function ql() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Ll = "_bar_1g564_2", jl = "_sticky_1g564_12", Il = "_start_1g564_19", Rl = "_end_1g564_20", Pl = "_status_1g564_22", Xl = "_dirty_1g564_23", Ol = "_kbd_1g564_25", St = {
  bar: Ll,
  sticky: jl,
  start: Il,
  end: Rl,
  status: Pl,
  dirty: Xl,
  kbd: Ol
};
function fw({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", St.bar, o ? "" : St.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: St.start }, e), /* @__PURE__ */ n.createElement("span", { className: St.end }, a && /* @__PURE__ */ n.createElement("span", { className: [St.status, r ? St.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: St.kbd }, ql())));
}
const zl = "_root_j67qt_2", Hl = "_closed_j67qt_3", Wl = "_tab_j67qt_6", Fl = "_collapse_j67qt_7", Kl = "_body_j67qt_16", Vl = "_card_j67qt_32", Ul = "_head_j67qt_37", Gl = "_cardOpen_j67qt_44", Yl = "_headBtn_j67qt_47", Ql = "_icon_j67qt_56", Jl = "_badge_j67qt_57", Zl = "_trailing_j67qt_58", ec = "_chev_j67qt_59", tc = "_panelWrap_j67qt_63", nc = "_panelOpen_j67qt_67", ac = "_panelBody_j67qt_68", rc = "_panelInner_j67qt_69", oc = "_panelSettled_j67qt_70", ke = {
  root: zl,
  closed: Hl,
  tab: Wl,
  collapse: Fl,
  body: Kl,
  card: Vl,
  head: Ul,
  cardOpen: Gl,
  headBtn: Yl,
  icon: Ql,
  badge: Jl,
  trailing: Zl,
  chev: ec,
  panelWrap: tc,
  panelOpen: nc,
  panelBody: ac,
  panelInner: rc,
  panelSettled: oc
}, sc = 1280, lc = 8, so = "axe-side-bar:";
function cc(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(so + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function ic(e, t) {
  if (e)
    try {
      window.localStorage.setItem(so + e, t ? "1" : "0");
    } catch {
    }
}
function pw({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = sc,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var _;
  const c = j(cc(o)), [i, m] = D((_ = c.current) != null ? _ : t), u = j(c.current !== null);
  if (U(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!p.matches && t);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const d = () => {
    u.current = !0, ic(o, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ke.root, i ? "" : ke.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : lc }
    },
    /* @__PURE__ */ n.createElement("div", { className: ke.tab }, /* @__PURE__ */ n.createElement(zt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ke.collapse,
        onClick: d,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Ws, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ke.body }, l)
  );
}
const lo = na(null);
function _w({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = D(t);
  return a ? /* @__PURE__ */ n.createElement(lo.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const co = "axe-side-panel:";
function uc(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(co + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function mc(e, t) {
  if (e)
    try {
      window.localStorage.setItem(co + e, t ? "1" : "0");
    } catch {
    }
}
function yw({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var k;
  const u = ta(lo), d = !!u && c != null, _ = j(uc(l)), [p, y] = D((k = _.current) != null ? k : a), f = d ? u.openId === c : p, [b, g] = D(f), [N, E] = D(f);
  if (!t) return null;
  f && !b && g(!0);
  const $ = () => {
    const w = !f;
    mc(l, w), g(!0), E(!1), d ? u.setOpenId(w ? c : null) : y(w);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ke.card, f ? ke.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ke.head, onClick: $ }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ke.headBtn, "aria-expanded": f }, r && /* @__PURE__ */ n.createElement("span", { className: ke.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ke.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ke.trailing, onClick: (w) => w.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ke.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ke.panelWrap, f ? ke.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && E(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ke.panelBody, f && N ? ke.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ke.panelInner }, m))
  ));
}
const dc = "_guide_qnh7l_1", fc = "_title_qnh7l_5", pc = "_desc_qnh7l_6", _c = "_act_qnh7l_7", yc = "_why_qnh7l_13", hc = "_steps_qnh7l_14", Ec = "_no_qnh7l_20", bc = "_cur_qnh7l_24", gc = "_link_qnh7l_26", ot = {
  guide: dc,
  title: fc,
  desc: pc,
  act: _c,
  why: yc,
  steps: hc,
  no: Ec,
  cur: bc,
  link: gc
};
function hw({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: ot.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: ot.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: ot.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: ot.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: ot.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? ot.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: ot.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const vc = "_list_1w2rs_1", kc = "_row_1w2rs_2", wc = "_label_1w2rs_6", Nc = "_value_1w2rs_7", $c = "_emphasis_1w2rs_8", xc = "_changed_1w2rs_10", Ut = {
  list: vc,
  row: kc,
  label: wc,
  value: Nc,
  emphasis: $c,
  changed: xc
};
function Ew({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [Ut.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [Ut.row, a.emphasis ? Ut.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: Ut.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [Ut.value, a.changed ? Ut.changed : ""].join(" ") }, a.value))));
}
const Ac = "_underline_1kpv5_2", Dc = "_active_1kpv5_24", Sc = "_segmented_1kpv5_33", da = {
  underline: Ac,
  active: Dc,
  segmented: Sc
};
function io({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? da.segmented : da.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? da.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Cc = "_bar_1cidz_1", Mc = "_fields_1cidz_4", Tc = "_actions_1cidz_36", Bc = "_field_1cidz_4", qc = "_fieldLabel_1cidz_46", Lc = "_readout_1cidz_54", jc = "_search_1cidz_65", Ic = "_detail_1cidz_79", Rc = "_pill_1cidz_92", Pc = "_hint_1cidz_103", Ge = {
  bar: Cc,
  fields: Mc,
  actions: Tc,
  field: Bc,
  fieldLabel: qc,
  readout: Lc,
  search: jc,
  detail: Ic,
  pill: Rc,
  hint: Pc
}, Xc = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Oc(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Xc.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function bw({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: m = "초기화",
  resetDisabled: u,
  trailing: d,
  enterSearch: _ = !0
}) {
  const p = (y) => {
    !_ || !t || r || !Oc(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ge.bar, onKeyDown: p }, /* @__PURE__ */ n.createElement("div", { className: Ge.fields }, e), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, d, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.detail, onClick: i, disabled: u }, m), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(zt, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.search, onClick: t, disabled: r, "data-axe-search": "" }, "⌕ ", a))));
}
function zc({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ge.field }, /* @__PURE__ */ n.createElement("span", { className: Ge.fieldLabel }, e), t);
}
function gw({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ge.readout }, e);
}
function vw({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ge.pill, role: "status" }, e);
}
function kw({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ge.hint }, e);
}
let Hc = 0;
function Ht(e = "axe") {
  const t = j(null);
  return t.current || (t.current = `${e}-${++Hc}`), t.current;
}
const Wc = "_btn_8aja4_2", Fc = "_text_8aja4_12", Kc = "_caret_8aja4_13", Vc = "_pop_8aja4_15", Uc = "_opt_8aja4_21", Gc = "_act_8aja4_22", Yc = "_sel_8aja4_23", Qc = "_off_8aja4_24", bt = {
  btn: Wc,
  text: Fc,
  caret: Kc,
  pop: Vc,
  opt: Uc,
  act: Gc,
  sel: Yc,
  off: Qc
}, Ln = 2, Jc = 260;
function Ie({
  value: e,
  options: t,
  onChange: a,
  disabled: r,
  label: o,
  id: s,
  "aria-describedby": l,
  "aria-invalid": c,
  "aria-required": i,
  className: m,
  title: u,
  style: d,
  onClick: _,
  buttonRef: p,
  popZIndex: y = 3500
}) {
  const [f, b] = D(!1), [g, N] = D(-1), [E, $] = D(null), k = j(null), w = j(null), v = j({ text: "", at: 0 }), A = Ht("axe-dd"), C = `${A}-list`, M = _e(() => t.findIndex((h) => h.value === e), [t, e]), B = M >= 0 ? t[M].label : "", I = oe(() => {
    const h = k.current;
    if (!h) return;
    const S = h.getBoundingClientRect(), P = window.innerHeight - S.bottom - Ln - 8, H = S.top - Ln - 8, J = P < 120 && H > P, q = Math.max(80, Math.min(Jc, J ? H : P));
    $({
      left: Math.max(4, Math.min(S.left, window.innerWidth - S.width - 4)),
      top: J ? S.top - Ln : S.bottom + Ln,
      minWidth: S.width,
      maxHeight: q,
      up: J
    });
  }, []), T = (h, S) => {
    for (let P = h; P >= 0 && P < t.length; P += S) if (!t[P].disabled) return P;
    return -1;
  }, z = () => {
    if (r) return;
    const h = M >= 0 && !t[M].disabled ? M : T(0, 1);
    N(h), b(!0);
  }, G = (h) => {
    var S;
    b(!1), h && ((S = k.current) == null || S.focus());
  }, K = (h) => {
    const S = t[h];
    !S || S.disabled || (S.value !== e && a(S.value), G(!0));
  };
  ge(() => {
    f && I();
  }, [f, I]), U(() => {
    if (!f) return;
    const h = (H) => {
      var q, Q;
      const J = H.target;
      (q = k.current) != null && q.contains(J) || (Q = w.current) != null && Q.contains(J) || b(!1);
    }, S = (H) => {
      H.key !== "Escape" || H.isComposing || (H.stopPropagation(), G(!0));
    }, P = (H) => {
      var J;
      H.target instanceof Node && ((J = w.current) != null && J.contains(H.target)) || I();
    };
    return document.addEventListener("mousedown", h), document.addEventListener("keydown", S, !0), window.addEventListener("resize", I), window.addEventListener("scroll", P, !0), () => {
      document.removeEventListener("mousedown", h), document.removeEventListener("keydown", S, !0), window.removeEventListener("resize", I), window.removeEventListener("scroll", P, !0);
    };
  }, [f, I]), U(() => {
    var h, S, P;
    !f || g < 0 || (P = (S = (h = w.current) == null ? void 0 : h.querySelector(`[data-i="${g}"]`)) == null ? void 0 : S.scrollIntoView) == null || P.call(S, { block: "nearest" });
  }, [f, g, E]);
  const R = (h) => {
    h >= 0 && N(h);
  }, ne = (h) => {
    if (r || h.nativeEvent.isComposing) return;
    const S = h.key;
    if (!f) {
      (S === "ArrowDown" || S === "ArrowUp" || S === "Enter" || S === " ") && (h.preventDefault(), z());
      return;
    }
    if (S === "ArrowDown")
      h.preventDefault(), R(T(g + 1, 1) >= 0 ? T(g + 1, 1) : g);
    else if (S === "ArrowUp")
      h.preventDefault(), R(T(g - 1, -1) >= 0 ? T(g - 1, -1) : g);
    else if (S === "Home")
      h.preventDefault(), R(T(0, 1));
    else if (S === "End")
      h.preventDefault(), R(T(t.length - 1, -1));
    else if (S === "Enter" || S === " ")
      h.preventDefault(), g >= 0 ? K(g) : G(!0);
    else if (S === "Tab") b(!1);
    else if (S.length === 1 && !h.ctrlKey && !h.metaKey && !h.altKey) {
      const P = Date.now(), H = v.current;
      H.text = P - H.at > 700 ? S.toLowerCase() : H.text + S.toLowerCase(), H.at = P;
      const J = (Q) => !Q.disabled && Q.label.toLowerCase().startsWith(H.text), q = t.findIndex((Q, X) => J(Q) && (H.text.length > 1 || X > g));
      R(q >= 0 ? q : t.findIndex(J));
    }
  }, te = (h) => `${A}-o${h}`;
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: (h) => {
        k.current = h, typeof p == "function" ? p(h) : p && (p.current = h);
      },
      type: "button",
      role: "combobox",
      id: s,
      className: [bt.btn, m].filter(Boolean).join(" "),
      style: d,
      title: u,
      disabled: r,
      "aria-label": o,
      "aria-haspopup": "listbox",
      "aria-expanded": f,
      "aria-controls": f ? C : void 0,
      "aria-activedescendant": f && g >= 0 ? te(g) : void 0,
      "aria-describedby": l,
      "aria-invalid": c,
      "aria-required": i,
      "data-value": e,
      onClick: (h) => {
        _ == null || _(h), !h.defaultPrevented && (f ? G(!1) : z());
      },
      onKeyDown: ne
    },
    /* @__PURE__ */ n.createElement("span", { className: bt.text }, B || " "),
    /* @__PURE__ */ n.createElement("span", { className: bt.caret, "aria-hidden": "true" }, "▾")
  ), f && E && Cn(
    /* @__PURE__ */ n.createElement(
      "ul",
      {
        ref: w,
        id: C,
        role: "listbox",
        "aria-label": o,
        className: bt.pop,
        style: {
          left: E.left,
          minWidth: E.minWidth,
          maxHeight: E.maxHeight,
          zIndex: y,
          ...E.up ? { bottom: window.innerHeight - E.top } : { top: E.top }
        }
      },
      t.map((h, S) => /* @__PURE__ */ n.createElement(
        "li",
        {
          key: h.value,
          id: te(S),
          "data-i": S,
          role: "option",
          "aria-selected": h.value === e,
          "aria-disabled": h.disabled || void 0,
          className: [
            bt.opt,
            S === g ? bt.act : "",
            h.value === e ? bt.sel : "",
            h.disabled ? bt.off : ""
          ].filter(Boolean).join(" "),
          onMouseEnter: () => {
            h.disabled || N(S);
          },
          onMouseDown: (P) => P.preventDefault(),
          onClick: () => K(S)
        },
        h.label || " "
      ))
    ),
    document.body
  ));
}
function Zc(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function ww({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(zc, { label: o }, /* @__PURE__ */ n.createElement(
    Ie,
    {
      value: t == null ? "" : String(t),
      label: o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      options: e.map((s) => ({ value: String(s.gisu), label: Zc(s) })),
      onChange: (s) => a(Number(s))
    }
  ));
}
const ei = "_box_1eajr_2", ti = "_mark_1eajr_17", ni = "_run_1eajr_30", fa = {
  box: ei,
  mark: ti,
  run: ni
};
function Nw({
  onRun: e,
  placeholder: t,
  label: a = "AI 검색",
  busyLabel: r = "찾는 중…",
  title: o,
  maxLength: s = 200,
  disabled: l = !1,
  className: c
}) {
  const [i, m] = D(""), [u, d] = D(!1), _ = j(0), p = async () => {
    const y = i.trim();
    if (u || l || !y) return;
    const f = ++_.current;
    d(!0);
    try {
      await e(y);
    } finally {
      f === _.current && d(!1);
    }
  };
  return /* @__PURE__ */ n.createElement("label", { className: [fa.box, c].filter(Boolean).join(" "), title: l ? o : void 0 }, /* @__PURE__ */ n.createElement("span", { className: fa.mark, "aria-hidden": "true" }, "✦"), /* @__PURE__ */ n.createElement(
    "input",
    {
      value: i,
      maxLength: s,
      disabled: u || l,
      "aria-label": a,
      placeholder: t,
      onChange: (y) => m(y.target.value),
      onKeyDown: (y) => {
        y.key !== "Enter" || y.nativeEvent.isComposing || (y.preventDefault(), p());
      }
    }
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: fa.run,
      disabled: u || l || !i.trim(),
      onClick: () => void p(),
      title: o
    },
    u ? r : a
  ));
}
class uo {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function Wa(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function Fa(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function mo(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function ai(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function fo(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function ri(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => fo(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function oi(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function si(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = o.length;
    for (; m < u; ) {
      const d = m + u >> 1;
      r[o[d]] < c ? m = d + 1 : u = d;
    }
    m > 0 && (s[i] = o[m - 1]), o[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const li = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', ci = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function ii(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function ui(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = ii(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(li)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function lr(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return ai(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function mi(e) {
  if (e.matches(ci) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function di() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function fi(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const po = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function pi(e, t, a) {
  if (po(t, a)) return;
  const r = si(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function _i(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? lr(c.rows[0], a) : null }));
    return l.sort((c, i) => fo(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = mi(l);
    return { level: c, value: c === null ? null : lr(l, a) };
  });
  return ri(s, r).map((l) => o[l]);
}
function yi(e, t, a) {
  const r = fi(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && po(o, a.shown)) return;
  a.base = a.sig ? oi(a.base, o) : o;
  let l = t ? _i(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  pi(r.parent, l, o), a.shown = l, a.sig = s;
}
const hi = "input, select, textarea, button";
function Ei(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const o = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), s = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    o !== "" && !r.querySelector(hi) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: o, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || s) && (r.getAttribute("title") !== o && r.setAttribute("title", o), r.dataset.axeTitle !== o && (r.dataset.axeTitle = o))) : s && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const bi = 7.09, gi = 3.88, vi = 4.46, ki = 16, wi = 2;
function Ni(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * bi + r * gi + (t.negative ? vi : 0) + ki + wi;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function $w(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : Ni(a, { ...t, negative: r });
}
function $i(e) {
  return /^[-−+▲△(]?\s*[$₩€]?\s*\d[\d,]*(\.\d+)?\s*(%|원)?\)?$/.test(String(e != null ? e : "").trim());
}
function xw(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const _o = na(null), xi = "_card_1j6er_2", Ai = "_grow_1j6er_24", Di = "_head_1j6er_26", Si = "_title_1j6er_35", Ci = "_trailing_1j6er_36", Mi = "_scroll_1j6er_6", Ti = "_foot_1j6er_54", Bi = "_strip_1j6er_56", qi = "_pager_1j6er_58", Li = "_spacer_1j6er_60", ji = "_table_1j6er_62", Ii = "_fixed_1j6er_63", Ri = "_fz_1j6er_81", Pi = "_fzEdge_1j6er_93", Xi = "_frozen_1j6er_100", Oi = "_sr_1j6er_162", zi = "_statusCell_1j6er_43", Hi = "_status_1j6er_43", Wi = "_st_error_1j6er_244", Fi = "_stIcon_1j6er_245", Ki = "_spin_1j6er_251", Vi = "_axeSpin_1j6er_1", Ui = "_busy_1j6er_261", Gi = "_statusRow_1j6er_263", Yi = "_busyBar_1j6er_264", Qi = "_axeBusy_1j6er_1", ce = {
  card: xi,
  grow: Ai,
  head: Di,
  title: Si,
  trailing: Ci,
  scroll: Mi,
  foot: Ti,
  strip: Bi,
  pager: qi,
  spacer: Li,
  table: ji,
  fixed: Ii,
  fz: Ri,
  fzEdge: Pi,
  frozen: Xi,
  sr: Oi,
  statusCell: zi,
  status: Hi,
  st_error: Wi,
  stIcon: Fi,
  spin: Ki,
  axeSpin: Vi,
  busy: Ui,
  statusRow: Gi,
  busyBar: Yi,
  axeBusy: Qi
}, Ji = 120;
function Zi(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Ji : void 0;
}
function cr({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const tn = /* @__PURE__ */ new Set();
function Ka() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function eu(e) {
  if (!Ka() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var o;
    return (o = r.textContent) == null ? void 0 : o.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  tn.has(a) || (tn.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function tu(...e) {
  if (!Ka()) return;
  const t = [];
  for (const r of e)
    r == null || r.querySelectorAll("td").forEach((o) => {
      var l, c;
      if (o.scrollWidth <= o.clientWidth + 1) return;
      const s = (c = (l = o.textContent) == null ? void 0 : l.trim()) != null ? c : "";
      (o.classList.contains("axe-money") || $i(s)) && t.push(s);
    });
  if (!t.length) return;
  const a = t.slice(0, 5).join("|");
  tn.has(a) || (tn.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function nu(e) {
  if (!Ka() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (tn.has(t)) return;
  tn.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function ir(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ce.fz, i), l.classList.toggle(ce.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + c; m += 1) r.set(m, l.rowSpan);
      s += c;
    }
  }
}
function Sa({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: d = !0,
  sort: _,
  onSort: p,
  manualSort: y,
  className: f = "",
  children: b
}) {
  const g = l || e !== void 0 && e.length > 0, N = g ? Zi(e) : void 0, { stick: E, offsets: $ } = _e(() => {
    const X = Math.max(Math.trunc(c), 0), F = [];
    if (X === 0 || !e) return { stick: 0, offsets: F };
    let Z = 0, W = 0;
    for (let V = 0; V < X; V += 1) {
      const ie = e[V];
      if (typeof ie != "number") break;
      F.push(Z), Z += ie, W += 1;
    }
    return { stick: W, offsets: F };
  }, [e, c]), k = [ce.table, g ? ce.fixed : "", E > 0 ? ce.frozen : ""].filter(Boolean).join(" "), w = j(null), v = j(null), A = j(null), C = j(null), M = j(0), B = j(0), I = _e(() => ({
    scrollRef: w,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (B.current += 1, () => {
      B.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [T, z] = D(null), G = _ !== void 0 ? _ : T, [K, R] = D(""), ne = j(di()), te = () => {
    const X = w.current, F = A.current, Z = C.current;
    if (!X || !F || !Z) return;
    const W = X.scrollWidth;
    Z.style.width = W + "px", F.style.display = W > X.clientWidth + 1 ? "" : "none";
    const V = X.offsetWidth - X.clientWidth;
    F.style.paddingRight = V + "px", v.current && (v.current.style.paddingRight = V + "px"), tu(X, v.current), nu(Ei(X.querySelector("table")));
  };
  U(() => {
    const X = w.current;
    if (!X) return;
    const F = new uo(X, te);
    return eu(X.querySelector("table")), () => F.detach();
  }, []), ge(() => {
    var X, F, Z, W, V;
    (E > 0 || M.current > 0) && (ir((F = (X = w.current) == null ? void 0 : X.querySelector("table")) != null ? F : null, E, $), ir((W = (Z = v.current) == null ? void 0 : Z.querySelector("table")) != null ? W : null, E, $)), M.current = E, (V = w.current) == null || V.querySelectorAll("thead th:not([scope])").forEach((ie) => ie.setAttribute("scope", "col")), h(), te();
  });
  function h() {
    var W;
    const X = (W = w.current) == null ? void 0 : W.querySelector("table");
    if (!X) return;
    const F = d ? ui(X) : [];
    X.querySelectorAll("thead th[data-axe-sort]").forEach((V) => {
      F.some((ie) => ie.th === V) || (V.removeAttribute("data-axe-sort"), V.removeAttribute("aria-sort"), V.removeAttribute("tabindex"));
    }), F.forEach(({ th: V, key: ie }) => {
      V.dataset.axeSort !== ie && (V.dataset.axeSort = ie);
      const Oe = Fa(G, ie);
      V.getAttribute("aria-sort") !== Oe && V.setAttribute("aria-sort", Oe), V.hasAttribute("tabindex") || V.setAttribute("tabindex", "0");
    });
    const Z = G && F.find((V) => V.key === G.key);
    yi(X, G && Z && !y && B.current === 0 ? { col: Z.col, dir: G.dir } : null, ne.current);
  }
  const S = (X) => {
    var V;
    const F = X.dataset.axeSort;
    if (F === void 0) return;
    const Z = Wa(G, F), W = ((V = X.textContent) != null ? V : "").replace(/\s+/g, " ").trim();
    R(mo(Z, () => W)), _ === void 0 && z(Z), p == null || p(Z);
  }, P = (X) => {
    var W, V;
    const F = X, Z = (W = F.closest) == null ? void 0 : W.call(F, "thead th[data-axe-sort]");
    return !Z || !((V = w.current) != null && V.contains(Z)) || F !== Z && F.closest('input, select, textarea, button, a[href], [role="button"]') ? null : Z;
  }, H = (X) => {
    const F = P(X.target);
    F && S(F);
  }, J = (X) => {
    if (X.key !== "Enter" && X.key !== " ") return;
    const F = P(X.target);
    !F || X.target !== F || (X.preventDefault(), S(F));
  }, q = (X) => {
    const F = X.target.scrollLeft;
    w.current && (w.current.scrollLeft = F), v.current && (v.current.scrollLeft = F);
  }, Q = (X) => {
    const F = X.target.scrollLeft;
    v.current && (v.current.scrollLeft = F), A.current && (A.current.scrollLeft = F);
  };
  return (
    // data-axe-grid — 본문·합계 표를 한 그리드로 묶는 표식(CSV 의 열째 빼기 `data-csv-skip-col` 이 두 표에 함께 걸린다)
    /* @__PURE__ */ n.createElement("div", { className: [ce.card, s ? ce.grow : "", i ? ce.busy : "", f].filter(Boolean).join(" "), "data-axe-grid": "" }, i && /* @__PURE__ */ n.createElement("div", { className: ce.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ce.head }, /* @__PURE__ */ n.createElement("span", { className: ce.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ce.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ce.scroll, ref: w, onScroll: Q }, /* @__PURE__ */ n.createElement(
      "table",
      {
        className: k,
        role: m && m !== "table" ? m : void 0,
        "aria-busy": i || void 0,
        "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
        style: N ? { minWidth: N } : void 0,
        onClick: d ? H : void 0,
        onKeyDown: d ? J : void 0
      },
      /* @__PURE__ */ n.createElement(cr, { cols: e }),
      /* @__PURE__ */ n.createElement(_o.Provider, { value: I }, b)
    )), t && /* @__PURE__ */ n.createElement("div", { className: ce.foot, ref: v }, /* @__PURE__ */ n.createElement("table", { className: k, style: N ? { minWidth: N } : void 0 }, /* @__PURE__ */ n.createElement(cr, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ce.strip, ref: A, onScroll: q }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ce.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ce.pager }, a), d && /* @__PURE__ */ n.createElement("span", { className: ce.sr, role: "status", "aria-live": "polite" }, K))
  );
}
const au = 600;
function ur(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : au, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function ru(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function ou(e, t) {
  return e.start === t.start && e.end === t.end;
}
const mr = /* @__PURE__ */ new Set();
function dr({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function Aw({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var k;
  const i = ta(_o), m = j(null), [u, d] = D(() => ur({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), _ = e.length, [p, y] = D(null), f = p && p.of === t ? p.px : t;
  ge(() => i ? i.registerVirtual() : void 0, [i]), ge(() => {
    var v;
    const w = (v = m.current) == null ? void 0 : v.closest("table");
    if (w)
      return w.setAttribute("aria-rowcount", String(_ + l)), () => w.removeAttribute("aria-rowcount");
  }, [_, l]), U(() => {
    const w = i == null ? void 0 : i.scrollRef.current, v = m.current;
    if (!w || !v) return;
    const A = () => {
      const M = v.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop, B = ur({ count: _, rowHeight: f, scrollTop: w.scrollTop, viewport: w.clientHeight, bodyTop: M, overscan: o });
      d((I) => ou(I, B) ? I : B);
    };
    A(), w.addEventListener("scroll", A, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(A) : null;
    return C ? C.observe(w) : window.addEventListener("resize", A), () => {
      w.removeEventListener("scroll", A), C ? C.disconnect() : window.removeEventListener("resize", A);
    };
  }, [i, _, f, o]), ge(() => {
    var A, C, M;
    const w = (A = m.current) == null ? void 0 : A.querySelector("tr:not([data-virtual-spacer])"), v = (C = w == null ? void 0 : w.getBoundingClientRect().height) != null ? C : 0;
    !(v > 0) || Math.abs(v - f) <= 0.25 || (y({ of: t, px: v }), typeof process != "undefined" && ((M = process.env) == null ? void 0 : M.NODE_ENV) !== "production" && Math.abs(v - t) > 2 && !mr.has(t) && (mr.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(v)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [f, t, _]);
  const b = Math.min(u.end, _), g = Math.min(u.start, b), N = ru(_, f, { start: g, end: b }), E = (k = s != null ? s : i == null ? void 0 : i.colCount) != null ? k : 1, $ = [];
  for (let w = g; w < b; w += 1) {
    const v = a(e[w], w), A = r ? r(e[w], w) : w;
    $.push(kn(v) ? za(v, { key: A, "aria-rowindex": w + 1 + l }) : v);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(dr, { height: N.top, colSpan: E }), $, /* @__PURE__ */ n.createElement(dr, { height: N.bottom, colSpan: E }));
}
const Ct = 12, su = 1.06, lu = 16, cu = 4;
function iu(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? Ct : e === " " ? Ct * 0.3 : /[0-9]/.test(e) ? Ct * 0.56 : /[A-Z]/.test(e) ? Ct * 0.68 : /[a-z]/.test(e) ? Ct * 0.56 : /[.,:;'|!]/.test(e) ? Ct * 0.3 : Ct * 0.6;
}
function uu(e, t = !1) {
  let a = 0;
  for (const r of e) a += iu(r);
  return t ? a * su : a;
}
function Dw(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = uu(i, t.bold);
    m > a && (a = m);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + lu + ((l = t.extra) != null ? l : 0) + cu);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function Vn({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = os(),
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let d;
  if (i) d = "error";
  else if (t && m) d = "loading";
  else if (r == null) {
    if (s === null) return null;
    d = "idle";
  } else if (r === 0) d = "empty";
  else return null;
  const _ = /* @__PURE__ */ n.createElement(n.Fragment, null, d === "loading" && /* @__PURE__ */ n.createElement("span", { className: ce.spin, "aria-hidden": "true" }), d === "error" && /* @__PURE__ */ n.createElement("span", { className: ce.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, d === "error" ? u : d === "loading" ? l : d === "idle" ? s : o)), p = /* @__PURE__ */ n.createElement("div", { className: [ce.status, ce[`st_${d}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": d }, p) : /* @__PURE__ */ n.createElement("tr", { className: [ce.statusRow, c].filter(Boolean).join(" "), "data-state": d }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ce.statusCell }, p));
}
function Sw({ colSpan: e, text: t, className: a }) {
  return /* @__PURE__ */ n.createElement(Vn, { colSpan: e, count: 0, empty: t, className: a });
}
function mu(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const du = "_cell_n9rrj_1", fu = "_toggle_n9rrj_2", pu = "_spacer_n9rrj_8", _u = "_label_n9rrj_9", yu = "_dim_n9rrj_10", sn = {
  cell: du,
  toggle: fu,
  spacer: pu,
  label: _u,
  dim: yu
};
function Cw(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = D(() => /* @__PURE__ */ new Set()), [l, c] = D(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = _e(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), f = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const g = a(b), N = g == null || !f.has(String(g)) ? null : String(g);
      p.set(String(t(b)), N), N && y.add(N);
    }
    return { parents: p, kids: y };
  }, [e, t, a]), u = oe((p) => r ? !o.has(p) : l.has(p), [r, o, l]), d = _e(() => e.filter((p) => {
    var b, g;
    let y = (b = i.get(String(t(p)))) != null ? b : null;
    const f = /* @__PURE__ */ new Set();
    for (; y && !f.has(y); ) {
      if (!u(y)) return !1;
      f.add(y), y = (g = i.get(y)) != null ? g : null;
    }
    return !0;
  }), [e, i, t, u]), _ = oe((p, y) => {
    const f = (b, g) => {
      const N = new Set(b);
      return g ? N.add(p) : N.delete(p), N;
    };
    r ? s((b) => f(b, !y)) : c((b) => f(b, y));
  }, [r]);
  return {
    visible: d,
    hasChildren: (p) => m.has(String(t(p))),
    isOpen: (p) => u(String(t(p))),
    toggle: (p) => {
      const y = String(t(p));
      _(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        s(p), c(y);
      };
    },
    reveal: (p) => {
      var b, g;
      let y = (b = i.get(String(p))) != null ? b : null;
      const f = /* @__PURE__ */ new Set();
      for (; y && !f.has(y); )
        _(y, !0), f.add(y), y = (g = i.get(y)) != null ? g : null;
    }
  };
}
function Mw({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const m = (d) => {
    d.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [sn.cell, o ? sn.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: sn.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: sn.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: sn.label, title: u }, i)
  );
}
function hu(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: Eu(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function Eu(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function Tw(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = j(null), [s, l] = D(null);
  U(() => {
    e.current !== s && l(e.current);
  }), U(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((f) => f.matches(r)) || y[0]), y.forEach((f) => {
        const b = f === o.current ? "0" : "-1";
        f.getAttribute("tabindex") !== b && f.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), f = [], b = [], g = /* @__PURE__ */ new Map(), N = [];
      return y.forEach((E) => {
        var M;
        const $ = E.tagName === "TR", k = $ ? null : E.closest("td, th"), w = k && s.contains(k) ? k.parentElement : null, v = $ ? E : (M = w != null ? w : E.parentElement) != null ? M : s;
        let A = f.indexOf(v);
        A < 0 && (A = f.length, f.push(v), b.push([]), N.push([]));
        let C;
        if ($)
          C = 0;
        else if (k && w) {
          C = 0;
          for (const B of Array.from(w.cells)) {
            if (B === k) break;
            C += Math.max(1, B.colSpan || 1);
          }
        } else
          C = b[A].length;
        g.set(E, { r: A, i: b[A].length }), b[A].push(C), N[A].push(E);
      }), { rows: b, where: g, byPos: N };
    }, d = (y) => {
      var w;
      const f = y.target;
      if (!f || !f.matches(a) || !s.contains(f) || y.altKey || y.metaKey || f.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: g, byPos: N } = u(), E = g.get(f);
      if (!E) return;
      const $ = hu(b, E, y.key, y.ctrlKey);
      if ($ === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const k = (w = N[$.r]) == null ? void 0 : w[$.i];
      k && (o.current = k, m(), k.focus());
    }, _ = (y) => {
      const f = y.target;
      !f || !f.matches(a) || f === o.current || (o.current = f, m());
    };
    m(), s.addEventListener("keydown", d), s.addEventListener("focusin", _);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return p == null || p.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", d), s.removeEventListener("focusin", _), p == null || p.disconnect();
    };
  }, [s, a, r]);
}
const bu = "_btn_1rzx6_1", gu = "_mark_1rzx6_7", vu = "_sr_1rzx6_9", Nn = {
  btn: bu,
  mark: gu,
  sr: vu
};
function Bw({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = Fa(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Nn.btn, onClick: () => a(Wa(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Nn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function qw({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Nn.sr, role: "status", "aria-live": "polite" }, mo(e, t));
}
function Lw({ sortKey: e, sort: t, onSort: a, children: r, ariaLabel: o, twoState: s = !1 }) {
  const l = Fa(t, e), c = () => s ? t && t.key === e ? { key: e, dir: t.dir === "asc" ? "desc" : "asc" } : { key: e, dir: "asc" } : Wa(t, e);
  return /* @__PURE__ */ n.createElement("button", { type: "button", className: Nn.btn, "aria-label": o, "data-on": l !== "none" ? "true" : void 0, onClick: () => a(c()) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Nn.mark, "aria-hidden": "true" }, l === "ascending" ? "▲" : l === "descending" ? "▼" : "↕"));
}
const ku = "_card_14vt3_1", wu = "_accent_14vt3_8", Nu = "_grow_14vt3_9", $u = "_head_14vt3_11", xu = "_body_14vt3_20", Au = "_title_14vt3_28", Du = "_trailing_14vt3_29", Su = "_summary_14vt3_32", Cu = "_sumHead_14vt3_33", Mu = "_sumTotal_14vt3_42", Tu = "_tone_warn_14vt3_43", Bu = "_tone_ok_14vt3_44", qu = "_sumList_14vt3_46", Lu = "_sumEm_14vt3_55", ju = "_sumFoot_14vt3_57", Iu = "_sumNote_14vt3_66", $e = {
  card: ku,
  accent: wu,
  grow: Nu,
  head: $u,
  body: xu,
  title: Au,
  trailing: Du,
  summary: Su,
  sumHead: Cu,
  sumTotal: Mu,
  tone_warn: Tu,
  tone_ok: Bu,
  sumList: qu,
  sumEm: Lu,
  sumFoot: ju,
  sumNote: Iu
};
function Va({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", r ? $e.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: $e.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function jw({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: $e.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: $e.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? $e.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: $e.sumNote }, s));
}
const Ru = "_sr_1y2mv_2", Pu = "_skip_1y2mv_8", Xu = "_crit_1y2mv_16", Ou = "_c_danger_1y2mv_21", zu = "_c_warn_1y2mv_22", Hu = "_critI_1y2mv_23", Wu = "_critBody_1y2mv_24", Fu = "_critX_1y2mv_25", Ku = "_ch_1y2mv_32", Vu = "_chBtn_1y2mv_33", Uu = "_chBox_1y2mv_43", et = {
  sr: Ru,
  skip: Pu,
  crit: Xu,
  c_danger: Ou,
  c_warn: zu,
  critI: Hu,
  critBody: Wu,
  critX: Fu,
  ch: Ku,
  chBtn: Vu,
  chBox: Uu
};
function yo({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: et.sr, id: a }, t);
}
function Iw({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [et.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function Rw({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [et.crit, et[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: et.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: et.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: et.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function Pw({ label: e, children: t, className: a = "" }) {
  const [r, o] = D(!1), s = Ht("axe-ch"), l = j(null), c = j(null);
  return U(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && o(!1);
    }, m = (u) => {
      var d;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), o(!1), (d = c.current) == null || d.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [et.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: et.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: et.chBox }, t));
}
function Ca(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function Gu(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Ca(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Yu(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const Qu = "_root_g2b1p_1", Ju = "_rootNone_g2b1p_5", Zu = "_field_g2b1p_12", em = "_codeInput_g2b1p_13", tm = "_nameHint_g2b1p_16", nm = "_pickBtn_g2b1p_25", am = "_suggest_g2b1p_42", rm = "_suggestList_g2b1p_48", om = "_suggestRow_g2b1p_49", sm = "_suggestOn_g2b1p_50", lm = "_suggestEmpty_g2b1p_55", cm = "_suggestMore_g2b1p_55", im = "_popup_g2b1p_59", um = "_popupHead_g2b1p_73", mm = "_searchRow_g2b1p_83", dm = "_list_g2b1p_87", fm = "_current_g2b1p_96", pm = "_empty_g2b1p_100", _m = "_summaryBtn_g2b1p_108", ym = "_ov_g2b1p_129", hm = "_modal_g2b1p_140", Em = "_modalWide_g2b1p_140", bm = "_head_g2b1p_152", gm = "_sub_g2b1p_160", vm = "_x_g2b1p_162", km = "_body_g2b1p_179", wm = "_chips_g2b1p_187", Nm = "_chip_g2b1p_187", $m = "_chipOn_g2b1p_201", xm = "_search_g2b1p_83", Am = "_tbl_g2b1p_220", Dm = "_row_g2b1p_250", Sm = "_rowCursor_g2b1p_252", Cm = "_rowPicked_g2b1p_253", Mm = "_rowCurrent_g2b1p_254", Tm = "_curTag_g2b1p_255", Bm = "_busy_g2b1p_256", qm = "_count_g2b1p_257", Lm = "_chk_g2b1p_259", jm = "_tdLeft_g2b1p_260", Im = "_tdCenter_g2b1p_261", Rm = "_emptyCell_g2b1p_263", Pm = "_stop_g2b1p_265", Xm = "_more_g2b1p_276", Om = "_pager_g2b1p_288", zm = "_note_g2b1p_301", Hm = "_foot_g2b1p_304", Wm = "_ghost_g2b1p_313", Fm = "_primary_g2b1p_325", Y = {
  root: Qu,
  rootNone: Ju,
  field: Zu,
  codeInput: em,
  nameHint: tm,
  pickBtn: nm,
  suggest: am,
  suggestList: rm,
  suggestRow: om,
  suggestOn: sm,
  suggestEmpty: lm,
  suggestMore: cm,
  popup: im,
  popupHead: um,
  searchRow: mm,
  list: dm,
  current: fm,
  empty: pm,
  summaryBtn: _m,
  ov: ym,
  modal: hm,
  modalWide: Em,
  head: bm,
  sub: gm,
  x: vm,
  body: km,
  chips: wm,
  chip: Nm,
  chipOn: $m,
  search: xm,
  tbl: Am,
  row: Dm,
  rowCursor: Sm,
  rowPicked: Cm,
  rowCurrent: Mm,
  curTag: Tm,
  busy: Bm,
  count: qm,
  chk: Lm,
  tdLeft: jm,
  tdCenter: Im,
  emptyCell: Rm,
  stop: Pm,
  more: Xm,
  pager: Om,
  note: zm,
  foot: Hm,
  ghost: Wm,
  primary: Fm
};
function Km({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, m] = D(""), u = _e(() => {
    const d = i.trim().toLowerCase();
    return d ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(d) || _.name.toLowerCase().includes(d) || ((p = _.sub) != null ? p : "").toLowerCase().includes(d);
      }
    ) : e;
  }, [e, i]);
  return U(() => {
    const d = (p) => {
      const y = p.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, _ = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", _);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: Y.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: Y.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: Y.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (d) => m(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && u.length && l(u[0]), d.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: Y.list }, u.map((d) => /* @__PURE__ */ n.createElement("li", { key: d.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(d), className: d.code === t ? Y.current : "" }, /* @__PURE__ */ n.createElement("code", null, d.code), /* @__PURE__ */ n.createElement("span", null, d.name), d.sub && /* @__PURE__ */ n.createElement("small", null, d.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: Y.empty }, "검색 결과가 없습니다"))
  ));
}
const ho = 250, jn = 7;
function fr(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Vm(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Um({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var J;
  const m = _e(() => Vm(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [d, _] = D(""), [p, y] = D((J = e == null ? void 0 : e.defaultFilter) != null ? J : null), [f, b] = D(0), [g, N] = D([]), [E, $] = D(!1), [k, w] = D(!1), [v, A] = D(null), [C, M] = D(0), [B, I] = D(/* @__PURE__ */ new Map()), T = j(u);
  T.current = u, U(() => {
    var Q;
    _(""), y((Q = T.current.defaultFilter) != null ? Q : null), b(0), M(0), A(null), I(new Map((o != null ? o : []).map((X) => [X.cd, X]))), l.current && l.current.focus();
    const q = window.setTimeout(() => {
      l.current && document.activeElement !== l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(q);
  }, [u.key]), U(() => {
    let q = !0;
    w(!0);
    const Q = () => {
      T.current.fetch({ q: d.trim(), ty: p, page: f }).then((F) => {
        var W, V;
        if (!q) return;
        w(!1), N((W = F.rows) != null ? W : []), $(!!F.hasMore), A(null);
        const Z = s ? ((V = F.rows) != null ? V : []).findIndex((ie) => ie.cd === s) : -1;
        M(Z > 0 ? Z : 0);
      }).catch(() => {
        q && (w(!1), N([]), $(!1), A("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        q && w(!1);
      });
    }, X = window.setTimeout(Q, d.trim() ? ho : 0);
    return () => {
      q = !1, window.clearTimeout(X);
    };
  }, [u.key, d, p, f]);
  const z = j(null);
  U(() => {
    const q = z.current && z.current.children[C];
    q && "scrollIntoView" in q && q.scrollIntoView({ block: "nearest" });
  }, [C, g]);
  const G = _e(() => {
    var Q, X;
    const q = [
      { key: "cd", label: "코드", width: (Q = u.codeWidth) != null ? Q : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (F) => /* @__PURE__ */ n.createElement(n.Fragment, null, F.nm, F.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: Y.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && q.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (F) => u.typeLabel ? u.typeLabel(F) : ""
    }), q.concat((X = u.extraColumns) != null ? X : []);
  }, [u]), K = oe((q) => {
    I((Q) => {
      const X = new Map(Q);
      return X.has(q.cd) ? X.delete(q.cd) : X.set(q.cd, q), X;
    });
  }, []), R = oe((q) => c([q]), [c]), ne = oe(() => c(Array.from(B.values())), [B, c]), te = g.length > 0 && g.every((q) => B.has(q.cd)), h = () => {
    I((q) => {
      const Q = new Map(q);
      return te ? g.forEach((X) => Q.delete(X.cd)) : g.forEach((X) => Q.set(X.cd, X)), Q;
    });
  }, S = j(null);
  U(() => {
    const q = document.activeElement;
    return () => {
      window.setTimeout(() => {
        q && q.isConnected && typeof q.focus == "function" && (!document.activeElement || document.activeElement === document.body) && q.focus();
      }, 0);
    };
  }, []);
  const P = j(i);
  P.current = i, U(() => {
    const q = (Q) => {
      Q.key !== "Escape" || Q.isComposing || (Q.stopPropagation(), Q.preventDefault(), P.current());
    };
    return document.addEventListener("keydown", q, !0), () => document.removeEventListener("keydown", q, !0);
  }, []);
  const H = (q) => {
    var F;
    if (q.nativeEvent.isComposing || q.keyCode === 229) return;
    if (q.key === "Tab" && S.current) {
      const Z = Array.from(S.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (Z.length) {
        const W = Z[0], V = Z[Z.length - 1], ie = document.activeElement;
        q.shiftKey && ie === W ? (q.preventDefault(), V.focus()) : !q.shiftKey && ie === V && (q.preventDefault(), W.focus());
      }
      return;
    }
    if (q.key === "Escape") {
      q.stopPropagation(), i();
      return;
    }
    const Q = q.target, X = Q === l.current;
    if (!(!X && Q !== S.current)) {
      if (q.key === "ArrowDown" || q.key === "ArrowUp") {
        q.preventDefault(), M((Z) => Math.max(0, Math.min(g.length - 1, Z + (q.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (q.key === " " && r && g[C] && !(X && ((F = l.current) != null && F.value))) {
        q.preventDefault(), K(g[C]);
        return;
      }
      if (q.key === "Enter") {
        if (q.preventDefault(), k) return;
        r ? ne() : g[C] && R(g[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement("div", { className: Y.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${Y.modal} ${Y.modalWide}` : Y.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: S,
      onClick: (q) => q.stopPropagation(),
      onKeyDown: H
    },
    /* @__PURE__ */ n.createElement("div", { className: Y.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: Y.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: Y.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: Y.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Y.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${Y.chip} ${Y.chipOn}` : Y.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((q) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: q.value,
        type: "button",
        className: p === q.value ? `${Y.chip} ${Y.chipOn}` : Y.chip,
        onClick: () => {
          y(q.value), b(0);
        }
      },
      q.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: Y.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (q) => {
          _(q.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: Y.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: Y.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: h,
        "aria-label": "표시된 행 전체 선택"
      }
    )), G.map((q) => /* @__PURE__ */ n.createElement("th", { key: q.key, style: q.width ? { width: q.width } : void 0 }, q.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: z, className: k && g.length > 0 ? Y.busy : void 0, "aria-busy": k }, g.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: Y.emptyCell, colSpan: G.length + (r ? 1 : 0) }, k ? "검색 중…" : v || u.emptyText || "검색 결과가 없습니다")) : g.map((q, Q) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: q.cd,
        className: [
          Y.row,
          Q === C ? Y.rowCursor : "",
          B.has(q.cd) ? Y.rowPicked : "",
          !r && s && q.cd === s ? Y.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Q === C,
        onClick: () => {
          M(Q), r ? K(q) : R(q);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: Y.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: B.has(q.cd),
          onChange: () => K(q),
          onClick: (X) => X.stopPropagation(),
          "aria-label": `${q.cd} 선택`
        }
      )),
      G.map((X) => {
        var F, Z;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: X.key,
            className: X.align === "left" ? Y.tdLeft : Y.tdCenter,
            title: X.render ? void 0 : String((F = q[X.key]) != null ? F : "")
          },
          X.render ? X.render(q) : String((Z = q[X.key]) != null ? Z : ""),
          X.key === "cd" && !r && s && q.cd === s && /* @__PURE__ */ n.createElement("em", { className: Y.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: Y.count, role: "status", "aria-live": "polite" }, k ? "검색 중…" : v ? "" : `${g.length}건`, !r && !k && !v && g.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (E || f > 0) && /* @__PURE__ */ n.createElement("div", { className: Y.more }, /* @__PURE__ */ n.createElement("span", null, E ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: Y.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: f === 0, onClick: () => b((q) => Math.max(0, q - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, f + 1), E && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((q) => q + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: Y.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, B.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: Y.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Y.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: Y.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Y.primary, onClick: ne }, "확인"))
  )));
}
let Gm = 0;
function Ym({ source: e, items: t, anchorRef: a }) {
  const [r, o] = D(null), [s, l] = D(-1), [c, i] = D(null), m = j(null), u = j(0), d = j(`axe-cp-${++Gm}`), _ = j(e);
  _.current = e;
  const p = j(t);
  p.current = t;
  const y = oe(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, o(null), l(-1);
  }, []);
  U(() => y, [y]);
  const f = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const g = u.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var $;
      let N = [], E = !1;
      try {
        const k = _.current;
        if (k) {
          const w = await k.fetch({ q: b, ty: null, page: 0 });
          N = w.rows, E = !!w.hasMore || N.length > jn;
        } else {
          const w = b.trim().toLowerCase();
          N = (($ = p.current) != null ? $ : []).filter((v) => {
            var A;
            return v.code.toLowerCase().includes(w) || v.name.toLowerCase().includes(w) || ((A = v.sub) != null ? A : "").toLowerCase().includes(w);
          }).map((v) => ({ cd: v.code, nm: v.name, sub: v.sub })), E = N.length > jn;
        }
      } catch {
        return;
      }
      g === u.current && (o({ rows: N.slice(0, jn), more: E, q: b }), l(-1));
    }, ho);
  };
  return U(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const g = a.current;
      if (!g) return;
      const N = g.getBoundingClientRect(), E = Math.min(r.rows.length, jn) * 28 + 34, $ = N.bottom + E > window.innerHeight - 8 && N.top - E - 2 > 8 ? N.top - E - 2 : N.bottom + 2, k = Math.max(N.width, 260);
      i({ left: Math.max(8, Math.min(N.left, window.innerWidth - k - 8)), top: $, width: k });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: d, runSuggest: f, cancelSuggest: y };
}
function Xw({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: d = "전체",
  open: _,
  onOpenChange: p,
  placeholder: y,
  title: f = "코드 선택",
  variant: b,
  disabled: g,
  className: N = "",
  maxLength: E,
  numeric: $ = !1,
  ariaLabel: k,
  autoFocus: w,
  onEnter: v,
  openOnEmptyEnter: A,
  onEscape: C,
  onBlur: M,
  invalid: B,
  selectOnFocus: I = !1
}) {
  const T = s ? "source" : "static", z = k != null ? k : (s == null ? void 0 : s.title) || (typeof f == "string" && f !== "코드 선택" ? f : "") || "코드", G = b != null ? b : T === "source" ? "modal" : "anchor", K = u != null ? u : l ? "summary" : "input", [R, ne] = D(!1), te = _ != null ? _ : R, h = oe(
    (x) => {
      _ === void 0 && ne(x), p && p(x);
    },
    [_, p]
  ), S = j(null), P = j(!1), H = j(null), J = j(null), [q, Q] = D(null), X = () => {
    if (!g) {
      if (G === "anchor") {
        const x = S.current;
        if (!x) return;
        const O = x.getBoundingClientRect(), ee = 320, se = O.bottom + ee > window.innerHeight ? Math.max(8, O.top - ee - 4) : O.bottom + 4;
        Q({ left: Math.min(O.left, window.innerWidth - 320), top: se });
      }
      h(!0);
    }
  }, F = oe(() => h(!1), [h]), [Z, W] = D(!1), [V, ie] = D(null), Oe = j(null);
  (!Oe.current || Oe.current.name !== t) && (Oe.current = { name: t, code: e });
  const xe = Yu(e, Oe.current, V, o), Ke = Ca(e, xe, a), _t = Ca(e, xe), Ft = Z && xe && a !== "code" ? xe : "", At = (x) => {
    !l && x[0] && ie({ code: x[0].cd, name: x[0].nm }), i ? i(x) : x[0] && r && r(x[0].cd, { code: x[0].cd, name: x[0].nm });
  }, { sugg: ye, active: rt, setActive: Qe, suggPos: Kt, suggId: yt, runSuggest: Vt, cancelSuggest: Dt } = Ym({ source: s, items: o, anchorRef: S }), Tn = (x) => {
    Dt(), At([x]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: S, className: [K === "none" ? Y.rootNone : Y.root, N].filter(Boolean).join(" ") }, K === "input" && /* @__PURE__ */ n.createElement("span", { className: Y.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: Y.codeInput,
      style: { paddingRight: Ft ? "calc(24px + 45%)" : 24 },
      value: Z ? e : Ke,
      placeholder: y,
      disabled: g,
      maxLength: E,
      inputMode: $ ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": z,
      "aria-invalid": B ? !0 : void 0,
      onChange: (x) => {
        const O = x.target.value.trim(), ee = $ ? O.replace(/[^0-9]/g, "") : O, se = E ? ee.slice(0, E) : ee;
        r && r(se), !g && (s || o) && Vt(se);
      },
      onKeyDown: (x) => {
        if (x.key === "F2") {
          x.preventDefault(), Dt(), X();
          return;
        }
        if (!ye) {
          if (x.key === "Enter" && A && !e.trim() && !x.nativeEvent.isComposing) {
            x.preventDefault(), X();
            return;
          }
          x.key === "Enter" && v && !x.nativeEvent.isComposing ? (x.preventDefault(), v()) : x.key === "Escape" && C && (x.preventDefault(), C());
          return;
        }
        const O = ye.rows.length;
        x.key === "ArrowDown" && O ? (x.preventDefault(), Qe((ee) => (ee + 1) % O)) : x.key === "ArrowUp" && O ? (x.preventDefault(), Qe((ee) => (ee <= 0 ? O : ee) - 1)) : x.key === "Enter" && rt >= 0 && ye.rows[rt] ? (x.preventDefault(), Tn(ye.rows[rt])) : x.key === "Enter" && v && !x.nativeEvent.isComposing ? (x.preventDefault(), Dt(), v()) : x.key === "Escape" && (x.preventDefault(), x.stopPropagation(), x.nativeEvent.stopImmediatePropagation(), Dt());
      },
      onFocus: (x) => {
        if (W(!0), !I) return;
        const O = x.currentTarget;
        window.requestAnimationFrame(() => O.select());
      },
      onMouseDown: (x) => {
        I && document.activeElement !== x.currentTarget && (P.current = !0);
      },
      onMouseUp: (x) => {
        P.current && (x.preventDefault(), P.current = !1);
      },
      onBlur: () => {
        W(!1), Dt(), M && M();
      },
      title: typeof B == "string" && B ? B : _t && _t !== e ? `${_t} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!ye,
      "aria-controls": ye ? yt.current : void 0,
      "aria-activedescendant": ye && rt >= 0 ? `${yt.current}-${rt}` : void 0,
      "aria-describedby": typeof B == "string" && B ? `${yt.current}-inv` : void 0
    }
  ), Ft && /* @__PURE__ */ n.createElement("span", { className: Y.nameHint, "aria-hidden": "true" }, Ft), typeof B == "string" && B && /* @__PURE__ */ n.createElement(yo, { id: `${yt.current}-inv` }, B), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Y.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: g,
      onClick: X,
      onMouseDown: (x) => x.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(wn, { name: "search", size: 13 })
  )), K === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: Y.summaryBtn, disabled: g, onClick: X }, /* @__PURE__ */ n.createElement("span", null, Gu(c != null ? c : [], d, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(wn, { name: "search", size: 13 }))), ye && Kt && K === "input" && !te && /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: Y.suggest,
      style: { left: Kt.left, top: Kt.top, width: Kt.width },
      onMouseDown: (x) => x.preventDefault()
    },
    ye.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: Y.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: yt.current, role: "listbox", className: Y.suggestList }, ye.rows.map((x, O) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: x.cd,
        id: `${yt.current}-${O}`,
        role: "option",
        "aria-selected": O === rt,
        className: [Y.suggestRow, O === rt ? Y.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Qe(O),
        onClick: () => Tn(x)
      },
      /* @__PURE__ */ n.createElement("code", null, fr(x.cd, ye.q)),
      /* @__PURE__ */ n.createElement("span", null, fr(x.nm, ye.q)),
      x.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    ye.more && /* @__PURE__ */ n.createElement("div", { className: Y.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && T === "static" && G === "anchor" && q && /* @__PURE__ */ n.createElement(
    Km,
    {
      items: o != null ? o : [],
      value: e,
      title: f,
      popupRef: H,
      anchorRef: S,
      pos: q,
      onPick: (x) => {
        ie({ code: x.code, name: x.name }), r && r(x.code, x), F();
      },
      onClose: F
    }
  ), te && (T === "source" || G === "modal") && /* @__PURE__ */ n.createElement(
    Um,
    {
      source: s,
      items: o,
      title: f,
      multiple: l,
      selected: c,
      current: m,
      searchRef: J,
      onConfirm: (x) => {
        At(x), F();
      },
      onClose: F
    }
  ));
}
const Ua = 864e5;
function Qm(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Qm(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function Nt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / Ua);
}
function Jm(e) {
  const t = new Date(e * Ua);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function aa(e, t) {
  return Jm(Nt(e) + t);
}
function Ga(e) {
  return new Date(Nt(e) * Ua).getUTCDay();
}
const pr = "1900-01-01", _r = "2099-12-31", pa = ["일", "월", "화", "수", "목", "금", "토"], Un = (e) => String(e).padStart(2, "0");
function at(e, t, a) {
  return `${String(e).padStart(4, "0")}-${Un(t)}-${Un(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Zm(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function ln(e, t) {
  return t === "month" ? Zm(e) : de(e);
}
function qe(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${Un(e.m)}` : at(e.y, e.m, e.d);
}
function Re(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function $n(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function xt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function ed(e, t, a) {
  return e >= t && e <= a;
}
function Gt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function _a(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function yr(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function zn(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function td(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return zn(r.replace(/\D/g, ""), t, a);
}
function nd(e, t) {
  const a = { y: e, m: t, d: 1 }, r = $n(a, -Re(a));
  return Array.from({ length: 42 }, (o, s) => $n(r, s));
}
function ad(e, t) {
  const a = e.y, r = [], o = (m, u) => `${String(m).padStart(4, "0")}-${Un(u)}`, s = (m, u, d) => at(m, u, d);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const m = xt(e, -1);
    r.push({ label: "지난달", from: o(m.y, m.m), to: o(m.y, m.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: o(a, u * 3 - 2), to: o(a, u * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = at(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = $n(e, -Re(e));
  r.push({ label: "이번 주", from: qe(c, "date"), to: qe($n(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = xt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, Le(a, m * 3)) });
  return r;
}
const rd = "_wrap_uxy72_1", od = "_disabled_uxy72_18", sd = "_input_uxy72_22", ld = "_month_uxy72_36", cd = "_weekday_uxy72_39", id = "_sun_uxy72_40", ud = "_sat_uxy72_41", md = "_icon_uxy72_43", dd = "_readOnly_uxy72_57", fd = "_required_uxy72_62", pd = "_invalid_uxy72_63", _d = "_pop_uxy72_66", yd = "_calHead_uxy72_79", hd = "_calTitleStatic_uxy72_80", Ed = "_calTitle_uxy72_80", bd = "_grid_uxy72_90", gd = "_wd_uxy72_91", vd = "_day_uxy72_95", kd = "_mon_uxy72_36", wd = "_out_uxy72_104", Nd = "_sel_uxy72_105", $d = "_today_uxy72_108", xd = "_months_uxy72_111", Ad = "_foot_uxy72_114", Dd = "_clear_uxy72_127", Sd = "_range_uxy72_130", Cd = "_tilde_uxy72_131", Md = "_rangeErr_uxy72_132", re = {
  wrap: rd,
  disabled: od,
  input: sd,
  month: ld,
  weekday: cd,
  sun: id,
  sat: ud,
  icon: md,
  readOnly: dd,
  required: fd,
  invalid: pd,
  pop: _d,
  calHead: yd,
  calTitleStatic: hd,
  calTitle: Ed,
  grid: bd,
  wd: gd,
  day: vd,
  mon: kd,
  out: wd,
  sel: Nd,
  today: $d,
  months: xd,
  foot: Ad,
  clear: Dd,
  range: Sd,
  tilde: Cd,
  rangeErr: Md
}, gt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function hr({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: d,
  id: _,
  name: p,
  onBlur: y,
  "aria-label": f,
  "aria-describedby": b,
  className: g = "",
  style: N
}) {
  const E = a === "month", $ = Ht("axe-dp"), k = r || (E ? pr.slice(0, 7) : pr), w = o || (E ? _r.slice(0, 7) : _r), v = (x) => ed(x, k, w), A = !!s || !!l, [C, M] = D(e || ""), [B, I] = D(!1), [T, z] = D(!1), [G, K] = D(E ? "month" : "day"), [R, ne] = D(() => {
    var O;
    const x = (O = ln(e, a)) != null ? O : gt();
    return { y: x.y, m: x.m };
  }), [te, h] = D({ top: 0, left: 0 }), S = j(null), P = j(null), H = j(null), J = j(null);
  U(() => {
    M(e || ""), I(!1);
  }, [e]), U(() => {
    const x = ln(e, a);
    x && ne({ y: x.y, m: x.m });
  }, [e, a]), ge(() => {
    const x = P.current;
    J.current != null && x && document.activeElement === x && x.setSelectionRange(J.current, J.current), J.current = null;
  }, [C]), ge(() => {
    if (!T) return;
    const x = () => {
      const O = S.current, ee = H.current;
      if (!O || !ee) return;
      const se = O.getBoundingClientRect(), ue = ee.offsetHeight, ve = ee.offsetWidth;
      let Ae = se.bottom + 4;
      Ae + ue > window.innerHeight - 8 && se.top - ue - 4 > 8 && (Ae = se.top - ue - 4);
      const on = Math.max(8, Math.min(se.left, window.innerWidth - ve - 8));
      h((ma) => ma.top === Ae && ma.left === on ? ma : { top: Ae, left: on });
    };
    return x(), window.addEventListener("resize", x), window.addEventListener("scroll", x, !0), () => {
      window.removeEventListener("resize", x), window.removeEventListener("scroll", x, !0);
    };
  }, [T, G, R.y, R.m]), U(() => {
    if (!T) return;
    const x = (O) => {
      var se, ue;
      const ee = O.target;
      (se = S.current) != null && se.contains(ee) || (ue = H.current) != null && ue.contains(ee) || z(!1);
    };
    return document.addEventListener("mousedown", x), () => document.removeEventListener("mousedown", x);
  }, [T]);
  const q = (x) => {
    x !== (e || "") && t(x);
  }, Q = (x) => {
    M(x), I(!1), q(x);
  }, X = () => {
    const x = Gt(C, a);
    if (!x) return;
    const O = zn(x, a, gt()), ee = O ? qe(O, a) : null;
    if (ee && v(ee)) {
      Q(ee);
      return;
    }
    u == null || u(C, ee ? "range" : "format"), M(e || ""), I(!1);
  }, F = (x, O) => {
    const ee = Gt(x.slice(0, O), a).length, se = Gt(x, a), ue = _a(se, a);
    if (J.current = yr(ue, Math.min(ee, se.length)), M(ue), !se) {
      I(!1), q("");
      return;
    }
    if (se.length === (E ? 6 : 8)) {
      const ve = zn(se, a, gt()), Ae = ve ? qe(ve, a) : null;
      Ae && v(Ae) ? (I(!1), q(Ae)) : I(!0);
    } else I(!1);
  }, Z = (x, O) => {
    var on;
    const ee = gt(), se = Gt(C, a), ue = (on = zn(se, a, ee)) != null ? on : ln(e, a);
    let ve;
    ue ? E ? ve = xt(ue, x === "year" ? 12 * O : O) : x === "day" ? ve = $n(ue, O) : ve = xt(ue, x === "month" ? O : 12 * O) : ve = ee;
    const Ae = qe(ve, a);
    v(Ae) && Q(Ae);
  }, W = (x) => {
    var O;
    Q(x), z(!1), (O = P.current) == null || O.focus();
  }, V = () => {
    var O;
    if (A) return;
    const x = (O = ln(e, a)) != null ? O : gt();
    ne({ y: x.y, m: x.m }), K(E ? "month" : "day"), z(!0);
  }, ie = (x) => {
    var ee, se;
    if (A) return;
    const O = x.currentTarget;
    switch (x.key) {
      case "Escape":
        T ? (z(!1), x.preventDefault(), x.stopPropagation(), x.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (M(e || ""), I(!1), x.preventDefault(), x.stopPropagation(), x.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => O.select()));
        break;
      case "ArrowDown":
        x.preventDefault(), x.altKey ? T ? z(!1) : V() : Z("day", 1);
        break;
      case "ArrowUp":
        x.preventDefault(), Z("day", -1);
        break;
      case "PageDown":
        x.preventDefault(), Z("month", 1);
        break;
      case "PageUp":
        x.preventDefault(), Z("month", -1);
        break;
      case "F2":
      case "F4":
        x.preventDefault(), T ? z(!1) : V();
        break;
      case "Enter":
        X(), T && z(!1);
        break;
      case "t":
      case "T":
        if (x.ctrlKey || x.metaKey || x.altKey) break;
        x.preventDefault(), Q(qe(gt(), a));
        break;
      case "Backspace": {
        const ue = (ee = O.selectionStart) != null ? ee : 0;
        if (ue === ((se = O.selectionEnd) != null ? se : 0) && ue > 0 && C[ue - 1] === "-") {
          x.preventDefault();
          const ve = Gt(C.slice(0, ue), a).length, Ae = Gt(C, a);
          F(_a(Ae.slice(0, ve - 1) + Ae.slice(ve), a), 0), J.current = yr(_a(Ae.slice(0, ve - 1) + Ae.slice(ve), a), ve - 1);
        }
        break;
      }
    }
  }, Oe = (x) => {
    if (A) return;
    x.preventDefault();
    const O = td(x.clipboardData.getData("text"), a, gt()), ee = O ? qe(O, a) : null;
    ee && v(ee) ? Q(ee) : I(!0);
  }, xe = (x) => {
    var ee, se;
    const O = x.relatedTarget;
    O && ((ee = S.current) != null && ee.contains(O) || (se = H.current) != null && se.contains(O)) || (X(), z(!1), y && y());
  }, Ke = ln(e, a), _t = gt(), Ft = B || !!i, At = m && !E && Ke ? Re(Ke) : null, ye = (x) => qe(x, a), rt = (x, O) => {
    const ee = qe({ y: x, m: O, d: 1 }, "date"), se = qe({ y: x, m: O, d: Le(x, O) }, "date"), ue = E ? k + "-01" : k, ve = E ? w + "-31" : w;
    return se >= ue && ee <= ve;
  }, Qe = (x) => {
    const O = xt({ y: R.y, m: R.m, d: 1 }, x);
    ne({ y: O.y, m: O.m });
  }, Kt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Qe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Qe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.calTitle, "aria-label": "연·월 선택", onClick: () => K("month") }, R.y, "년 ", R.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Qe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Qe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.grid }, pa.map((x, O) => /* @__PURE__ */ n.createElement("span", { key: x, className: [re.wd, O === 0 ? re.sun : "", O === 6 ? re.sat : ""].join(" ") }, x)), nd(R.y, R.m).map((x) => {
    const O = qe(x, "date"), ee = Re(x), se = [
      re.day,
      x.m !== R.m ? re.out : "",
      ee === 0 ? re.sun : "",
      ee === 6 ? re.sat : "",
      O === qe(_t, "date") ? re.today : "",
      Ke && O === qe(Ke, "date") ? re.sel : ""
    ].join(" "), ue = !v(O);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: O,
        type: "button",
        tabIndex: -1,
        className: se,
        disabled: ue,
        "aria-label": `${x.y}년 ${x.m}월 ${x.d}일 ${pa[ee]}요일`,
        "aria-pressed": !!Ke && O === qe(Ke, "date"),
        onClick: () => W(O)
      },
      x.d
    );
  }))), yt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: re.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Qe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: re.calTitleStatic }, R.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Qe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: re.months }, Array.from({ length: 12 }, (x, O) => O + 1).map((x) => {
    const O = !!Ke && Ke.y === R.y && Ke.m === x, ee = [re.mon, O ? re.sel : "", _t.y === R.y && _t.m === x ? re.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x,
        type: "button",
        tabIndex: -1,
        className: ee,
        disabled: !rt(R.y, x),
        "aria-pressed": O,
        onClick: () => {
          E ? W(ye({ y: R.y, m: x, d: 1 })) : (ne({ y: R.y, m: x }), K("day"));
        }
      },
      x,
      "월"
    );
  }))), Vt = qe(_t, a), Dt = E ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !v(Vt), onClick: () => W(Vt) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !v(Vt), onClick: () => W(Vt) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !v(ye({ y: R.y, m: R.m, d: 1 })),
      onClick: () => W(ye({ y: R.y, m: R.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !v(ye({ y: R.y, m: R.m, d: Le(R.y, R.m) })),
      onClick: () => W(ye({ y: R.y, m: R.m, d: Le(R.y, R.m) }))
    },
    "월말"
  )), Tn = [
    re.wrap,
    s ? re.disabled : "",
    l ? re.readOnly : "",
    c && !e && !C ? re.required : "",
    Ft ? re.invalid : "",
    E ? re.month : "",
    g
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: S, className: Tn, style: N, onBlur: xe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: P,
      id: _,
      name: p,
      className: re.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: d != null ? d : E ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": T,
      "aria-controls": $,
      "aria-label": f,
      "aria-describedby": b,
      "aria-invalid": Ft || void 0,
      "aria-required": c || void 0,
      onChange: (x) => {
        var O;
        return F(x.target.value, (O = x.target.selectionStart) != null ? O : x.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Oe
    }
  ), At != null && /* @__PURE__ */ n.createElement("span", { className: [re.weekday, At === 0 ? re.sun : "", At === 6 ? re.sat : ""].join(" "), "aria-hidden": "true" }, "(", pa[At], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: re.icon,
      disabled: A,
      "aria-label": E ? "월 선택 열기" : "달력 열기",
      onMouseDown: (x) => x.preventDefault(),
      onClick: () => {
        var x;
        (x = P.current) == null || x.focus(), T ? z(!1) : V();
      }
    },
    /* @__PURE__ */ n.createElement(wn, { name: "calendar", size: 15 })
  ), T && /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: H,
      id: $,
      className: re.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": E ? "월 선택" : "날짜 선택",
      onMouseDown: (x) => x.preventDefault()
    },
    G === "day" && !E ? Kt() : yt(),
    /* @__PURE__ */ n.createElement("div", { className: re.foot }, Dt, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: re.clear, onClick: () => W("") }, "비우기"))
  )));
}
const jt = (e) => String(e).padStart(2, "0");
function Eo() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${jt(e.getMonth() + 1)}-${jt(e.getDate())}`;
}
function Td(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${jt(t.getMonth() + 1)}-${jt(t.getDate())} ${jt(t.getHours())}:${jt(t.getMinutes())}:${jt(t.getSeconds())}`;
}
function Ow(e, t) {
  return !!e && !!t && e <= t;
}
function zw({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const d = !!e && !!t && e > t, _ = /* @__PURE__ */ new Date(), p = i === !1 ? [] : Array.isArray(i) ? i : ad({ y: _.getFullYear(), m: _.getMonth() + 1, d: _.getDate() }, r), y = (f) => (!o || f.from >= o) && (!s || f.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: re.range }, /* @__PURE__ */ n.createElement(
    hr,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (f) => a(f, t),
      onReject: u && ((f, b) => u(f, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: re.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    hr,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (f) => a(e, f),
      onReject: u && ((f, b) => u(f, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ n.createElement(
    ml,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: p.map((f) => ul(
        f.label,
        f.label,
        () => a(f.from, f.to),
        y(f) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), d && /* @__PURE__ */ n.createElement("span", { className: re.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const bo = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function go(e, t = bo) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Bd(e, t = {}) {
  const a = go(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function Hw(e, t) {
  const a = go(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Ce = 1440, Gn = (e) => String(e).padStart(2, "0");
function pe(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Rt(e) {
  const t = new Date(e * 6e4);
  return at(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function _n(e) {
  const t = new Date(e * 6e4);
  return `${Rt(e)}T${Gn(t.getUTCHours())}:${Gn(t.getUTCMinutes())}`;
}
function tt(e) {
  const t = (e % Ce + Ce) % Ce;
  return `${Gn(Math.floor(t / 60))}:${Gn(t % 60)}`;
}
function we(e, t) {
  return de(e) ? aa(e, t) : e;
}
function nn(e, t) {
  return Math.round((pe(t) - pe(e)) / Ce);
}
function xn(e) {
  if (!de(e)) return !1;
  const t = Ga(e);
  return t === 0 || t === 6;
}
function qd(e) {
  var o;
  const t = pe(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = Rt(t), l = e.end ? Rt(pe(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: pe(s), e: pe(c) + Ce, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? pe(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Rt(t), eDay: Rt(r - 1) };
}
function ra(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = qd(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(Ld);
}
function Ld(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = nn(t.sDay, t.eDay) - nn(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function jd(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function vo(e) {
  return e.allDay || e.e - e.s >= Ce;
}
function Yn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Re(a) - t + 7) % 7;
  return we(e, -r);
}
function oa(e, t) {
  const a = nn(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => we(e, o));
}
function ko(e, t) {
  const a = de(e), r = at(a.y, a.m, 1), o = at(a.y, a.m, Le(a.y, a.m)), s = Yn(r, t), l = we(Yn(o, t), 6), c = oa(s, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function Ya(e, t, a) {
  if (e === "month") {
    const r = ko(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: at(r.y, r.m, 1), to: at(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = Yn(t, a);
    return { from: r, to: we(r, 6) };
  }
  return { from: t, to: t };
}
function Id(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = xt(o, a);
    return at(l.y, l.m, l.d);
  }
  if (e === "week") return we(t, 7 * a);
  let s = we(t, a);
  for (; r && xn(s); ) s = we(s, a);
  return s;
}
function Rd(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = Ya("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function wo(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function Pd(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const Xd = 20;
function Od(e, t) {
  const a = pe(t), r = a + Ce, o = e.filter((m) => !vo(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of o) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Xd);
    let d = l.findIndex((_) => _ <= m.top);
    d < 0 ? (d = l.length, l.push(u)) : l[d] = u, m.col = d, s.push(m), c = Math.max(c, u);
  }
  return i(), o;
}
function Er(e, t) {
  return Math.round(e / t) * t;
}
function Ma(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Ce);
    return { start: we(e.sDay, a), end: we(e.eDay, a) };
  }
  return { start: _n(e.s + t), end: _n(e.e + t) };
}
function Qa(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = pe(e.sDay), r = tt(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Ce ? "24:00" : tt(e.e - a)}`;
  const o = de(e.sDay), s = de(Rt(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${tt(e.e - pe(Rt(e.e)))}`;
}
const De = (e) => {
  const t = de(e);
  return { ...t, w: Re(t) };
};
function br(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = Bd(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function zd(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : bo, o = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], d = (p) => br(p, a, "年", r, o), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: d,
      ym: (p) => `${d(p)}${De(p).m}月`,
      ymd: (p) => {
        const y = De(p);
        return `${d(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${De(p).d}日`,
      m: (p) => `${De(p).m}月`,
      dayTitle: (p) => {
        const y = De(p);
        return `${d(p)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => br(u, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, d) => `${u}/${d}일째`,
    openDay: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${De(u).m}월`,
    ymd: (u) => {
      const d = De(u);
      return `${l(u)} ${d.m}월 ${d.d}일`;
    },
    md: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일`;
    },
    d: (u) => `${De(u).d}일`,
    m: (u) => `${De(u).m}월`,
    dayTitle: (u) => {
      const d = De(u);
      return `${l(u)} ${d.m}월 ${d.d}일 (${s[d.w]})`;
    },
    dayAria: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일 ${s[d.w]}요일`;
    }
  };
}
const No = zd("ko"), Hd = "_cal_38qtm_2", Wd = "_toolbar_38qtm_20", Fd = "_navBtns_38qtm_28", Kd = "_title_38qtm_29", Vd = "_toolRight_38qtm_36", Ud = "_toggle_38qtm_37", Gd = "_body_38qtm_58", Yd = "_busy_38qtm_59", Qd = "_sun_38qtm_71", Jd = "_sat_38qtm_72", Zd = "_tAccent_38qtm_75", ef = "_tOk_38qtm_76", tf = "_tWarn_38qtm_77", nf = "_tDanger_38qtm_78", af = "_tViolet_38qtm_79", rf = "_tGray_38qtm_80", of = "_month_38qtm_83", sf = "_mHead_38qtm_84", lf = "_wdName_38qtm_85", cf = "_mBody_38qtm_91", uf = "_mWeek_38qtm_92", mf = "_mCells_38qtm_94", df = "_cell_38qtm_96", ff = "_out_38qtm_104", pf = "_dayNum_38qtm_105", _f = "_creatable_38qtm_106", yf = "_selDay_38qtm_109", hf = "_cellHead_38qtm_111", Ef = "_isToday_38qtm_124", bf = "_holiday_38qtm_125", gf = "_addHint_38qtm_130", vf = "_barLayer_38qtm_138", kf = "_chip_38qtm_139", wf = "_more_38qtm_139", Nf = "_tEv_38qtm_155", $f = "_aRow_38qtm_155", xf = "_popItem_38qtm_155", Af = "_bar_38qtm_138", Df = "_contL_38qtm_165", Sf = "_contR_38qtm_166", Cf = "_dotChip_38qtm_167", Mf = "_dot_38qtm_167", Tf = "_chipTime_38qtm_170", Bf = "_chipTitle_38qtm_171", qf = "_movable_38qtm_173", Lf = "_ghost_38qtm_176", jf = "_time_38qtm_189", If = "_tHead_38qtm_190", Rf = "_tAllDay_38qtm_190", Pf = "_gutter_38qtm_193", Xf = "_tHeadDays_38qtm_197", Of = "_tAllDayCells_38qtm_197", zf = "_tDay_38qtm_198", Hf = "_tDayBtn_38qtm_202", Wf = "_tWd_38qtm_206", Ff = "_tDayNum_38qtm_208", Kf = "_tAllDayRow_38qtm_216", Vf = "_allDayCell_38qtm_218", Uf = "_tBody_38qtm_222", Gf = "_tGrid_38qtm_223", Yf = "_tGutter_38qtm_224", Qf = "_tCols_38qtm_230", Jf = "_tCol_38qtm_230", Zf = "_tSel_38qtm_238", ep = "_tEvTitle_38qtm_258", tp = "_tEvTime_38qtm_259", np = "_tEvShort_38qtm_261", ap = "_contTop_38qtm_263", rp = "_contBottom_38qtm_264", op = "_resize_38qtm_265", sp = "_now_38qtm_268", lp = "_agenda_38qtm_272", cp = "_aDay_38qtm_273", ip = "_aDate_38qtm_275", up = "_aDateBtn_38qtm_276", mp = "_aDayNum_38qtm_280", dp = "_aDayWd_38qtm_286", fp = "_aList_38qtm_288", pp = "_aTime_38qtm_295", _p = "_aTitle_38qtm_296", yp = "_aSpan_38qtm_297", hp = "_aLoc_38qtm_298", Ep = "_empty_38qtm_303", bp = "_pop_38qtm_155", gp = "_popHead_38qtm_321", vp = "_popDay_38qtm_322", kp = "_popClose_38qtm_329", wp = "_popList_38qtm_334", Np = "_tAllDayOnly_38qtm_348", L = {
  cal: Hd,
  toolbar: Wd,
  navBtns: Fd,
  title: Kd,
  toolRight: Vd,
  toggle: Ud,
  body: Gd,
  busy: Yd,
  sun: Qd,
  sat: Jd,
  tAccent: Zd,
  tOk: ef,
  tWarn: tf,
  tDanger: nf,
  tViolet: af,
  tGray: rf,
  month: of,
  mHead: sf,
  wdName: lf,
  mBody: cf,
  mWeek: uf,
  mCells: mf,
  cell: df,
  out: ff,
  dayNum: pf,
  creatable: _f,
  selDay: yf,
  cellHead: hf,
  isToday: Ef,
  holiday: bf,
  addHint: gf,
  barLayer: vf,
  chip: kf,
  more: wf,
  tEv: Nf,
  aRow: $f,
  popItem: xf,
  bar: Af,
  contL: Df,
  contR: Sf,
  dotChip: Cf,
  dot: Mf,
  chipTime: Tf,
  chipTitle: Bf,
  movable: qf,
  ghost: Lf,
  time: jf,
  tHead: If,
  tAllDay: Rf,
  gutter: Pf,
  tHeadDays: Xf,
  tAllDayCells: Of,
  tDay: zf,
  tDayBtn: Hf,
  tWd: Wf,
  tDayNum: Ff,
  tAllDayRow: Kf,
  allDayCell: Vf,
  tBody: Uf,
  tGrid: Gf,
  tGutter: Yf,
  tCols: Qf,
  tCol: Jf,
  tSel: Zf,
  tEvTitle: ep,
  tEvTime: tp,
  tEvShort: np,
  contTop: ap,
  contBottom: rp,
  resize: op,
  now: sp,
  agenda: lp,
  aDay: cp,
  aDate: ip,
  aDateBtn: up,
  aDayNum: mp,
  aDayWd: dp,
  aList: fp,
  aTime: pp,
  aTitle: _p,
  aSpan: yp,
  aLoc: hp,
  empty: Ep,
  pop: bp,
  popHead: gp,
  popDay: vp,
  popClose: kp,
  popList: wp,
  tAllDayOnly: Np
}, An = 22, $p = {
  accent: L.tAccent,
  ok: L.tOk,
  warn: L.tWarn,
  danger: L.tDanger,
  violet: L.tViolet,
  gray: L.tGray
};
function sa(e) {
  var t;
  return e.color ? "" : $p[(t = e.tone) != null ? t : "accent"];
}
function la(e) {
  if (e.color)
    return { "--ev": e.color };
}
function $o(e, t) {
  return [e.ev.title, Qa(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const yn = (e, t) => !!e.onEventChange && !t.locked;
function Hn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function Qn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (u) => {
    !o && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (o = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, o);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function xo(e) {
  const [t, a] = D(null), [r, o] = D(null), s = j(!1);
  return { preview: t, items: (d, _) => ra(e.events, d, _, t), onItemDown: (d, _) => {
    var f;
    if (d.button !== 0 || !yn(e, _.ev)) return;
    const p = (f = Hn(d.clientX, d.clientY, "data-cal-day")) == null ? void 0 : f.dataset.calDay;
    if (!p) return;
    s.current = !1;
    let y = 0;
    Qn(d, {
      move: (b) => {
        var N;
        s.current = !0;
        const g = (N = Hn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : N.dataset.calDay;
        g && (y = nn(p, g), a({ id: _.ev.id, ...Ma(_, y * Ce) }));
      },
      end: (b, g) => {
        var N;
        a(null), g && y && ((N = e.onEventChange) == null || N.call(e, _.ev, Ma(_, y * Ce)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (d, _) => {
    if (d.button !== 0 || !e.onCreate) return;
    d.preventDefault();
    let p = _;
    o({ a: _, b: _ }), Qn(d, {
      move: (y) => {
        var b;
        const f = (b = Hn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        f && (p = f, o({ a: _, b: f }));
      },
      end: () => {
        var b;
        o(null);
        const [y, f] = _ <= p ? [_, p] : [p, _];
        (b = e.onCreate) == null || b.call(e, { start: y, end: f, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (d, _) => {
    var p;
    if (s.current) {
      s.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, d);
  }, inSel: (d) => !!r && d >= (r.a < r.b ? r.a : r.b) && d <= (r.a < r.b ? r.b : r.a) };
}
function Ao({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: L.barLayer }, e.map((s) => {
    var d;
    const l = s.item, c = l.ev, i = jd(l), m = tt(l.s - pe(l.sDay)), u = [
      L.chip,
      i ? L.bar : L.dotChip,
      sa(c),
      s.contL ? L.contL : "",
      s.contR ? L.contR : "",
      ((d = o.preview) == null ? void 0 : d.id) === c.id ? L.ghost : "",
      yn(r, c) ? L.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * An,
          ...la(c)
        },
        "aria-label": $o(l, r.L),
        onPointerDown: (_) => o.onItemDown(_, l),
        onClick: (_) => o.clickItem(_.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: L.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: L.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: L.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: L.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: L.chipTitle }, c.title))
    );
  }));
}
const ya = 26;
function xp({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = _e(
    () => ko(a, o).map(($) => s ? $ : $.filter((k) => !xn(k))),
    [a, o, s]
  ), m = i[0].length, u = xo(e), d = u.items(i[0][0], i[i.length - 1][m - 1]), _ = j(null), [p, y] = D(0);
  ge(() => {
    const $ = _.current;
    if (!$) return;
    const k = () => y($.clientHeight / i.length);
    if (k(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(k);
    return w.observe($), () => w.disconnect();
  }, [i.length]);
  const f = p ? Math.max(1, Math.floor((p - ya - 4) / An)) : 3, b = j(!1), g = j(null);
  U(() => {
    var $, k;
    b.current && (b.current = !1, (k = ($ = g.current) == null ? void 0 : $.querySelector(`[data-cal-day="${a}"]`)) == null || k.focus());
  }, [a, c]);
  const N = ($, k) => {
    let w = we($, k);
    for (; !s && xn(w); ) w = we(w, k > 0 ? 1 : -1);
    return w;
  }, E = ($, k, w) => {
    let v = null;
    if ($.key === "ArrowLeft") v = N(k, -1);
    else if ($.key === "ArrowRight") v = N(k, 1);
    else if ($.key === "ArrowUp") v = N(k, -7);
    else if ($.key === "ArrowDown") v = N(k, 7);
    else if ($.key === "Home") v = w[0];
    else if ($.key === "End") v = w[w.length - 1];
    else if ($.key === "Enter" || $.key === " ") {
      $.preventDefault(), e.goto("day", k);
      return;
    }
    v && ($.preventDefault(), b.current = !0, e.setCursor(v));
  };
  return /* @__PURE__ */ n.createElement("div", { className: L.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: g }, /* @__PURE__ */ n.createElement("div", { className: L.mHead, role: "row" }, i[0].map(($) => {
    const k = Re(de($));
    return /* @__PURE__ */ n.createElement("div", { key: $, role: "columnheader", className: [L.wdName, k === 0 ? L.sun : "", k === 6 ? L.sat : ""].join(" ") }, t.weekdays[k]);
  })), /* @__PURE__ */ n.createElement("div", { className: L.mBody, ref: _ }, i.map(($) => {
    const { shown: k, more: w } = Pd(wo(d, $), m, f);
    return /* @__PURE__ */ n.createElement("div", { key: $[0], className: L.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: L.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, $.map((v) => {
      const A = de(v), C = Re(A), M = l[v], B = d.filter((T) => T.sDay <= v && T.eDay >= v).length, I = [
        L.cell,
        v.slice(0, 7) !== c ? L.out : "",
        C === 0 || M ? L.sun : C === 6 ? L.sat : "",
        v === r ? L.isToday : "",
        u.inSel(v) ? L.selDay : "",
        e.onCreate ? L.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: v,
          role: "gridcell",
          "data-cal-day": v,
          tabIndex: v === a ? 0 : -1,
          "aria-selected": v === a,
          "aria-current": v === r ? "date" : void 0,
          "aria-label": `${t.dayAria(v)}${M ? ` ${M}` : ""}, ${t.eventCount(B)}`,
          className: I,
          onPointerDown: (T) => u.onCellDown(T, v),
          onKeyDown: (T) => E(T, v, $)
        },
        /* @__PURE__ */ n.createElement("div", { className: L.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: L.dayNum,
            "aria-label": t.openDay(v),
            onPointerDown: (T) => T.stopPropagation(),
            onClick: () => e.goto("day", v)
          },
          A.d === 1 ? t.md(v) : A.d
        ), M && /* @__PURE__ */ n.createElement("span", { className: L.holiday, title: M }, M), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: L.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Ao, { segs: k, cols: m, top: ya, ctx: e, drag: u }), w.map((v, A) => v > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: $[A],
        type: "button",
        className: L.more,
        style: {
          left: `calc(${A / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: ya + (f - 1) * An
        },
        onClick: (C) => e.openMore($[A], C.currentTarget)
      },
      t.more(v)
    ) : null));
  })));
}
const Ze = 44, Ap = Array.from({ length: 23 }, (e, t) => t + 1);
function gr() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function ha(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Ce, (e - a.top) / Ze * 60));
}
function vr({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = xo(e), [s, l] = D(null), [c, i] = D(null), m = j(!1), u = ra(e.events, t[0], t[a - 1], s != null ? s : o.preview), d = wo(e.timeGrid ? u.filter(vo) : u, t), _ = d.reduce((k, w) => Math.max(k, w.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, f] = D(gr);
  U(() => {
    const k = window.setInterval(() => f(gr()), 6e4);
    return () => window.clearInterval(k);
  }, []);
  const b = j(null), g = t.includes(e.today);
  ge(() => {
    const k = b.current;
    if (!k) return;
    const w = g ? Math.max(0, Math.floor((y - pe(e.today)) / 60) - 1) : e.scrollToHour;
    k.scrollTop = w * Ze;
  }, [t[0], a]);
  const N = (k, w) => {
    if (k.button !== 0 || !e.onCreate) return;
    k.preventDefault();
    const v = k.currentTarget, A = Math.min(Ce - r, Math.floor(ha(k.clientY, v) / r) * r);
    let C = A;
    i({ day: w, a: A, b: A + r }), Qn(k, {
      move: (M) => {
        C = Math.min(Ce - r, Math.floor(ha(M.clientY, v) / r) * r), i({ day: w, a: Math.min(A, C), b: Math.max(A, C) + r });
      },
      end: (M, B) => {
        var G;
        i(null);
        const I = pe(w), T = B ? Math.min(A, C) : A, z = B ? Math.max(A, C) + r : Math.min(A + 60, Ce);
        (G = e.onCreate) == null || G.call(e, { start: _n(I + T), end: _n(I + z), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, E = (k, w, v) => {
    if (k.stopPropagation(), k.button !== 0 || !yn(e, w.ev)) return;
    const A = (B, I) => {
      const T = Hn(B, I, "data-cal-col");
      return T ? pe(T.dataset.calCol) + ha(I, T) : null;
    }, C = A(k.clientX, k.clientY);
    if (C == null) return;
    m.current = !1;
    let M = null;
    Qn(k, {
      move: (B) => {
        m.current = !0;
        const I = A(B.clientX, B.clientY);
        if (I != null) {
          if (v === "move") {
            const T = Er(I - C, r);
            M = T ? Ma(w, T) : null;
          } else {
            const T = Math.max(w.s + r, Er(I, r));
            M = T !== w.e ? { start: w.ev.start, end: _n(T) } : null;
          }
          l(M ? { id: w.ev.id, ...M } : null);
        }
      },
      end: (B, I) => {
        var T;
        l(null), I && M && ((T = e.onEventChange) == null || T.call(e, w.ev, M));
      },
      cancel: () => l(null)
    });
  }, $ = (k, w) => {
    var v;
    if (m.current) {
      m.current = !1;
      return;
    }
    (v = e.onEventClick) == null || v.call(e, w, k);
  };
  return /* @__PURE__ */ n.createElement("div", { className: L.time }, /* @__PURE__ */ n.createElement("div", { className: L.tHead }, /* @__PURE__ */ n.createElement("div", { className: L.gutter }), /* @__PURE__ */ n.createElement("div", { className: L.tHeadDays, style: p }, t.map((k) => {
    const w = de(k), v = Re(w), A = e.holidays[k];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: k,
        className: [L.tDay, k === e.today ? L.isToday : "", v === 0 || A ? L.sun : v === 6 ? L.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: L.tDayBtn, onClick: () => e.goto("day", k), "aria-label": e.L.openDay(k) }, /* @__PURE__ */ n.createElement("span", { className: L.tWd }, e.L.weekdays[v]), /* @__PURE__ */ n.createElement("span", { className: L.tDayNum }, w.d)),
      A && /* @__PURE__ */ n.createElement("span", { className: L.holiday, title: A }, A)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [L.tAllDay, e.timeGrid ? "" : L.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: L.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: L.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, _) * An + 6 } : { minHeight: Math.max(1, _) * An + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: L.tAllDayCells, style: p }, t.map((k) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: k,
        "data-cal-day": k,
        className: [L.allDayCell, o.inSel(k) ? L.selDay : "", e.onCreate ? L.creatable : ""].join(" "),
        onPointerDown: (w) => o.onCellDown(w, k)
      }
    ))),
    /* @__PURE__ */ n.createElement(Ao, { segs: d, cols: a, top: 3, ctx: e, drag: o })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: L.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: L.tGrid, style: { height: 24 * Ze } }, /* @__PURE__ */ n.createElement("div", { className: L.tGutter, "aria-hidden": !0 }, Ap.map((k) => /* @__PURE__ */ n.createElement("span", { key: k, style: { top: k * Ze } }, tt(k * 60)))), /* @__PURE__ */ n.createElement("div", { className: L.tCols, style: { ...p, backgroundSize: `100% ${Ze}px` } }, t.map((k) => {
    const w = Od(u, k);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: k,
        "data-cal-col": k,
        className: [L.tCol, k === e.today ? L.isToday : "", e.onCreate ? L.creatable : ""].join(" "),
        onPointerDown: (v) => N(v, k)
      },
      (c == null ? void 0 : c.day) === k && /* @__PURE__ */ n.createElement("div", { className: L.tSel, style: { top: c.a / 60 * Ze, height: (c.b - c.a) / 60 * Ze } }, tt(c.a), " – ", c.b === Ce ? "24:00" : tt(c.b)),
      w.map((v) => {
        const A = v.item.ev, C = (v.bottom - v.top) / 60 * Ze, M = [
          L.tEv,
          sa(A),
          C < 34 ? L.tEvShort : "",
          v.contTop ? L.contTop : "",
          v.contBottom ? L.contBottom : "",
          (s == null ? void 0 : s.id) === A.id ? L.ghost : "",
          yn(e, A) ? L.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: A.id,
            type: "button",
            className: M,
            style: {
              top: v.top / 60 * Ze,
              height: Math.max(18, C - 1),
              left: `calc(${v.col / v.cols * 100}% + 1px)`,
              width: `calc(${100 / v.cols}% - 4px)`,
              ...la(A)
            },
            "aria-label": $o(v.item, e.L),
            onPointerDown: (B) => E(B, v.item, "move"),
            onClick: (B) => $(B.currentTarget, A)
          },
          /* @__PURE__ */ n.createElement("span", { className: L.tEvTitle }, A.title),
          /* @__PURE__ */ n.createElement("span", { className: L.tEvTime }, Qa(v.item, e.L.allDay)),
          yn(e, A) && !v.contBottom && /* @__PURE__ */ n.createElement("span", { className: L.resize, "aria-hidden": !0, onPointerDown: (B) => E(B, v.item, "resize") })
        );
      }),
      k === e.today && /* @__PURE__ */ n.createElement("div", { className: L.now, style: { top: (y - pe(k)) / 60 * Ze }, "aria-hidden": !0 })
    );
  })))));
}
function kr(e, t, a) {
  return e.sDay === e.eDay ? Qa(e, a) : e.allDay ? a : t === e.sDay ? `${tt(e.s - pe(t))} ~` : t === e.eDay ? `~ ${tt(e.e - pe(t))}` : a;
}
function Dp({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = Ya("agenda", e.cursor, e.weekStartsOn), o = ra(e.events, a, r), s = oa(a, r).filter((l) => e.showWeekends || !xn(l)).map((l) => {
    const c = pe(l), i = (u) => kr(u, l, "") === "" ? -1 : Math.max(u.s, c), m = o.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, d) => i(u) - i(d)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: L.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = Re(i), d = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [L.aDay, l === e.today ? L.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [L.aDate, u === 0 || m ? L.sun : u === 6 ? L.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: L.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: L.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: L.aDayWd }, t.m(l), " · ", d)), m && /* @__PURE__ */ n.createElement("span", { className: L.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: L.aList }, c.map((_) => {
      const p = _.ev, y = nn(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: p.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [L.aRow, sa(p)].join(" "),
          style: la(p),
          onClick: (f) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, f.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: L.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: L.aTime }, kr(_, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: L.aTitle }, p.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: L.aSpan }, t.dayOfSpan(nn(_.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ n.createElement("span", { className: L.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: L.empty }, t.empty);
}
const Ea = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function wr(e, t, a) {
  const [r, o] = D(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const Nr = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function Ww({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: d,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  timeGrid: y = !0,
  onRangeChange: f,
  onEventClick: b,
  onCreate: g,
  onEventChange: N,
  locale: E = No,
  loading: $,
  headerExtra: k,
  className: w = "",
  style: v,
  "aria-label": A
}) {
  var Z;
  const C = Eo(), [M, B] = wr(t, (Z = a != null ? a : c[0]) != null ? Z : "month", r), [I, T] = wr(o, s != null ? s : C, l), z = de(I) ? I : C, [G, K] = D(m), [R, ne] = D(null), te = j(null), h = j(!1);
  U(() => {
    var V;
    if (!h.current) return;
    h.current = !1;
    const W = te.current;
    !W || W.contains(document.activeElement) || ((V = W.querySelector('[data-cal-day][tabindex="0"]')) != null ? V : W).focus();
  });
  const { from: S, to: P } = Ya(M, z, i), H = j(f);
  H.current = f, U(() => {
    var W;
    (W = H.current) == null || W.call(H, { from: S, to: P, view: M });
  }, [S, P, M]);
  const J = (W, V) => {
    T(V), c.includes(W) && B(W);
  }, q = {
    events: e,
    L: E,
    cursor: z,
    today: C,
    weekStartsOn: i,
    showWeekends: G,
    holidays: d != null ? d : {},
    slotMinutes: _,
    scrollToHour: p,
    timeGrid: y,
    setCursor: T,
    goto: J,
    openMore: (W, V) => ne({ day: W, anchor: V }),
    onEventClick: b,
    onCreate: g,
    onEventChange: N
  }, Q = (W) => T(Id(M, z, W, M === "day" && !G)), X = (W) => {
    if (W.defaultPrevented || W.ctrlKey || W.metaKey || W.altKey || W.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const V = W.nativeEvent.code;
    if (V === "KeyT") T(C);
    else if (V === "KeyN" || V === "KeyJ" || W.key === "PageDown") Q(1);
    else if (V === "KeyP" || V === "KeyK" || W.key === "PageUp") Q(-1);
    else if (Ea[V] && c.includes(Ea[V])) B(Ea[V]);
    else if (V === "KeyC" && g)
      g(M === "month" || M === "agenda" ? { start: z, end: z, allDay: !0 } : { start: `${z}T09:00`, end: `${z}T10:00`, allDay: !1 });
    else return;
    W.preventDefault(), h.current = !0;
  }, F = _e(
    () => oa(S, P).filter((W) => G || !xn(W)),
    [S, P, G]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [L.cal, w].filter(Boolean).join(" "),
      style: v,
      role: "region",
      "aria-label": A != null ? A : E.region,
      "aria-busy": $ || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: X,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: L.toolbar }, /* @__PURE__ */ n.createElement(Fe, { onClick: () => T(C), title: `${E.today} (T)` }, E.today), /* @__PURE__ */ n.createElement("span", { className: L.navBtns }, /* @__PURE__ */ n.createElement(Da, { label: E.prev(M), onClick: () => Q(-1) }, /* @__PURE__ */ n.createElement(Nr, { dir: "l" })), /* @__PURE__ */ n.createElement(Da, { label: E.next(M), onClick: () => Q(1) }, /* @__PURE__ */ n.createElement(Nr, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: L.title, "aria-live": "polite" }, Rd(M, z, i, E)), /* @__PURE__ */ n.createElement("span", { className: L.toolRight }, k, u && M !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: L.toggle,
        "aria-pressed": !G,
        onClick: () => K((W) => !W)
      },
      E.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      io,
      {
        variant: "segmented",
        "aria-label": E.viewTabs,
        items: c.map((W) => ({ key: W, label: E.views[W] })),
        value: M,
        onChange: (W) => B(W)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: L.body }, $ && /* @__PURE__ */ n.createElement("div", { className: L.busy, role: "progressbar", "aria-label": E.loading }), M === "month" && /* @__PURE__ */ n.createElement(xp, { ctx: q }), M === "week" && /* @__PURE__ */ n.createElement(vr, { ctx: q, days: F }), M === "day" && /* @__PURE__ */ n.createElement(vr, { ctx: q, days: [z] }), M === "agenda" && /* @__PURE__ */ n.createElement(Dp, { ctx: q })),
    R && /* @__PURE__ */ n.createElement(Sp, { ctx: q, day: R.day, anchor: R.anchor, onClose: () => ne(null) })
  );
}
function Sp({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = j(null), [s, l] = D({ top: -9999, left: -9999 }), c = de(t), i = ra(e.events, t, t);
  return ge(() => {
    var p;
    const m = o.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), d = m.offsetWidth, _ = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - d / 2, window.innerWidth - d - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - _ - 8))
    }), (p = m.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), U(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (_) => {
      var p;
      (p = o.current) != null && p.contains(_.target) || r();
    }, d = (_) => {
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", d, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", d, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(rn, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: L.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: L.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: L.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Re(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: L.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: L.popList }, i.map((m) => {
    const u = m.ev, d = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [L.popItem, d ? L.bar : L.dotChip, sa(u)].join(" "),
        style: la(u),
        onClick: () => {
          var _;
          r(), (_ = e.onEventClick) == null || _.call(e, u, a);
        }
      },
      !d && /* @__PURE__ */ n.createElement("i", { className: L.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: L.chipTime }, tt(Math.max(m.s, pe(t)) - pe(t))),
      /* @__PURE__ */ n.createElement("span", { className: L.chipTitle }, u.title)
    ));
  }))));
}
const Cp = "_mini_10rxe_3", Mp = "_nav_10rxe_5", Tp = "_navBtn_10rxe_6", Bp = "_todayBtn_10rxe_6", qp = "_title_10rxe_6", Lp = "_day_10rxe_25", jp = "_mon_10rxe_25", Ip = "_grid_10rxe_29", Rp = "_wdRow_10rxe_30", Pp = "_row_10rxe_30", Xp = "_sun_10rxe_35", Op = "_sat_10rxe_36", zp = "_num_10rxe_45", Hp = "_sel_10rxe_46", Wp = "_out_10rxe_50", Fp = "_isToday_10rxe_52", Kp = "_dots_10rxe_55", Vp = "_months_10rxe_59", le = {
  mini: Cp,
  nav: Mp,
  navBtn: Tp,
  todayBtn: Bp,
  title: qp,
  day: Lp,
  mon: jp,
  grid: Ip,
  wdRow: Rp,
  row: Pp,
  sun: Xp,
  sat: Op,
  num: zp,
  sel: Hp,
  out: Wp,
  isToday: Fp,
  dots: Kp,
  months: Vp
}, $r = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function Fw({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = No,
  today: m,
  children: u,
  className: d = "",
  "aria-label": _
}) {
  const p = m != null ? m : Eo(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, f = de(y), b = Yn(y, c), g = oa(b, we(b, 41)), N = s != null ? s : i.eventCount, [E, $] = D("day"), [k, w] = D(f.y), v = (K) => !!K && K.slice(0, 7) === y.slice(0, 7), [A, C] = D(() => v(a) ? a : v(p) ? p : y);
  U(() => {
    v(A) || C(v(a) ? a : v(p) ? p : y);
  }, [y]);
  const M = j(!1), B = j(null);
  U(() => {
    var K, R;
    M.current && (M.current = !1, (R = (K = B.current) == null ? void 0 : K.querySelector(`[data-day="${A}"]`)) == null || R.focus());
  }, [A, y]);
  const I = (K) => {
    M.current = !0, C(K), v(K) || t(K.slice(0, 7));
  }, T = (K) => {
    const R = xt(f, K);
    t($r(R.y, R.m));
  }, z = (K, R) => {
    const ne = de(R), te = (Re(ne) - c + 7) % 7;
    let h = null;
    if (K.key === "ArrowLeft") h = we(R, -1);
    else if (K.key === "ArrowRight") h = we(R, 1);
    else if (K.key === "ArrowUp") h = we(R, -7);
    else if (K.key === "ArrowDown") h = we(R, 7);
    else if (K.key === "Home") h = we(R, -te);
    else if (K.key === "End") h = we(R, 6 - te);
    else if (K.key === "PageUp" || K.key === "PageDown") {
      const S = xt(ne, K.key === "PageUp" ? -1 : 1);
      h = at(S.y, S.m, S.d);
    }
    h && (K.preventDefault(), I(h));
  }, G = () => {
    w(f.y), $("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, d].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, E === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => T(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: G }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => T(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: v(p),
      onClick: () => {
        t(p.slice(0, 7)), I(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => w((K) => K - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${k}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => w((K) => K + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => $("day"), "aria-label": i.close }, "✕")), E === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (K) => {
    K.key === "Escape" && (K.preventDefault(), $("day"));
  } }, Array.from({ length: 12 }, (K, R) => {
    const ne = $r(k, R + 1), te = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, te ? le.sel : "", ne === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ne), $("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: B }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, g.slice(0, 7).map((K) => {
    const R = Re(de(K));
    return /* @__PURE__ */ n.createElement("span", { key: K, role: "columnheader", className: R === 0 ? le.sun : R === 6 ? le.sat : "" }, i.weekdays[R]);
  })), [0, 1, 2, 3, 4, 5].map((K) => /* @__PURE__ */ n.createElement("div", { key: K, className: le.row, role: "row" }, g.slice(K * 7, K * 7 + 7).map((R) => {
    var P;
    const ne = Re(de(R)), te = l[R], h = (P = o[R]) != null ? P : 0, S = [
      le.day,
      v(R) ? "" : le.out,
      ne === 0 || te ? le.sun : ne === 6 ? le.sat : "",
      R === p ? le.isToday : "",
      R === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: R,
        type: "button",
        role: "gridcell",
        "data-day": R,
        className: S,
        tabIndex: R === A ? 0 : -1,
        "aria-selected": R === a,
        "aria-current": R === p ? "date" : void 0,
        "aria-label": [i.dayAria(R), te, h ? N(h) : ""].filter(Boolean).join(", "),
        onKeyDown: (H) => z(H, R),
        onFocus: () => C(R),
        onClick: () => r(R)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +R.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(h, 3) }, (H, J) => /* @__PURE__ */ n.createElement("i", { key: J })))
    );
  })))), u);
}
const Up = "_mono_6omzf_2", Gp = "_invalid_6omzf_3", Yp = "_qty_6omzf_6", Qp = "_qtyInput_6omzf_7", Jp = "_unit_6omzf_8", Zp = "_note_6omzf_9", e_ = "_qtyErr_6omzf_10", dt = {
  mono: Up,
  invalid: Gp,
  qty: Yp,
  qtyInput: Qp,
  unit: Jp,
  note: Zp,
  qtyErr: e_
};
function t_(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
const n_ = {
  sign: "음수는 입력할 수 없습니다",
  decimal: "소수점 이하는 입력할 수 없습니다. 정수로 입력하세요"
};
function Kw({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = j(null), i = j(null), [m, u] = D(!1), [d, _] = D(null), p = j(!1), y = e == null || e === "";
  ge(() => {
    const g = c.current, N = i.current;
    if (i.current = null, !g || N === null) return;
    let E = 0, $ = 0;
    for (; E < g.value.length && $ < N; )
      /\d/.test(g.value[E]) && ($ += 1), E += 1;
    E === 0 && g.value[0] === "-" && (E = 1), g.setSelectionRange(E, E);
  });
  const f = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: m && y ? "-" : ar(e),
      "aria-invalid": d ? !0 : l["aria-invalid"],
      onBlur: (g) => {
        var N;
        _(null), p.current = !1, (N = l.onBlur) == null || N.call(l, g);
      },
      onChange: (g) => {
        var w;
        const N = g.target;
        i.current = t_(N.value.slice(0, (w = N.selectionStart) != null ? w : N.value.length));
        const E = ss(N.value, a), $ = ao(N.value);
        if (p.current) {
          const v = (m && y ? "-" : ar(e)).replace(/,/g, ""), A = $.replace(/,/g, "");
          if (A.length > v.length && A.startsWith(v) && /^\d+$/.test(A.slice(v.length))) {
            _("decimal"), r == null || r("decimal");
            return;
          }
          p.current = !1;
        }
        let k = null;
        !a && /^\s*-/.test($) ? k = "sign" : (/\.\d*[1-9]/.test($.replace(/^\s*-/, "")) || /\.$/.test($)) && (k = "decimal"), p.current = k === "decimal" && /\.$/.test($), k ? _(k) : E === "" && _(null), k && (r == null || r(k)), u(E === "-"), t({ text: E, num: ls(E) });
      }
    }
  ), b = d ? /* @__PURE__ */ n.createElement("span", { className: dt.note, role: "status", "aria-live": "polite" }, n_[d]) : null;
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, f, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o), b) : /* @__PURE__ */ n.createElement(n.Fragment, null, f, b);
}
function Ta(e) {
  const t = ao(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function xr(e, t) {
  const a = Ta(e), r = Ta(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function Vw(e, t) {
  var s, l;
  const a = xr(e.qty, e.unitAm), r = xr((s = t.qty) != null ? s : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const o = Ta(e.lineAm);
  return o == null || o === a ? { ...t, lineAm: String(r) } : t;
}
const a_ = "_box_qzg36_3", r_ = "_banner_qzg36_9", o_ = "_verify_qzg36_10", s_ = "_t_info_qzg36_15", l_ = "_t_warn_qzg36_16", c_ = "_t_danger_qzg36_17", i_ = "_error_qzg36_22", u_ = "_note_qzg36_30", m_ = "_noteI_qzg36_42", d_ = "_noteBody_qzg36_43", f_ = "_badge_qzg36_49", p_ = "_b_muted_qzg36_53", __ = "_b_ok_qzg36_54", y_ = "_b_warn_qzg36_55", h_ = "_b_info_qzg36_56", E_ = "_b_off_qzg36_57", We = {
  box: a_,
  banner: r_,
  verify: o_,
  t_info: s_,
  t_warn: l_,
  t_danger: c_,
  error: i_,
  note: u_,
  noteI: m_,
  noteBody: d_,
  badge: f_,
  b_muted: p_,
  b_ok: __,
  b_warn: y_,
  b_info: h_,
  b_off: E_
};
function fn({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.banner, We[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Uw({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [We.box, We.verify, We[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Do({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [We.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(b_, { text: t }) : t);
}
function Gw({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [We.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: We.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: We.noteBody }, a));
}
function hn({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", We.badge, We[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function b_({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(as, { key: a }, t))) : null;
}
const ba = "__AX_UNSAVED_HINT__";
function So() {
  var t;
  const e = window;
  return (t = e[ba]) != null ? t : e[ba] = {};
}
function Ar(e, t) {
  if (typeof window == "undefined") return;
  const a = So();
  t ? a[e] = !0 : delete a[e];
}
function Yw() {
  return typeof window == "undefined" ? !1 : Object.keys(So()).length > 0;
}
let g_ = 0;
const v_ = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function k_(e, t = v_) {
  const a = j(e);
  a.current = e;
  const r = j("");
  return r.current || (r.current = `dirtyGuard-${++g_}`), U(() => {
    const o = r.current;
    return Ar(o, e), () => Ar(o, !1);
  }, [e]), U(() => {
    if (!e) return;
    const o = (s) => {
      s.preventDefault(), s.returnValue = "";
    };
    return window.addEventListener("beforeunload", o), () => window.removeEventListener("beforeunload", o);
  }, [e]), oe(() => !a.current || window.confirm(t), [t]);
}
const w_ = "_overlay_1s8aj_2", N_ = "_modal_1s8aj_8", $_ = "_wide_1s8aj_15", x_ = "_head_1s8aj_16", A_ = "_title_1s8aj_20", D_ = "_close_1s8aj_21", S_ = "_body_1s8aj_25", C_ = "_flush_1s8aj_26", M_ = "_error_1s8aj_27", T_ = "_foot_1s8aj_29", B_ = "_overlayTop_1s8aj_35", ze = {
  overlay: w_,
  modal: N_,
  wide: $_,
  head: x_,
  title: A_,
  close: D_,
  body: S_,
  flush: C_,
  error: M_,
  foot: T_,
  overlayTop: B_
}, It = [];
function Dr(e) {
  const t = It[It.length - 1];
  if (e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc) return;
  const a = document.activeElement;
  a instanceof HTMLSelectElement || a != null && a.closest('[aria-expanded="true"]') || (e.preventDefault(), t.close());
}
const q_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Sr(e) {
  return Array.from(e.querySelectorAll(q_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Cr = 0, Mr = "";
function ca({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !0,
  error: m,
  confirmDiscard: u = !0,
  layer: d
}) {
  const [_, p] = D(!1), y = u ? () => {
    _ || p(!0);
  } : void 0, f = k_(u && _, "입력한 내용을 저장하지 않고 닫을까요?"), b = () => {
    f() && t();
  }, g = j(b);
  g.current = b;
  const N = j({ close: () => g.current(), esc: i });
  N.current.esc = i, U(() => {
    const v = N.current;
    return It.push(v), It.length === 1 && window.addEventListener("keydown", Dr), () => {
      const A = It.lastIndexOf(v);
      A >= 0 && It.splice(A, 1), It.length === 0 && window.removeEventListener("keydown", Dr);
    };
  }, []);
  const E = j(null), $ = j(null), k = j(void 0);
  k.current === void 0 && (k.current = typeof document == "undefined" ? null : document.activeElement), U(() => {
    var C;
    const v = E.current, A = (C = k.current) != null ? C : null;
    return v && !v.contains(document.activeElement) && ($.current && Sr($.current)[0] || null || v).focus(), Cr++ === 0 && (Mr = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Cr === 0 && (document.body.style.overflow = Mr), A && A.isConnected && typeof A.focus == "function" && A.focus();
    };
  }, []);
  const w = (v) => {
    const A = E.current;
    if (v.key !== "Tab" || !A || !A.contains(v.target)) return;
    const C = Sr(A);
    if (C.length === 0) {
      v.preventDefault(), A.focus();
      return;
    }
    const M = C[0], B = C[C.length - 1], I = document.activeElement;
    v.shiftKey && (I === M || I === A) ? (v.preventDefault(), B.focus()) : !v.shiftKey && I === B && (v.preventDefault(), M.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: d === "top" ? `${ze.overlay} ${ze.overlayTop}` : ze.overlay, onClick: c ? b : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: E,
      tabIndex: -1,
      className: [ze.modal, r ? ze.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (v) => v.stopPropagation(),
      onKeyDown: w
    },
    /* @__PURE__ */ n.createElement("header", { className: ze.head }, /* @__PURE__ */ n.createElement("strong", { className: ze.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: ze.close, onClick: b, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: $,
        className: [ze.body, l ? ze.flush : ""].filter(Boolean).join(" "),
        onInputCapture: y,
        onChangeCapture: y
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: ze.error }, /* @__PURE__ */ n.createElement(Do, null, m)),
    o && /* @__PURE__ */ n.createElement("footer", { className: ze.foot }, o)
  ));
}
function Qw(e = 4e3) {
  const [t, a] = D(""), [r, o] = D(!1), s = j(void 0), l = oe((m) => {
    window.clearTimeout(s.current), o(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = oe((m) => {
    window.clearTimeout(s.current), o(!0), a(m);
  }, []), i = oe(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const L_ = "_message_1l9xj_1", j_ = "_details_1l9xj_2", I_ = "_warn_1l9xj_7", R_ = "_field_1l9xj_8", P_ = "_choice_1l9xj_9", cn = {
  message: L_,
  details: j_,
  warn: I_,
  field: R_,
  choice: P_
};
function Jw() {
  var p, y;
  const [e, t] = D(null), [a, r] = D(""), o = j(null), s = j(null), l = j(null), c = oe((f) => new Promise((b) => {
    t({ kind: "confirm", opts: f, resolve: b });
  }), []), i = oe((f) => new Promise((b) => {
    var g, N, E, $;
    r(($ = (E = f.defaultValue) != null ? E : (N = (g = f.choices) == null ? void 0 : g[0]) == null ? void 0 : N.value) != null ? $ : ""), t({ kind: "prompt", opts: f, resolve: b });
  }), []);
  U(() => {
    var f, b, g;
    e && (e.kind === "prompt" ? (f = l.current) == null || f.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : (g = o.current) == null || g.focus());
  }, [e]);
  const m = (f) => {
    e && (e.kind === "confirm" ? e.resolve(f) : e.resolve(f ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, d = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && u ? /* @__PURE__ */ n.createElement(
    ca,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      layer: "top",
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Fe, { ref: s, onClick: () => m(!1) }, (p = u.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(
        Fe,
        {
          ref: o,
          variant: u.danger ? "danger" : "primary",
          disabled: d,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: cn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: cn.details }, u.details.map((f, b) => /* @__PURE__ */ n.createElement("li", { key: b }, f))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: cn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: cn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement(
      Ie,
      {
        buttonRef: l,
        className: cn.choice,
        value: a,
        label: e.opts.label,
        onChange: r,
        options: e.opts.choices.map((f) => ({ value: f.value, label: f.label }))
      }
    ) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (f) => r(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && !d && (f.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: _ };
}
function Co(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + X_(e);
}
function X_(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function Zw() {
  const [e, t] = D(!1), a = j(!1), r = oe(async (o) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await o();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function eN(e, t, a, r) {
  const [o, s] = D(null), [l, c] = D(a), [i, m] = D(null), [u, d] = D(!1), [_, p] = D(0), y = j(0), f = j(r);
  f.current = r;
  const b = oe(() => p((g) => g + 1), []);
  return U(() => {
    if (!a) return;
    const g = ++y.current;
    return c(!0), e().then((N) => {
      g === y.current && (s(N), m(null), d(!1));
    }).catch((N) => {
      var E, $, k;
      g === y.current && (m(f.current.errorText(N)), d((k = ($ = (E = f.current).isUnavailable) == null ? void 0 : $.call(E, N)) != null ? k : !1));
    }).finally(() => {
      g === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, _, ...t]), { data: o, loading: l, error: i, unavailable: u, reload: b };
}
function tN(e) {
  const [t, a] = D(null), [r, o] = D(null), [s, l] = D(!1), [c, i] = D(1), m = j(0), u = j(e);
  u.current = e;
  const d = oe(async (p, y) => {
    const f = ++m.current;
    l(!0), o(null);
    try {
      const b = await y(p);
      if (f !== m.current) return;
      a(b), i(p);
    } catch (b) {
      if (f !== m.current) return;
      a(null), o(u.current.errorText(b));
    } finally {
      f === m.current && l(!1);
    }
  }, []), _ = oe(() => {
    m.current++, a(null), o(null), l(!1);
  }, []);
  return { data: t, err: r, loading: s, page: c, load: d, clear: _ };
}
const O_ = "_section_13ljt_3", z_ = "_row_13ljt_10", H_ = "_label_13ljt_15", W_ = "_value_13ljt_21", F_ = "_invalid_13ljt_50", K_ = "_help_13ljt_52", V_ = "_err_13ljt_52", U_ = "_req_13ljt_56", G_ = "_opt_13ljt_57", Y_ = "_sr_13ljt_58", Q_ = "_ro_13ljt_10", J_ = "_readonly_13ljt_65", Z_ = "_hint_13ljt_72", ey = "_toggle_13ljt_80", ty = "_table_13ljt_87", ny = "_isReq_13ljt_102", Se = {
  section: O_,
  row: z_,
  label: H_,
  value: W_,
  invalid: F_,
  help: K_,
  err: V_,
  req: U_,
  opt: G_,
  sr: Y_,
  ro: Q_,
  readonly: J_,
  hint: Z_,
  toggle: ey,
  table: ty,
  isReq: ny
};
let ay = 0;
const ry = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function nN({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var k, w, v, A;
  const u = j(`axe-fr${++ay}`).current, d = `${u}-lbl`, _ = j(null), p = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, f = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let g = t;
  const N = Aa.count(t) === 1 ? Aa.toArray(t)[0] : null, E = kn(N) && typeof N.type != "string" && !!N.type.axeFormControl;
  if (kn(N) && (typeof N.type == "string" && ry.has(N.type) || E)) {
    const C = N, M = C.props;
    g = za(C, {
      id: (k = M.id) != null ? k : o,
      "aria-describedby": (w = M["aria-describedby"]) != null ? w : f,
      "aria-invalid": (v = M["aria-invalid"]) != null ? v : i ? !0 : void 0,
      "aria-required": (A = M["aria-required"]) != null ? A : s ? !0 : void 0
    });
  }
  ge(() => {
    var I;
    const C = (I = _.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const M = (T, z) => {
      const G = `data-fr-${T}`;
      if (z == null) {
        C.hasAttribute(G) && (C.removeAttribute(T), C.removeAttribute(G));
        return;
      }
      C.hasAttribute(T) && !C.hasAttribute(G) || (C.getAttribute(T) !== z && C.setAttribute(T, z), C.setAttribute(G, ""));
    }, B = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    M("aria-labelledby", B ? null : d), M("aria-invalid", i ? "true" : null), M("aria-required", s ? "true" : null), M("aria-describedby", f != null ? f : null);
  });
  const $ = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Se.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Se.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Se.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Se.row, r ? Se.ro : "", i ? Se.invalid : "", s ? Se.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Se.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: d }, $) : /* @__PURE__ */ n.createElement("span", { id: d }, $), a && /* @__PURE__ */ n.createElement(zt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Se.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: _, className: `axe-form-value ${Se.value}` }, g, c && /* @__PURE__ */ n.createElement("span", { id: p, className: Se.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Se.err }, i)));
}
function aN({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Se.table}` : "", Se.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function rN({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Se.readonly }, e);
}
function oN({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Se.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
function oy({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": d,
  "aria-invalid": _,
  "aria-required": p,
  className: y = ""
}) {
  const f = [s ? dt.mono : "", l ? dt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: f,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": m,
    "aria-describedby": d,
    "aria-invalid": _ != null ? _ : l || void 0,
    "aria-required": p,
    onChange: (g) => t(g.target.value === "" ? null : g.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
oy.axeFormControl = !0;
function sy(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u,
    title: d,
    style: _,
    onClick: p
  } = e, y = (g) => {
    e.codeType === "string" ? e.onChange(g === "" ? null : g) : e.onChange(g === "" ? null : Number(g));
  }, f = Array.isArray(a) ? a : Object.entries(a), b = [
    ...r != null ? [{ value: "", label: r }] : [],
    ...f.map(([g, N, E]) => ({ value: String(g), label: N, disabled: E || void 0 }))
  ];
  return /* @__PURE__ */ n.createElement(
    Ie,
    {
      id: l,
      className: u,
      title: d,
      style: _,
      onClick: p,
      value: t == null ? "" : String(t),
      options: b,
      disabled: o,
      label: s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: y
    }
  );
}
sy.axeFormControl = !0;
function ly(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const cy = /^-?(\d+\.?\d*|\.\d+)$/;
function un(e) {
  const t = ly(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!cy.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Jn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Mo(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Jn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, Jn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function Yt(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function iy(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function uy(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Mo(e + a * t, Math.max(r, Jn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const my = 2500;
function dy({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": d,
  "aria-required": _,
  width: p,
  onEnter: y,
  onInvalidChange: f,
  placeholder: b,
  className: g = ""
}) {
  const [N, E] = D(() => Yt(e)), [$, k] = D(!1), [w, v] = D(null), [A, C] = D(!1), M = j(null), B = j(N);
  B.current = N, U(() => {
    const h = un(B.current), S = h.kind === "num" ? h.value : h.kind === "empty" ? null : void 0;
    S !== void 0 && S === (e != null ? e : null) || E(Yt(e));
  }, [e]), U(() => () => {
    M.current && clearTimeout(M.current);
  }, []);
  const I = un(N), T = I.kind === "bad" || I.kind === "partial";
  U(() => {
    T || C(!1);
  }, [T]);
  const z = j(f);
  z.current = f, U(() => {
    var h;
    (h = z.current) == null || h.call(z, T);
  }, [T]), U(() => () => {
    var h;
    (h = z.current) == null || h.call(z, !1);
  }, []);
  const G = (h) => {
    M.current && clearTimeout(M.current), v(h), M.current = setTimeout(() => v(null), my);
  }, K = (h) => {
    E(h);
    const S = un(h);
    S.kind === "empty" ? t(null) : S.kind === "num" && t(S.value);
  }, R = () => {
    const h = un(N);
    if (h.kind !== "num") return;
    if (Jn(h.value) > a) {
      const P = Mo(h.value, a);
      E(Yt(P)), t(P), G(`반올림했습니다 → ${Yt(P)}`);
      return;
    }
    const S = Yt(h.value);
    S !== N && E(S);
  }, ne = (h) => {
    if (!h.nativeEvent.isComposing) {
      if (h.key === "Enter") {
        if (T) {
          C(!0);
          return;
        }
        R(), y == null || y();
        return;
      }
      if (s && (h.key === "ArrowUp" || h.key === "ArrowDown")) {
        h.preventDefault();
        const S = un(N), P = S.kind === "num" ? S.value : S.kind === "empty" ? null : e, H = uy(P, s, h.key === "ArrowUp" ? 1 : -1, a, r, o);
        E(Yt(H)), t(H);
      }
    }
  }, te = I.kind === "bad" || I.kind === "partial" && (!$ || A) || I.kind === "num" && iy(I.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [dt.qty, g].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [dt.qtyInput, te ? dt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: N,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": d != null ? d : te || void 0,
      "aria-required": _,
      onChange: (h) => K(h.target.value),
      onFocus: () => k(!0),
      onBlur: () => {
        k(!1), R();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: dt.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!$ || A)) && /* @__PURE__ */ n.createElement("span", { className: dt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: dt.note, role: "status", "aria-live": "polite" }, w));
}
dy.axeFormControl = !0;
function fy(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function py(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    fy(e[s], t[s]) || r.push(s);
  }), r;
}
function _y(e, t) {
  return e === null || t === null ? e === t : py(e, t).length === 0;
}
function sN() {
  const [e, t] = D(null), [a, r] = D(!1), [o, s] = D(null), l = _e(() => a || !_y(o, e), [a, o, e]), c = oe((p) => {
    t((y) => y === null ? y : { ...y, ...p });
  }, []), i = oe((p, y) => {
    t((f) => f === null ? f : { ...f, [p]: y });
  }, []), m = j(null), u = oe((p) => {
    m.current = p, t(p), s(p), r(!1);
  }, []), d = oe((p) => {
    m.current = p, t(p), s(p), r(!0);
  }, []), _ = oe(() => t(m.current), []);
  return _e(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: d, reset: _, snapshot: o }),
    [e, a, l, i, c, u, d, _, o]
  );
}
function yy() {
  const e = j(!1), [t, a] = D(!1), r = oe(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const hy = "_panel_1w7xx_2", Ey = "_band_1w7xx_7", by = "_chev_1w7xx_11", gy = "_title_1w7xx_17", vy = "_note_1w7xx_19", ky = "_chip_1w7xx_21", wy = "_other_1w7xx_32", Ny = "_reset_1w7xx_33", $y = "_form_1w7xx_42", st = {
  panel: hy,
  band: Ey,
  chev: by,
  title: gy,
  note: vy,
  chip: ky,
  other: wy,
  reset: Ny,
  form: $y
};
function lN({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const d = j(null);
  if (i && !a && e.length === 0) return null;
  const _ = (y, f = 0) => {
    var $, k, w;
    const b = ($ = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? $ : d.current, g = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), N = (w = g && ((k = g[y]) != null ? k : g[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), E = !document.activeElement || document.activeElement === document.body;
    N && N !== document.activeElement && (f === 0 || E) && N.focus(), f < 4 && setTimeout(() => _(y, f + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => _(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [st.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: st.band, ref: d }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: st.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: st.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, f) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [st.chip, y.tone === "other" ? st.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(f)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: st.reset, onClick: () => {
    t(), requestAnimationFrame(() => _(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: st.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: st.form }, c));
}
const xy = "_zone_1y6sp_2", Ay = "_drag_1y6sp_8", Dy = "_busy_1y6sp_9", Sy = "_attached_1y6sp_10", Cy = "_left_1y6sp_12", My = "_icon_1y6sp_13", Ty = "_title_1y6sp_18", By = "_desc_1y6sp_19", qy = "_right_1y6sp_20", Ly = "_count_1y6sp_21", jy = "_pick_1y6sp_22", Ve = {
  zone: xy,
  drag: Ay,
  busy: Dy,
  attached: Sy,
  left: Cy,
  icon: My,
  title: Ty,
  desc: By,
  right: qy,
  count: Ly,
  pick: jy
};
function Iy({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = j(null), [d, _] = D(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Ve.zone, d ? Ve.drag : "", l ? Ve.busy : "", c ? Ve.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (y) => {
        y.preventDefault(), _(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: Ve.left }, /* @__PURE__ */ n.createElement("div", { className: Ve.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: Ve.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: Ve.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: Ve.right }, r && /* @__PURE__ */ n.createElement("span", { className: Ve.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Ve.pick,
        disabled: l,
        onClick: (y) => {
          var f;
          y.stopPropagation(), (f = u.current) == null || f.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function To(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Bo(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function Ry(e, t, a) {
  Bo(await e.blob(), a != null ? a : To(e, t));
}
const Py = /^([△▲\-−]?)\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, Xy = /^\(\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function qo(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = Xy.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = Py.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function en(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function Oy(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((c) => a.push(c.map((i) => Rn(en(String(i != null ? i : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (c) => {
    var m;
    const i = zy(c, e);
    !i || i === o || (o = i, a.length > r && a.push(""), a.push(Rn(en((m = i.getAttribute("data-csv-title")) != null ? m : ""))));
  }, l = /* @__PURE__ */ new Map();
  return e.querySelectorAll("table").forEach((c) => {
    var u, d;
    const i = (u = c.closest("[data-axe-grid]")) != null ? u : c, m = (d = l.get(i)) != null ? d : /* @__PURE__ */ new Set();
    Fy(c).forEach((_) => m.add(_)), l.set(i, m);
  }), e.querySelectorAll("table, [data-csv-kv]").forEach((c) => {
    var f, b, g;
    if (c.tagName !== "TABLE") {
      if ((f = c.parentElement) != null && f.closest("table") && e.contains(c.parentElement.closest("table"))) return;
      const N = Hy(c, t);
      if (!N) return;
      s(c), a.push(N.map(Rn).join(","));
      return;
    }
    const i = c;
    s(i);
    const m = i.querySelector("[data-tree-depth]"), u = m ? m.closest("td, th") : null, d = u ? u.cellIndex : -1, _ = d >= 0 && !!i.querySelector("[data-csv-path]"), p = (g = l.get((b = i.closest("[data-axe-grid]")) != null ? b : i)) != null ? g : /* @__PURE__ */ new Set(), y = [];
    Array.from(i.rows).forEach((N) => {
      if (N.hasAttribute("data-state") || N.getAttribute("aria-hidden") === "true") return;
      const E = [];
      let $ = 0;
      const k = () => {
        for (; y[$] && y[$].n > 0; )
          y[$].n -= 1, y[$].skip || E.push(""), $ += 1;
      };
      Array.from(N.cells).forEach((w) => {
        var B, I;
        k();
        const v = Ky(w), A = Math.max(1, w.colSpan || 1), C = Math.max(1, w.rowSpan || 1);
        let M = v ? "" : null;
        for (let T = 0; T < A; T += 1) {
          const z = v || p.has($);
          z || (M === null ? (M = Vy(w, t), E.push(M)) : E.push("")), y[$] = { n: C - 1, skip: z }, $ += 1;
        }
        if (d >= 0 && w.cellIndex === d) {
          const T = w.querySelector("[data-tree-depth]");
          T ? (E.push(String(Number(T.getAttribute("data-tree-depth")) + 1)), _ && E.push(en((B = T.getAttribute("data-csv-path")) != null ? B : ""))) : ((I = N.parentElement) == null ? void 0 : I.tagName) === "THEAD" ? (E.push("단계"), _ && E.push("상위 경로")) : (E.push(""), _ && E.push(""));
        }
      }), k(), E.some((w) => w !== "") && a.push(E.map(Rn).join(","));
    });
  }), a.join(`\r
`);
}
function zy(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function Hy(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? In(o) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? In(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const d = r.cloneNode(!0);
    d.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = In(d);
  } else {
    const d = e.cloneNode(!0);
    d.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = In(d);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [en(c), (u = qo(i, t)) != null ? u : en(i)];
}
function In(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function Wy(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Bo(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function Fy(e) {
  const t = [];
  if (!e.querySelector("[data-csv-skip-col]")) return t;
  const a = [];
  return Array.from(e.rows).forEach((r) => {
    let o = 0;
    const s = () => {
      for (; a[o] > 0; )
        a[o] -= 1, o += 1;
    };
    Array.from(r.cells).forEach((l) => {
      s();
      const c = Math.max(1, l.colSpan || 1);
      for (let i = 0; i < c; i += 1)
        l.hasAttribute("data-csv-skip-col") && t.push(o), a[o] = Math.max(1, l.rowSpan || 1) - 1, o += 1;
    });
  }), t;
}
function Ky(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Vy(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = qo(r, t)) != null ? l : en(r);
}
function Rn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Uy = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function cN({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Da,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await Uy());
        try {
          const i = e.current;
          if (!i) return;
          Wy(Oy(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(wn, { name: "download", size: 14 }),
    "CSV"
  );
}
const Gy = "_root_kpw7f_1", Yy = "_guide_kpw7f_2", Qy = "_tpl_kpw7f_3", ga = {
  root: Gy,
  guide: Yy,
  tpl: Qy
};
function iN({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: o,
  maxBytes: s,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: m = "CSV 파일",
  pickLabel: u = "파일 선택",
  busyReason: d,
  className: _ = ""
}) {
  const p = (f) => {
    var g;
    const b = (g = f[0]) != null ? g : null;
    if (b && s !== void 0 && b.size > s) {
      l == null || l(b);
      return;
    }
    o(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [ga.root, _].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(fn, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: ga.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: ga.tpl }, /* @__PURE__ */ n.createElement(Fe, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    Iy,
    {
      title: m,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!d,
      pickLabel: u,
      onFiles: p
    }
  ));
}
const Jy = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function uN({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(hn, { tone: Jy[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(hn, null, String(t));
}
const Tr = "axerp-form-modal";
function mN({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: o,
  submitLabel: s,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: m,
  children: u
}) {
  var _, p, y;
  const d = (f) => {
    f.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    ca,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: o,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Fe, { onClick: t, disabled: r }, (_ = i == null ? void 0 : i.cancel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(Fe, { type: "submit", form: Tr, variant: "primary", blockedReason: r ? (p = i == null ? void 0 : i.saving) != null ? p : "저장 중입니다" : l }, (y = s != null ? s : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: Tr, className: m, onSubmit: d, noValidate: !0 }, u)
  );
}
const Zy = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Br(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const qr = (e) => {
  var t;
  return Zy[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function dN({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: o = null,
  emptyText: s = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: m,
  grow: u = !1,
  growClassName: d,
  pagination: _,
  stickyCols: p
}) {
  const y = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(Sa, { grow: u, className: u ? d : void 0, cols: e.map((f) => f.width), busy: r, title: m, pagination: _, stickyCols: p }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((f) => /* @__PURE__ */ n.createElement("th", { key: f.key, className: qr(f) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Br }, f.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Vn,
    {
      colSpan: e.length,
      loading: r,
      error: o,
      count: t ? y.length : null,
      empty: s,
      idle: null
    }
  ), y.map((f, b) => {
    var E;
    const g = a(f), N = [c ? "axe-clickable" : "", l === g ? "axe-sel" : "", (E = i == null ? void 0 : i(f)) != null ? E : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: g,
        className: N || void 0,
        onClick: c ? () => c(f) : void 0,
        ...c ? mu(() => c(f), l === void 0 ? void 0 : l === g) : {}
      },
      e.map(($) => /* @__PURE__ */ n.createElement("td", { key: $.key, className: qr($), onMouseEnter: Br }, $.render(f, b)))
    );
  })));
}
function fN({ title: e, info: t, badge: a, notice: r, actions: o, minWidth: s, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(bs, { style: { height: "100%" }, minWidth: s }, /* @__PURE__ */ n.createElement(Os, { title: e, info: t, badge: a, notice: r }, o), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const eh = "_menu_1ow3k_1", th = "_heading_1ow3k_11", nh = "_section_1ow3k_18", ah = "_item_1ow3k_23", Pn = {
  menu: eh,
  heading: th,
  section: nh,
  item: ah
}, Xn = 8;
function pN({ x: e, y: t, entries: a, onClose: r, ariaLabel: o, heading: s }) {
  const l = j(null), c = j(r);
  c.current = r;
  const [i, m] = D({ left: e, top: t });
  ge(() => {
    const _ = l.current;
    if (!_) return;
    const p = Math.max(Xn, Math.min(e, window.innerWidth - _.offsetWidth - Xn)), y = Math.max(Xn, Math.min(t, window.innerHeight - _.offsetHeight - Xn));
    m({ left: p, top: y });
  }, [e, t]);
  const u = () => {
    var _, p;
    return Array.from((p = (_ = l.current) == null ? void 0 : _.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  U(() => {
    var _;
    (_ = u()[0]) == null || _.focus();
  }, []), U(() => {
    const _ = () => c.current(), p = (f) => {
      l.current && !l.current.contains(f.target) && _();
    }, y = (f) => {
      f.key !== "Escape" || f.isComposing || (f.preventDefault(), f.stopPropagation(), _());
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", _), window.addEventListener("scroll", _, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", _), window.removeEventListener("scroll", _, !0);
    };
  }, []);
  const d = (_) => {
    const p = u();
    if (p.length === 0) return;
    const y = p.indexOf(document.activeElement);
    let f = -1;
    if (_.key === "ArrowDown") f = (y + 1) % p.length;
    else if (_.key === "ArrowUp") f = (y - 1 + p.length) % p.length;
    else if (_.key === "Home") f = 0;
    else if (_.key === "End") f = p.length - 1;
    else if (_.key === "Tab") {
      c.current();
      return;
    }
    f >= 0 && (_.preventDefault(), p[f].focus());
  };
  return Cn(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: Pn.menu,
        role: "menu",
        "aria-label": o,
        style: { left: i.left, top: i.top },
        onKeyDown: d,
        onContextMenu: (_) => _.preventDefault()
      },
      s && /* @__PURE__ */ n.createElement("div", { className: Pn.heading }, s),
      a.map((_) => _.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: _.key, className: Pn.section }, _.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: _.key,
          type: "button",
          role: "menuitem",
          className: Pn.item,
          disabled: _.disabled,
          onClick: () => {
            c.current(), _.onClick();
          }
        },
        _.label
      ))
    ),
    document.body
  );
}
const rh = "_sw_xhqlf_1", oh = "_on_xhqlf_10", Lr = {
  sw: rh,
  on: oh
};
function _N({ checked: e, onChange: t, label: a, onText: r = "ON", offText: o = "OFF", disabled: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: s,
      className: [Lr.sw, e ? Lr.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : o),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
function sh({ accept: e, multiple: t = !0, onFiles: a }) {
  const r = j(null), o = j(a);
  return o.current = a, { open: oe(() => {
    var c;
    (c = r.current) == null || c.click();
  }, []), input: /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: r,
      type: "file",
      accept: e,
      multiple: t,
      hidden: !0,
      onChange: (c) => {
        var m;
        const i = Array.from((m = c.target.files) != null ? m : []);
        c.target.value = "", i.length > 0 && o.current(i);
      }
    }
  ) };
}
function yN({ accept: e, multiple: t = !0, onFiles: a, disabled: r, title: o, variant: s, size: l, children: c }) {
  const { open: i, input: m } = sh({ accept: e, multiple: t, onFiles: a });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Fe, { variant: s, size: l, onClick: i, disabled: r, title: o }, c), m);
}
const lh = "_over_bhzlv_1", ch = "_thumbs_bhzlv_2", ih = "_thumb_bhzlv_2", Ba = {
  over: lh,
  thumbs: ch,
  thumb: ih
};
function hN({ onFiles: e, accept: t, disabled: a, className: r = "", children: o }) {
  const [s, l] = D(!1), c = (m) => !t || t.some((u) => m.startsWith(u)), i = (m) => Array.from(m).some((u) => u.kind === "file" && c(u.type));
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [r, s ? Ba.over : ""].filter(Boolean).join(" "),
      onDragOver: (m) => {
        var u;
        a || (u = m.dataTransfer) != null && u.items && !i(m.dataTransfer.items) || (m.preventDefault(), l(!0));
      },
      onDragLeave: () => l(!1),
      onDrop: (m) => {
        if (m.preventDefault(), l(!1), a) return;
        const u = Array.from(m.dataTransfer.files).filter((d) => c(d.type));
        u.length > 0 && e(u);
      }
    },
    o
  );
}
function EN({ images: e, onRemove: t, removeLabel: a, disabled: r }) {
  return /* @__PURE__ */ n.createElement("div", { className: Ba.thumbs }, e.map((o) => {
    var s;
    return /* @__PURE__ */ n.createElement("figure", { key: o.uid, className: Ba.thumb, title: (s = o.title) != null ? s : o.name }, /* @__PURE__ */ n.createElement("img", { src: o.previewUrl, alt: o.name }), /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => t(o.uid), "aria-label": a(o.name), disabled: r }, "×"), o.caption !== void 0 && /* @__PURE__ */ n.createElement("figcaption", null, o.caption));
  }));
}
const uh = "_box_dd9ol_1", mh = "_btn_dd9ol_2", dh = "_text_dd9ol_11", fh = "_caret_dd9ol_12", ph = "_pop_dd9ol_13", _h = "_off_dd9ol_22", Qt = {
  box: uh,
  btn: mh,
  text: dh,
  caret: fh,
  pop: ph,
  off: _h
}, jr = "\0all", On = 2, yh = 280;
function hh(e, t, a) {
  const r = e.filter((o) => t.includes(o.value));
  return r.length === 0 ? a : r.length === e.length && e.length > 1 ? "전체" : r.length <= 2 ? r.map((o) => o.label).join(", ") : `${r[0].label} 외 ${r.length - 1}`;
}
function bN(e) {
  const { label: t, disabled: a, className: r = "" } = e, [o, s] = D(!1), [l, c] = D(null), i = j(null), m = j(null), u = _e(() => {
    if (e.options === void 0) return { items: e.items, onToggle: e.onToggle, summary: e.summary };
    const { options: p, values: y, onChange: f, allLabel: b, placeholder: g = "선택" } = e, N = p.filter((w) => !w.disabled), E = N.length > 0 && N.every((w) => y.includes(w.value));
    return { items: [
      ...b != null ? [{ key: jr, label: b, checked: E }] : [],
      ...p.map((w) => ({ key: w.value, label: w.label, checked: y.includes(w.value), disabled: w.disabled }))
    ], onToggle: (w) => {
      if (w === jr) {
        f(E ? p.filter((A) => A.disabled && y.includes(A.value)).map((A) => A.value) : p.filter((A) => !A.disabled || y.includes(A.value)).map((A) => A.value));
        return;
      }
      const v = new Set(y);
      v.has(w) ? v.delete(w) : v.add(w), f(p.filter((A) => v.has(A.value)).map((A) => A.value));
    }, summary: hh(p, y, g) };
  }, [e]), d = oe(() => {
    const p = m.current;
    if (!p) return;
    const y = p.getBoundingClientRect(), f = window.innerHeight - y.bottom - On - 8, b = y.top - On - 8, g = f < 140 && b > f;
    c({
      left: Math.max(4, Math.min(y.left, window.innerWidth - Math.max(y.width, 140) - 4)),
      top: g ? y.top - On : y.bottom + On,
      minWidth: y.width,
      maxHeight: Math.max(80, Math.min(yh, g ? b : f)),
      up: g
    });
  }, []);
  ge(() => {
    o && d();
  }, [o, d]), U(() => {
    if (!o) return;
    const p = (b) => {
      var N, E;
      const g = b.target;
      (N = m.current) != null && N.contains(g) || (E = i.current) != null && E.contains(g) || s(!1);
    }, y = (b) => {
      var g;
      b.key !== "Escape" || b.isComposing || (b.stopPropagation(), s(!1), (g = m.current) == null || g.focus());
    }, f = (b) => {
      var g;
      b.target instanceof Node && ((g = i.current) != null && g.contains(b.target)) || d();
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", d), window.addEventListener("scroll", f, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", d), window.removeEventListener("scroll", f, !0);
    };
  }, [o, d]), U(() => {
    var p, y;
    o && l && ((y = (p = i.current) == null ? void 0 : p.querySelector("input:not(:disabled)")) == null || y.focus());
  }, [o, l === null]);
  const _ = (p) => {
    var g, N;
    if (p.key !== "ArrowDown" && p.key !== "ArrowUp") return;
    const y = Array.from((N = (g = i.current) == null ? void 0 : g.querySelectorAll("input:not(:disabled)")) != null ? N : []);
    if (y.length === 0) return;
    p.preventDefault();
    const f = y.indexOf(document.activeElement), b = p.key === "ArrowDown" ? Math.min(y.length - 1, f + 1) : Math.max(0, f - 1);
    y[b].focus();
  };
  return /* @__PURE__ */ n.createElement("div", { className: [Qt.box, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: m,
      type: "button",
      className: Qt.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": o,
      "aria-label": t,
      disabled: a,
      onClick: () => s((p) => !p),
      onKeyDown: (p) => {
        p.key === "ArrowDown" && !o && !a && (p.preventDefault(), s(!0));
      }
    },
    /* @__PURE__ */ n.createElement("span", { className: Qt.text }, u.summary),
    " ",
    /* @__PURE__ */ n.createElement("span", { className: Qt.caret, "aria-hidden": "true" }, "▾")
  ), o && l && Cn(
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: i,
        className: Qt.pop,
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": t,
        onKeyDown: _,
        style: { left: l.left, minWidth: l.minWidth, maxHeight: l.maxHeight, ...l.up ? { bottom: window.innerHeight - l.top } : { top: l.top } }
      },
      u.items.map((p) => /* @__PURE__ */ n.createElement("label", { key: p.key, className: p.disabled ? Qt.off : void 0 }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: p.checked, disabled: p.disabled, onChange: () => u.onToggle(p.key) }), p.label))
    ),
    document.body
  ));
}
function qa() {
  return globalThis.YukimushiI18n;
}
function Wn(e) {
  return e === "ja" || e === "en" ? e : "ko";
}
function Wt() {
  const [e, t] = D(() => {
    var a, r;
    return Wn((r = (a = qa()) == null ? void 0 : a.getLang) == null ? void 0 : r.call(a));
  });
  return U(() => {
    var r, o;
    const a = qa();
    if (a)
      return t(Wn((r = a.getLang) == null ? void 0 : r.call(a))), (o = a.subscribe) == null ? void 0 : o.call(a, (s) => t(Wn(s)));
  }, []), e;
}
function gN() {
  var e, t;
  return Wn((t = (e = qa()) == null ? void 0 : e.getLang) == null ? void 0 : t.call(e));
}
const Ja = "poc_portal_token", Xt = "poc_portal_refresh", La = "auth:session-expired", Eh = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Lo = Eh + "/chat-api/api/auth";
function vN(e) {
  e.authBase && (Lo = e.authBase);
}
function ia(e) {
  try {
    const t = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(t))));
  } catch {
    return {};
  }
}
function Dn(e, t = 30) {
  const a = ia(e).exp;
  return !a || a * 1e3 < Date.now() + t * 1e3;
}
function jo(e = 30) {
  const t = localStorage.getItem(Xt);
  if (!t) return !0;
  const a = ia(t).exp;
  return !!a && a * 1e3 < Date.now() + e * 1e3;
}
function Mn() {
  return localStorage.getItem(Ja);
}
function bh(e, t) {
  localStorage.setItem(Ja, e), t && localStorage.setItem(Xt, t);
}
function gh() {
  localStorage.removeItem(Ja), localStorage.removeItem(Xt), Io();
}
function En(e) {
  if (e !== void 0) {
    const t = localStorage.getItem(Xt);
    if (t && t !== e) return !1;
  }
  return gh(), window.dispatchEvent(new Event(La)), !0;
}
function kN(e) {
  return window.addEventListener(La, e), () => window.removeEventListener(La, e);
}
let bn = null;
const vh = 2147483647;
function kh() {
  if (Io(), jo()) {
    En();
    return;
  }
  const e = localStorage.getItem(Xt), t = e ? ia(e).exp : void 0;
  if (!t) return;
  const a = Math.min(Math.max(t * 1e3 - Date.now() - 30 * 1e3, 0), vh);
  bn = setTimeout(() => {
    bn = null, kh();
  }, a);
}
function Io() {
  bn !== null && (clearTimeout(bn), bn = null);
}
let Fn = null;
const wh = "poc_portal_refresh_lock";
async function Nh(e) {
  const t = typeof navigator != "undefined" ? navigator.locks : void 0;
  return t ? t.request(wh, e) : e();
}
function Ro(e) {
  return Fn || (Fn = $h(e)), Fn;
}
async function $h(e) {
  try {
    return await Nh(async () => {
      const t = Mn();
      return t && !Dn(t) && t !== e ? t : await Po(!1);
    });
  } finally {
    Fn = null;
  }
}
async function Po(e) {
  const t = localStorage.getItem(Xt);
  if (!t)
    return En(), null;
  let a;
  try {
    a = await fetch(Lo + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok) {
    if (a.status >= 500) return null;
    const o = localStorage.getItem(Xt), s = Mn();
    if (o && o !== t) {
      if (s && !Dn(s)) return s;
      if (!e) return Po(!0);
    }
    return En(t), null;
  }
  const r = await a.json().catch(() => ({}));
  return r.access_token ? (bh(r.access_token, r.refresh_token), r.access_token) : (En(t), null);
}
async function xh() {
  if (jo())
    return En(), null;
  const e = Mn();
  return e && !Dn(e) ? e : Ro();
}
const Zn = "poc_portal_active_aff:", Ah = "X-Active-Com", Dh = "X-Active-Dept";
function Za(e = Mn()) {
  return e && ia(e).preferred_username || null;
}
function ja(e) {
  if (!e) return null;
  try {
    const t = JSON.parse(e);
    if (Number.isInteger(t == null ? void 0 : t.comSq) && typeof (t == null ? void 0 : t.deptCd) == "string" && t.deptCd)
      return { comSq: t.comSq, deptCd: t.deptCd };
  } catch {
  }
  return null;
}
function Sh(e = Za()) {
  if (!e) return null;
  try {
    return ja(localStorage.getItem(Zn + e));
  } catch {
    return null;
  }
}
function wN(e, t) {
  if (e)
    try {
      t ? localStorage.setItem(Zn + e, JSON.stringify(t)) : localStorage.removeItem(Zn + e);
    } catch {
    }
}
function NN(e) {
  const t = (a) => {
    const r = Za();
    if (!r || a.key !== Zn + r) return;
    const o = ja(a.oldValue), s = ja(a.newValue);
    (o == null ? void 0 : o.comSq) === (s == null ? void 0 : s.comSq) && (o == null ? void 0 : o.deptCd) === (s == null ? void 0 : s.deptCd) || e(s, o);
  };
  return window.addEventListener("storage", t), () => window.removeEventListener("storage", t);
}
function Ch(e) {
  const t = Sh(Za(e));
  return t ? { [Ah]: String(t.comSq), [Dh]: t.deptCd } : {};
}
async function Xo(e, t = {}) {
  const a = (s) => {
    var u;
    const l = (u = t.headers) != null ? u : {}, c = Object.keys(l).map((d) => d.toLowerCase()), i = Ch(s), m = {};
    return Object.keys(i).forEach((d) => {
      c.indexOf(d.toLowerCase()) < 0 && (m[d] = i[d]);
    }), {
      ...t,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...m }
    };
  }, r = await xh();
  let o = await fetch(e, a(r));
  if (o.status === 401 && r) {
    const s = await Th(r);
    s && (o = await fetch(e, a(s)));
  }
  return o;
}
const Mh = 3e4;
let Ir = 0;
async function Th(e) {
  const t = Mn();
  if (t && t !== e && !Dn(t)) return t;
  if (!Dn(e)) {
    const a = Date.now();
    if (a - Ir < Mh) return null;
    Ir = a;
  }
  return Ro(e);
}
const Xe = (e) => typeof e == "string" ? e : "", va = (e) => typeof e == "number" && Number.isFinite(e) ? e : Number(e) || 0;
function Bh(e) {
  return Array.isArray(e) ? e.map((t) => ({ code: Xe(t == null ? void 0 : t.code), level: (t == null ? void 0 : t.level) === "E" ? "E" : "W", msg: Xe(t == null ? void 0 : t.msg) })) : [];
}
function qh(e) {
  const t = e != null ? e : {};
  return {
    ready: t.ready === !0,
    etaxVer: Xe(t.etaxVer) || Xe(t.procVer),
    shaVer: Xe(t.shaVer) || Xe(t.formVer),
    issues: Bh(t.issues)
  };
}
function Lh(e) {
  return Array.isArray(e) ? e.map((t) => {
    var a;
    return {
      seq: va((a = t.xmlSq) != null ? a : t.genSq),
      etaxVer: Xe(t.etaxVer) || Xe(t.procVer),
      shaVer: Xe(t.formVer) || null,
      fileNm: Xe(t.fileNm),
      sha256: Xe(t.sha256),
      byteQt: va(t.byteQt),
      warnQt: va(t.warnQt),
      insertId: typeof t.insertId == "string" ? t.insertId : null,
      insertDt: typeof t.insertDt == "string" ? t.insertDt : null
    };
  }) : [];
}
async function Oo(e) {
  let t = null;
  try {
    t = await e.json();
  } catch {
  }
  const a = Xe(t == null ? void 0 : t.detail).trim() || Xe(t == null ? void 0 : t.error).trim();
  return !a || a === (t == null ? void 0 : t.title) || /^[A-Za-z ]+$/.test(a) ? null : a;
}
class zo extends Error {
  constructor(t, a) {
    super(a), this.name = "AXErpEtaxError", this.status = t;
  }
}
async function Rr(e, t, a) {
  var o;
  const r = await Xo(e);
  if (!r.ok) throw new zo(r.status, (o = await Oo(r)) != null ? o : Co(r.status, t));
  return a(await r.json());
}
async function jh(e, t, a) {
  var s, l, c;
  const r = await Xo(e, { method: "POST" });
  if (!r.ok) throw new zo(r.status, (s = await Oo(r)) != null ? s : Co(r.status, a));
  const o = To(r, t);
  return await Ry(r, t, o), { fileNm: o, sha256: (l = r.headers.get("X-Xml-Sha256")) != null ? l : "", warnQt: Number((c = r.headers.get("X-Xml-Warn-Count")) != null ? c : 0) || 0 };
}
const Ih = "_meta_1b3r6_2", Rh = "_hint_1b3r6_3", Ph = "_code_1b3r6_4", Xh = "_slot_1b3r6_5", Oh = "_num_1b3r6_6", Mt = {
  meta: Ih,
  hint: Rh,
  code: Ph,
  slot: Xh,
  num: Oh
}, zh = {
  ko: {
    title: "e-Tax 신고 데이터(XML)",
    check: "다시 점검",
    gen: "XML 받기",
    checking: "점검 중입니다",
    working: "처리 중입니다",
    ready: "만들 수 있습니다",
    notReady: "만들 수 없습니다",
    ver: "판",
    forms: "싣는 서식",
    issues: "점검 결과",
    noIssues: "점검에서 나온 항목이 없습니다",
    errBlock: "오류가 있으면 파일을 만들지 않습니다 — 아래 내용을 고친 뒤 다시 점검하세요.",
    blocked: "점검 오류가 있어 만들 수 없습니다",
    levelE: "오류",
    levelW: "알림",
    colLevel: "구분",
    colCode: "코드",
    colMsg: "내용",
    saved: (e, t) => `XML 을 내려받았습니다 — ${e}${t ? ` (알림 ${t}건)` : ""}`,
    history: "만든 이력",
    historyEmpty: "아직 만든 적이 없습니다",
    colSeq: "순번",
    colAt: "만든 일시",
    colVer: "판",
    colFile: "파일명",
    colHash: "검증값",
    colWarn: "알림 수",
    colBy: "만든 사람",
    what: { preflight: "e-Tax XML 점검", history: "e-Tax XML 생성 이력", generate: "e-Tax XML 생성" }
  },
  ja: {
    title: "e-Tax申告データ(XML)",
    check: "再点検",
    gen: "XMLを保存",
    checking: "点検中です",
    working: "処理中です",
    ready: "作成できます",
    notReady: "作成できません",
    ver: "バージョン",
    forms: "載せる様式",
    issues: "点検結果",
    noIssues: "点検で指摘された項目はありません",
    errBlock: "エラーがあるとファイルを作成しません — 下記を修正してから再点検してください。",
    blocked: "点検エラーがあるため作成できません",
    levelE: "エラー",
    levelW: "お知らせ",
    colLevel: "区分",
    colCode: "コード",
    colMsg: "内容",
    saved: (e, t) => `XMLを保存しました — ${e}${t ? `(お知らせ${t}件)` : ""}`,
    history: "作成履歴",
    historyEmpty: "まだ作成していません",
    colSeq: "連番",
    colAt: "作成日時",
    colVer: "バージョン",
    colFile: "ファイル名",
    colHash: "検証値",
    colWarn: "お知らせ数",
    colBy: "作成者",
    what: { preflight: "e-Tax XMLの点検", history: "e-Tax XMLの作成履歴", generate: "e-Tax XMLの作成" }
  },
  en: {
    title: "e-Tax filing data (XML)",
    check: "Check again",
    gen: "Get XML",
    checking: "Checking",
    working: "Processing",
    ready: "Ready to create",
    notReady: "Cannot be created",
    ver: "Version",
    forms: "Forms included",
    issues: "Check results",
    noIssues: "No findings from the check",
    errBlock: "No file is created while there are errors — fix the items below and check again.",
    blocked: "Cannot be created because of check errors",
    levelE: "Error",
    levelW: "Notice",
    colLevel: "Level",
    colCode: "Code",
    colMsg: "Details",
    saved: (e, t) => `XML downloaded — ${e}${t ? ` (${t} notices)` : ""}`,
    history: "Creation history",
    historyEmpty: "Nothing created yet",
    colSeq: "No.",
    colAt: "Created at",
    colVer: "Version",
    colFile: "File name",
    colHash: "Checksum",
    colWarn: "Notices",
    colBy: "Created by",
    what: { preflight: "e-Tax XML check", history: "e-Tax XML history", generate: "e-Tax XML creation" }
  }
}, Hh = (e) => e ? Td(e).slice(0, 16) : "—";
function $N({
  preflightUrl: e,
  historyUrl: t,
  generateUrl: a,
  fallbackFileName: r = "etax.xml",
  title: o,
  hint: s,
  children: l,
  reloadKey: c,
  showCode: i = !0,
  onGenerated: m,
  blockedReason: u
}) {
  var te, h, S;
  const d = zh[Wt()], [_, p] = yy(), [y, f] = D(null), [b, g] = D(!0), [N, E] = D(null), [$, k] = D(null), [w, v] = D(null), [A, C] = D(null), M = j(!0), B = j(0);
  U(() => (M.current = !0, () => {
    M.current = !1;
  }), []);
  const I = oe((P = !1) => {
    const H = ++B.current, J = () => M.current && H === B.current;
    g(!0), P || (v(null), C(null)), Rr(e, d.what.preflight, qh).then((q) => {
      J() && f(q);
    }).catch((q) => {
      J() && (f(null), v(q.message));
    }).finally(() => {
      J() && g(!1);
    }), Rr(t, d.what.history, Lh).then((q) => {
      J() && (E(q), k(null));
    }).catch((q) => {
      J() && (E(null), k(q.message));
    });
  }, [e, t, d]);
  U(() => {
    I();
  }, [I, c]);
  const T = (te = y == null ? void 0 : y.issues.filter((P) => P.level === "E")) != null ? te : [], z = [...T, ...(h = y == null ? void 0 : y.issues.filter((P) => P.level !== "E")) != null ? h : []], G = _ ? d.working : b ? d.checking : u || (y ? y.ready ? void 0 : ((S = T[0]) == null ? void 0 : S.msg) || d.blocked : w != null ? w : d.notReady), K = () => {
    G || p(async () => {
      try {
        const P = await jh(a, r, d.what.generate);
        if (!M.current) return;
        v(null), C(d.saved(P.fileNm, P.warnQt)), m == null || m(P), I(!0);
      } catch (P) {
        if (!M.current) return;
        C(null), v(P.message), I(!0);
      }
    });
  }, R = i ? [80, 110, null] : [80, null], ne = [60, 150, 110, null, 110, 70, 110];
  return /* @__PURE__ */ n.createElement(
    Va,
    {
      title: o != null ? o : d.title,
      trailing: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Fe, { size: "sm", onClick: () => I(), blockedReason: _ ? d.working : b ? d.checking : void 0 }, d.check), /* @__PURE__ */ n.createElement(Fe, { size: "sm", variant: "primary", onClick: K, blockedReason: G }, d.gen))
    },
    s && /* @__PURE__ */ n.createElement("p", { className: Mt.hint }, s),
    l && /* @__PURE__ */ n.createElement("div", { className: Mt.slot }, l),
    w && /* @__PURE__ */ n.createElement(fn, { tone: "warn" }, w),
    A && /* @__PURE__ */ n.createElement(fn, { tone: "info" }, A),
    y && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("p", { className: Mt.meta, "aria-label": d.issues }, /* @__PURE__ */ n.createElement(hn, { tone: y.ready ? "ok" : "warn" }, y.ready ? d.ready : d.notReady), y.etaxVer && /* @__PURE__ */ n.createElement(hn, { tone: "muted" }, d.ver, " ", y.etaxVer)), y.shaVer && /* @__PURE__ */ n.createElement("p", { className: Mt.hint }, d.forms, ": ", y.shaVer), !y.ready && /* @__PURE__ */ n.createElement(fn, { tone: "danger" }, d.errBlock), /* @__PURE__ */ n.createElement(Sa, { cols: R, "aria-label": d.issues, title: d.issues }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("th", null, d.colLevel), i && /* @__PURE__ */ n.createElement("th", null, d.colCode), /* @__PURE__ */ n.createElement("th", null, d.colMsg))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(Vn, { colSpan: R.length, count: z.length, empty: d.noIssues }), z.map((P, H) => /* @__PURE__ */ n.createElement("tr", { key: `${P.code}-${H}` }, /* @__PURE__ */ n.createElement("td", { className: "axe-c" }, /* @__PURE__ */ n.createElement(hn, { tone: P.level === "E" ? "warn" : "muted" }, P.level === "E" ? d.levelE : d.levelW)), i && /* @__PURE__ */ n.createElement("td", { className: `axe-l ${Mt.code}` }, P.code), /* @__PURE__ */ n.createElement("td", { className: "axe-l" }, P.msg)))))),
    $ && /* @__PURE__ */ n.createElement(fn, { tone: "warn" }, $),
    /* @__PURE__ */ n.createElement(Sa, { cols: ne, "aria-label": d.history, title: d.history }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("th", null, d.colSeq), /* @__PURE__ */ n.createElement("th", null, d.colAt), /* @__PURE__ */ n.createElement("th", null, d.colVer), /* @__PURE__ */ n.createElement("th", null, d.colFile), /* @__PURE__ */ n.createElement("th", null, d.colHash), /* @__PURE__ */ n.createElement("th", null, d.colWarn), /* @__PURE__ */ n.createElement("th", null, d.colBy))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(Vn, { colSpan: ne.length, count: N ? N.length : null, error: $ ? !0 : void 0, empty: d.historyEmpty }), (N != null ? N : []).map((P) => {
      var H, J;
      return /* @__PURE__ */ n.createElement("tr", { key: P.seq }, /* @__PURE__ */ n.createElement("td", { className: "axe-c" }, P.seq), /* @__PURE__ */ n.createElement("td", { className: "axe-c" }, Hh(P.insertDt)), /* @__PURE__ */ n.createElement("td", { className: "axe-l", title: (H = P.shaVer) != null ? H : void 0 }, P.etaxVer), /* @__PURE__ */ n.createElement("td", { className: "axe-l" }, P.fileNm), /* @__PURE__ */ n.createElement("td", { className: `axe-l ${Mt.num}`, title: P.sha256 }, P.sha256.slice(0, 12)), /* @__PURE__ */ n.createElement("td", { className: `axe-r ${Mt.num}` }, P.warnQt), /* @__PURE__ */ n.createElement("td", { className: "axe-l" }, (J = P.insertId) != null ? J : ""));
    })))
  );
}
const Wh = "_card_krkjh_1", Fh = "_sub_krkjh_2", Kh = "_state_krkjh_3", Vh = "_list_krkjh_7", Uh = "_row_krkjh_8", Gh = "_warn_krkjh_21", Yh = "_danger_krkjh_22", Tt = {
  card: Wh,
  sub: Fh,
  state: Kh,
  list: Vh,
  row: Uh,
  warn: Gh,
  danger: Yh
};
function xN({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Va,
    {
      flush: !0,
      className: [Tt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: Tt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: Tt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: Tt.state }, /* @__PURE__ */ n.createElement(Do, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(Ha, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: Tt.list }, c.map((m, u) => {
      var p, y;
      const d = [Tt.row, m.tone ? Tt[m.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (p = m.key) != null ? p : u, className: d, onClick: m.onClick }, _) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: d }, _);
    }))
  );
}
function Qh(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const Jh = "_group_44kzq_1", Zh = "_tile_44kzq_2", eE = "_click_44kzq_9", tE = "_pressed_44kzq_13", nE = "_ok_44kzq_14", aE = "_warn_44kzq_15", rE = "_danger_44kzq_16", oE = "_info_44kzq_17", sE = "_accent_44kzq_18", lE = "_muted_44kzq_19", cE = "_label_44kzq_20", iE = "_value_44kzq_22", uE = "_desc_44kzq_27", wt = {
  group: Jh,
  tile: Zh,
  click: eE,
  pressed: tE,
  ok: nE,
  warn: aE,
  danger: rE,
  info: oE,
  accent: sE,
  muted: lE,
  label: cE,
  value: iE,
  desc: uE
};
function AN({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const m = [wt.tile, wt[o], s ? wt.click : "", s && l ? wt.pressed : "", i].filter(Boolean).join(" "), u = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: wt.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: wt.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: wt.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: m, onClick: s, "aria-pressed": l, title: c, "data-csv-kv": "" }, u) : /* @__PURE__ */ n.createElement("div", { className: m, title: c, "data-csv-kv": "" }, u);
}
const mE = 150, dE = 12, fE = 8;
function DN({ children: e, columns: t, className: a = "" }) {
  const r = j(null), o = Aa.toArray(e).filter(kn).length, s = t != null || o <= fE, [l, c] = D(null);
  ge(() => {
    const u = r.current;
    if (!s || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const d = new ResizeObserver(() => c(u.clientWidth));
    return d.observe(u), () => d.disconnect();
  }, [s]);
  const i = s ? Qh(o, l != null ? l : Number.MAX_SAFE_INTEGER, mE, dE, t) : 0, m = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [wt.group, a].filter(Boolean).join(" "), style: m }, e);
}
const pE = "_card_nvp4o_1", _E = "_n_nvp4o_2", yE = "_list_nvp4o_7", hE = "_item_nvp4o_8", EE = "_row_nvp4o_9", bE = "_launch_nvp4o_14", gE = "_tabBtn_nvp4o_17", vE = "_starBtn_nvp4o_17", kE = "_on_nvp4o_21", wE = "_name_nvp4o_23", NE = "_empty_nvp4o_24", $E = "_star_nvp4o_17", xE = "_clear_nvp4o_34", je = {
  card: pE,
  n: _E,
  list: yE,
  item: hE,
  row: EE,
  launch: bE,
  tabBtn: gE,
  starBtn: vE,
  on: kE,
  name: wE,
  empty: NE,
  star: $E,
  clear: xE
}, AE = {
  ko: {
    title: "빠른 메뉴",
    mine: "마이메뉴",
    recent: "최근 사용",
    clearRecent: "목록 비우기",
    openNewTab: "새 탭으로 열기",
    removeMine: "마이메뉴에서 삭제",
    emptyMine: "아직 추가한 메뉴가 없습니다",
    emptyRecent: "최근 사용한 메뉴가 없습니다",
    emptyRecentHint: "메뉴를 실행하면 최근 사용 목록에 표시됩니다",
    mineHint: "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다"
  },
  ja: {
    title: "クイックメニュー",
    mine: "マイメニュー",
    recent: "最近使用",
    clearRecent: "履歴を消去",
    openNewTab: "新しいタブで開く",
    removeMine: "マイメニューから削除",
    emptyMine: "まだ追加したメニューがありません",
    emptyRecent: "最近使用したメニューがありません",
    emptyRecentHint: "メニューを実行すると最近使用の一覧に表示されます",
    mineHint: "メニュー一覧で ☆ を押すとここに追加されます"
  },
  en: {
    title: "Quick menu",
    mine: "My Menu",
    recent: "Recent",
    clearRecent: "Clear list",
    openNewTab: "Open in new tab",
    removeMine: "Remove from My Menu",
    emptyMine: "No menus added yet",
    emptyRecent: "No recently used menus",
    emptyRecentHint: "Menus you open will appear in this list",
    mineHint: "Press ☆ in the menu list to add it here"
  }
};
function DE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function SE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function SN({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  onRemoveMine: o,
  onOpenNewTab: s,
  mineHint: l,
  labels: c,
  className: i = ""
}) {
  const m = Wt(), u = { ...AE[m], ...c }, d = l != null ? l : u.mineHint, [_, p] = D("mine"), y = _ === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Va,
    {
      flush: !0,
      className: [je.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        io,
        {
          variant: "segmented",
          "aria-label": u.title,
          value: _,
          onChange: (f) => p(f),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, u.mine, e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, u.recent, t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, t.length)) }
          ]
        }
      ),
      trailing: _ === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(Ha, { className: je.clear, onClick: r }, u.clearRecent) : void 0
    },
    y.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: je.list }, y.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.path, className: je.item }, /* @__PURE__ */ n.createElement("button", { type: "button", className: je.row, onClick: () => a(f) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.launch }, /* @__PURE__ */ n.createElement(DE, null)), /* @__PURE__ */ n.createElement("span", { className: je.name }, f.label)), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: je.tabBtn,
        "aria-label": `${f.label} ${u.openNewTab}`,
        title: u.openNewTab,
        onClick: () => s ? s(f) : window.open(f.path, "_blank", "noopener")
      },
      /* @__PURE__ */ n.createElement(SE, null)
    ), _ === "mine" && o && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: `${je.starBtn} ${je.on}`,
        "aria-pressed": !0,
        "aria-label": `${f.label} ${u.removeMine}`,
        title: u.removeMine,
        onClick: () => o(f)
      },
      "★"
    )))) : /* @__PURE__ */ n.createElement("div", { className: je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, _ === "mine" ? u.emptyMine : u.emptyRecent), /* @__PURE__ */ n.createElement("p", null, _ === "mine" ? d : u.emptyRecentHint))
  );
}
function Pr(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function ka(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function CN({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = D(() => Pr(e)), [s, l] = D(() => Pr(t)), c = oe((d) => r.some((_) => _.path === d), [r]), i = oe((d) => o((_) => {
    const p = _.some((y) => y.path === d.path) ? _.filter((y) => y.path !== d.path) : [..._, d];
    return ka(e, p), p;
  }), [e]), m = oe((d) => l((_) => {
    const p = [d, ..._.filter((y) => y.path !== d.path)].slice(0, a);
    return ka(t, p), p;
  }), [t, a]), u = oe(() => {
    l([]), ka(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const CE = "_banner_7tqhk_2", ME = "_heading_7tqhk_7", TE = "_sparkleBox_7tqhk_8", BE = "_eyebrow_7tqhk_12", qE = "_headline_7tqhk_13", LE = "_desc_7tqhk_15", jE = "_err_7tqhk_16", IE = "_chips_7tqhk_18", RE = "_footer_7tqhk_28", PE = "_kicker_7tqhk_35", XE = "_list_7tqhk_36", OE = "_row_7tqhk_37", zE = "_icon_7tqhk_39", HE = "_text_7tqhk_40", WE = "_cap_7tqhk_41", FE = "_body_7tqhk_43", KE = "_reason_7tqhk_44", VE = "_empty_7tqhk_45", Ee = {
  banner: CE,
  heading: ME,
  sparkleBox: TE,
  eyebrow: BE,
  headline: qE,
  desc: LE,
  err: jE,
  chips: IE,
  footer: RE,
  kicker: PE,
  list: XE,
  row: OE,
  icon: zE,
  text: HE,
  cap: WE,
  body: FE,
  reason: KE,
  empty: VE
};
function Xr({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const ua = {
  ko: {
    all: "전체 업무 제안 보기",
    count: (e) => `${e}건`,
    more: (e) => `+${e}종류 더`,
    noneLeft: "남은 제안이 없습니다.",
    run: "실행",
    skip: "무시",
    kicker: "ProActive AI 업무 제안",
    failed: "처리하지 못했습니다. 잠시 후 다시 시도하세요.",
    close: "닫기",
    cardsHead: "지금 처리할 수 있는 업무를 발견했습니다",
    cardsEmpty: "지금은 처리할 업무 제안이 없습니다.",
    cardsLoading: "업무 제안을 확인하고 있습니다.",
    detail: "상세 보기"
  },
  ja: {
    all: "すべての業務提案を見る",
    count: (e) => `${e}件`,
    more: (e) => `+${e}種類`,
    noneLeft: "残りの提案はありません。",
    run: "実行",
    skip: "無視",
    kicker: "ProActive AI 業務提案",
    failed: "処理できませんでした。しばらくしてからもう一度お試しください。",
    close: "閉じる",
    cardsHead: "今すぐ処理できる業務が見つかりました",
    cardsEmpty: "現在、処理する業務提案はありません。",
    cardsLoading: "業務提案を確認しています。",
    detail: "詳細を見る"
  },
  en: {
    all: "View all task suggestions",
    count: (e) => `${e}`,
    more: (e) => `+${e} more types`,
    noneLeft: "No suggestions left.",
    run: "Run",
    skip: "Dismiss",
    kicker: "ProActive AI Task Suggestions",
    failed: "Could not process. Please try again shortly.",
    close: "Close",
    cardsHead: "Found tasks you can handle now",
    cardsEmpty: "No task suggestions right now.",
    cardsLoading: "Checking task suggestions.",
    detail: "View details"
  }
}, UE = {
  "index-to-rag": { ko: "AI 검색 등록", ja: "AI検索への登録", en: "Add to AI search" },
  "translate-content": { ko: "번역 제안", ja: "翻訳の提案", en: "Translation suggestion" },
  "draft-post": { ko: "공지 초안 작성", ja: "お知らせ下書きの作成", en: "Draft an announcement" },
  "deadline-reminder": { ko: "마감 알림", ja: "締切の通知", en: "Deadline reminder" },
  "dedupe-file-upload": { ko: "중복 파일 정리", ja: "重複ファイルの整理", en: "Clean up duplicate files" },
  "payment-deadline-review": { ko: "법정 지급 한도 점검", ja: "法定支払期限の確認", en: "Statutory payment deadline check" },
  "contract-notice-review": { ko: "계약 통지 기한 점검", ja: "契約通知期限の確認", en: "Contract notice deadline check" },
  "supply-reorder-review": { ko: "소모품 재주문 점검", ja: "消耗品の再発注確認", en: "Supplies reorder check" },
  "filing-due-review": { ko: "세무 신고기한 점검", ja: "税務申告期限の確認", en: "Tax filing deadline check" }
};
function MN(e, t) {
  var s;
  const a = e ? UE[e] : void 0;
  if (!a) return t;
  const r = globalThis.YukimushiI18n, o = (s = r == null ? void 0 : r.getLang) == null ? void 0 : s.call(r);
  return a[o === "ja" || o === "en" ? o : "ko"];
}
function TN({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m,
  allDisabled: u,
  className: d = ""
}) {
  const _ = ua[Wt()], p = o.slice(0, s), y = o.length - p.length;
  return /* @__PURE__ */ n.createElement("section", { className: [Ee.banner, d].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Ee.heading }, /* @__PURE__ */ n.createElement("span", { className: Ee.sparkleBox }, /* @__PURE__ */ n.createElement(Xr, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: Ee.eyebrow }, /* @__PURE__ */ n.createElement(Xr, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: Ee.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [Ee.desc, r ? Ee.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Ee.chips }, p.map((f) => /* @__PURE__ */ n.createElement("button", { type: "button", key: f.key, title: f.label, onClick: () => l(f.key) }, /* @__PURE__ */ n.createElement("i", { style: f.color ? { background: f.color } : void 0, "aria-hidden": "true" }), f.label, " ", /* @__PURE__ */ n.createElement("strong", { style: f.color ? { color: f.color } : void 0 }, _.count(f.count)))), y > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, _.more(y))), /* @__PURE__ */ n.createElement("div", { className: Ee.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? Ee.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(Ha, { onClick: () => l(null), disabled: u }, m != null ? m : _.all, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function GE({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o }) {
  const s = ua[Wt()];
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: Ee.empty }, o != null ? o : s.noneLeft) : /* @__PURE__ */ n.createElement("ul", { className: Ee.list }, e.map((l) => {
    var c, i;
    return /* @__PURE__ */ n.createElement("li", { key: l.id, className: Ee.row }, /* @__PURE__ */ n.createElement("span", { className: Ee.icon, "aria-hidden": "true" }, (c = l.icon) != null ? c : "💡"), /* @__PURE__ */ n.createElement("div", { className: Ee.text }, /* @__PURE__ */ n.createElement("div", { className: Ee.cap }, l.title, l.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", l.meta) : null), /* @__PURE__ */ n.createElement("div", { className: Ee.body }, l.body), l.reason ? /* @__PURE__ */ n.createElement("div", { className: Ee.reason }, l.reason) : null), /* @__PURE__ */ n.createElement(Fe, { size: "sm", variant: "primary", disabled: r, onClick: () => t(l) }, (i = l.actionLabel) != null ? i : s.run), /* @__PURE__ */ n.createElement(Fe, { size: "sm", disabled: r, onClick: () => a(l) }, s.skip));
  }));
}
function BN({ title: e, kicker: t, items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = ua[Wt()], c = j(!1), [i, m] = D(!1), [u, d] = D(""), _ = async (p) => {
    if (!c.current) {
      c.current = !0, m(!0), d("");
      try {
        await p();
      } catch {
        d(l.failed);
      } finally {
        c.current = !1, m(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    ca,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: Ee.kicker }, "✦ ", t != null ? t : l.kicker),
      error: u,
      footer: /* @__PURE__ */ n.createElement(Fe, { onClick: r }, l.close)
    },
    /* @__PURE__ */ n.createElement(GE, { items: a, busy: i, onRun: (p) => _(() => o(p)), onSkip: (p) => _(() => s(p)) })
  );
}
const YE = "_wrap_1wvdc_2", QE = "_header_1wvdc_7", JE = "_iconBox_1wvdc_8", ZE = "_headText_1wvdc_12", eb = "_eyebrow_1wvdc_13", tb = "_headline_1wvdc_14", nb = "_headerExtra_1wvdc_16", ab = "_grid_1wvdc_19", rb = "_card_1wvdc_20", ob = "_badge_1wvdc_29", sb = "_toneRed_1wvdc_33", lb = "_toneViolet_1wvdc_34", cb = "_toneGreen_1wvdc_35", ib = "_toneBlue_1wvdc_36", ub = "_title_1wvdc_38", mb = "_summary_1wvdc_42", db = "_action_1wvdc_46", fb = "_notice_1wvdc_53", pb = "_err_1wvdc_56", fe = {
  wrap: YE,
  header: QE,
  iconBox: JE,
  headText: ZE,
  eyebrow: eb,
  headline: tb,
  headerExtra: nb,
  grid: ab,
  card: rb,
  badge: ob,
  toneRed: sb,
  toneViolet: lb,
  toneGreen: cb,
  toneBlue: ib,
  title: ub,
  summary: mb,
  action: db,
  notice: fb,
  err: pb
};
function Or({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const _b = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function qN({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r,
  error: o,
  loading: s,
  emptyText: l,
  headerExtra: c,
  className: i = ""
}) {
  const m = ua[Wt()];
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(Or, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r != null ? r : m.cardsHead)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, m.cardsLoading) : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l != null ? l : m.cardsEmpty) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((u) => {
    var d, _;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: u.id, className: fe.card, onClick: () => t(u) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, _b[(d = u.tone) != null ? d : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Or, { size: 9 }), u.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, u.title), u.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof u.summary == "string" ? u.summary : void 0 }, u.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (_ = u.actionLabel) != null ? _ : m.detail, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const yb = "_wrapper_1j5pd_1", hb = "_searchIcon_1j5pd_17", Eb = "_input_1j5pd_25", bb = "_clearButton_1j5pd_39", gb = "_hint_1j5pd_59", mn = {
  wrapper: yb,
  searchIcon: hb,
  input: Eb,
  clearButton: bb,
  hint: gb
}, vb = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function kb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: `${mn.wrapper} axe-focus-box` }, /* @__PURE__ */ n.createElement("span", { className: mn.searchIcon }, vb), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: mn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: mn.clearButton,
      onClick: s,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: mn.hint }, r));
}
const wb = "_screen_sizmw_1", Nb = "_shell_sizmw_8", $b = "_command_sizmw_10", xb = "_body_sizmw_20", Ab = "_overview_sizmw_22", Db = "_areaHead_sizmw_25", Sb = "_hintPart_sizmw_28", Cb = "_hintIcon_sizmw_29", $t = {
  screen: wb,
  shell: Nb,
  command: $b,
  body: xb,
  overview: Ab,
  areaHead: Db,
  hintPart: Sb,
  hintIcon: Cb
};
function LN({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [$t.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: $t.shell }, e && /* @__PURE__ */ n.createElement("div", { className: $t.command }, /* @__PURE__ */ n.createElement(
    kb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: $t.body }, a)));
}
function jN({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [$t.overview, t].filter(Boolean).join(" ") }, e);
}
function Mb() {
  return /* @__PURE__ */ n.createElement("svg", { className: $t.hintIcon, width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Tb(e) {
  return typeof e != "string" || e.indexOf("↗") < 0 ? e : e.split("↗").map((a, r) => /* @__PURE__ */ n.createElement("span", { key: r, className: $t.hintPart }, r > 0 && /* @__PURE__ */ n.createElement(Mb, null), a));
}
function IN({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: $t.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, Tb(t)));
}
const Bb = "_group_oodts_1", qb = "_grid_oodts_7", Lb = "_row_oodts_8", jb = "_item_oodts_9", Ib = "_launch_oodts_14", Rb = "_name_oodts_17", Pb = "_desc_oodts_18", Xb = "_badge_oodts_19", Ob = "_disabled_oodts_23", zb = "_tab_oodts_25", Hb = "_star_oodts_25", Wb = "_on_oodts_30", Fb = "_empty_oodts_32", Pe = {
  group: Bb,
  grid: qb,
  row: Lb,
  item: jb,
  launch: Ib,
  name: Rb,
  desc: Pb,
  badge: Xb,
  disabled: Ob,
  tab: zb,
  star: Hb,
  on: Wb,
  empty: Fb
}, Kb = {
  ko: { openNewTab: "새 탭으로 열기", addMine: "마이메뉴에 추가", removeMine: "마이메뉴에서 삭제" },
  ja: { openNewTab: "新しいタブで開く", addMine: "マイメニューに追加", removeMine: "マイメニューから削除" },
  en: { openNewTab: "Open in new tab", addMine: "Add to My Menu", removeMine: "Remove from My Menu" }
};
function Vb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Ub() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function RN({ title: e, items: t, emptyText: a, labels: r, className: o = "" }) {
  const s = Wt(), l = { ...Kb[s], ...r };
  return /* @__PURE__ */ n.createElement("section", { className: [Pe.group, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Pe.grid }, t.map((c) => /* @__PURE__ */ n.createElement("div", { className: Pe.row, key: c.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.item, c.disabled ? Pe.disabled : ""].filter(Boolean).join(" "),
      disabled: c.disabled,
      onClick: c.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Pe.launch }, /* @__PURE__ */ n.createElement(Vb, null)),
    /* @__PURE__ */ n.createElement("span", { className: Pe.name }, c.label),
    c.desc && /* @__PURE__ */ n.createElement("span", { className: Pe.desc }, c.desc),
    c.badge != null && /* @__PURE__ */ n.createElement("em", { className: Pe.badge }, c.badge)
  ), c.onOpenNewTab && !c.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Pe.tab,
      "aria-label": `${c.label} ${l.openNewTab}`,
      title: l.openNewTab,
      onClick: c.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Ub, null)
  ), c.onToggleStar && !c.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.star, c.starred ? Pe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!c.starred,
      "aria-label": `${c.label} ${c.starred ? l.removeMine : l.addMine}`,
      onClick: c.onToggleStar
    },
    c.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Pe.empty }, a)));
}
const Gb = "_strip_8zhai_2", Yb = "_day_8zhai_9", Qb = "_total_8zhai_10", Jb = "_sel_8zhai_31", Zb = "_today_8zhai_35", eg = "_md_8zhai_35", tg = "_off_8zhai_36", ng = "_head_8zhai_45", ag = "_wd_8zhai_46", rg = "_sun_8zhai_47", og = "_sat_8zhai_48", sg = "_lock_8zhai_50", lg = "_value_8zhai_60", cg = "_mark_8zhai_66", ig = "_warn_8zhai_67", ug = "_danger_8zhai_68", mg = "_info_8zhai_69", Ne = {
  strip: Gb,
  day: Yb,
  total: Qb,
  sel: Jb,
  today: Zb,
  md: eg,
  off: tg,
  head: ng,
  wd: ag,
  sun: rg,
  sat: og,
  lock: sg,
  value: lg,
  mark: cg,
  warn: ig,
  danger: ug,
  info: mg
}, zr = ["일", "월", "화", "수", "목", "금", "토"];
function dg(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function PN({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = j([]), m = (_) => {
    var y;
    const p = e.length;
    for (let f = 0; f < p; f++) {
      const b = (_ + f + p) % p;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (_, p) => {
    _.key === "ArrowRight" ? (_.preventDefault(), m(p + 1)) : _.key === "ArrowLeft" ? (_.preventDefault(), m(p - 1)) : _.key === "Home" ? (_.preventDefault(), m(0)) : _.key === "End" && (_.preventDefault(), m(e.length - 1));
  }, d = Math.max(0, e.findIndex((_) => _.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${Ne.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((_, p) => {
    var N, E, $, k;
    const { md: y, wd: f } = dg(_.date), b = [
      Ne.day,
      _.off ? Ne.off : "",
      _.date === t ? Ne.sel : "",
      _.date === a ? Ne.today : "",
      f === 0 ? Ne.sun : f === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), g = [`${y}(${zr[f]})`, _.offLabel, _.locked ? "잠김" : null, (N = _.mark) == null ? void 0 : N.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: _.date,
        ref: (w) => {
          i.current[p] = w;
        },
        type: "button",
        className: b,
        disabled: _.disabled,
        tabIndex: p === d ? 0 : -1,
        "aria-pressed": _.date === t,
        "aria-label": g,
        title: g,
        onClick: () => r == null ? void 0 : r(_.date),
        onKeyDown: (w) => u(w, p)
      },
      /* @__PURE__ */ n.createElement("span", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, zr[f]), /* @__PURE__ */ n.createElement("span", { className: Ne.md }, y), _.locked && /* @__PURE__ */ n.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: Ne.value }, _.value),
      /* @__PURE__ */ n.createElement("span", { className: `${Ne.mark}${_.mark ? ` ${Ne[_.mark.tone]}` : ""}` }, (k = (E = _.mark) == null ? void 0 : E.text) != null ? k : _.off && ($ = _.offLabel) != null ? $ : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: Ne.total }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, s), /* @__PURE__ */ n.createElement("span", { className: Ne.value }, o)));
}
const fg = "_stepper_1wbt2_1", pg = "_nav_1wbt2_2", _g = "_today_1wbt2_3", yg = "_range_1wbt2_14", dn = {
  stepper: fg,
  nav: pg,
  today: _g,
  range: yg
};
function hg(e) {
  const t = Ga(e);
  return t === 0 ? 7 : t;
}
function Eg(e, t = 1) {
  const a = (hg(e) - t + 7) % 7;
  return aa(e, -a);
}
function wa(e, t) {
  return aa(e, t);
}
function XN({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = wa(e, 6), c = Eg(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: dn.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: dn.nav,
      onClick: () => t(wa(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: dn.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: dn.nav,
      onClick: () => t(wa(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: dn.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const bg = "_wrap_1dtpy_1", gg = "_svg_1dtpy_2", vg = "_grid_1dtpy_3", kg = "_axis_1dtpy_4", wg = "_accent_1dtpy_5", Ng = "_muted_1dtpy_6", $g = "_ok_1dtpy_7", xg = "_warn_1dtpy_8", Ag = "_danger_1dtpy_9", Dg = "_legend_1dtpy_10", Sg = "_dot_accent_1dtpy_13", Cg = "_dot_muted_1dtpy_14", Mg = "_dot_ok_1dtpy_15", Tg = "_dot_warn_1dtpy_16", Bg = "_dot_danger_1dtpy_17", vt = {
  wrap: bg,
  svg: gg,
  grid: vg,
  axis: kg,
  accent: wg,
  muted: Ng,
  ok: $g,
  warn: xg,
  danger: Ag,
  legend: Dg,
  dot_accent: Sg,
  dot_muted: Cg,
  dot_ok: Mg,
  dot_warn: Tg,
  dot_danger: Bg
}, qg = 600;
function Lg(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const Hr = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function ON({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = j(null), [c, i] = D(qg);
  ge(() => {
    const v = l.current;
    if (!v) return;
    const A = () => {
      const M = v.clientWidth;
      M > 0 && i((B) => B === M ? B : M);
    };
    if (A(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(A);
    return C.observe(v), () => C.disconnect();
  }, []);
  const m = r, u = 40, d = 22, _ = 8, p = c - u - 4, y = m - d - _, f = t.flatMap((v) => v.values.filter((A) => A != null)), b = Lg(Math.max(0, ...f)), g = Math.max(e.length, 1), N = p / g, E = Math.min(8, N * 0.2), $ = Math.max(1, (N - E) / Math.max(t.length, 1)), k = s != null ? s : Math.max(1, Math.ceil(g / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: vt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: vt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    w.map((v) => {
      const A = _ + y - v / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: v }, /* @__PURE__ */ n.createElement("line", { className: vt.grid, x1: u, x2: c - 4, y1: A, y2: A }), /* @__PURE__ */ n.createElement("text", { className: vt.axis, x: u - 4, y: A + 3, textAnchor: "end" }, Hr(v)));
    }),
    e.map((v, A) => /* @__PURE__ */ n.createElement("g", { key: v }, t.map((C, M) => {
      var T;
      const B = C.values[A];
      if (B == null || B <= 0) return null;
      const I = B / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: vt[(T = C.tone) != null ? T : "accent"],
          x: u + A * N + E / 2 + M * $,
          y: _ + y - I,
          width: $,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${v} · ${C.label} ${Hr(B)}${a}`)
      );
    }), A % k === 0 && /* @__PURE__ */ n.createElement("text", { className: vt.axis, x: u + A * N + N / 2, y: m - 6, textAnchor: "middle" }, v)))
  ), /* @__PURE__ */ n.createElement("ul", { className: vt.legend }, t.map((v) => {
    var A;
    return /* @__PURE__ */ n.createElement("li", { key: v.key }, /* @__PURE__ */ n.createElement("i", { className: vt[`dot_${(A = v.tone) != null ? A : "accent"}`], "aria-hidden": "true" }), v.label, a ? ` (${a})` : "");
  })));
}
const jg = "_wrap_85lir_1", Ig = "_track_85lir_2", Rg = "_accent_85lir_3", Pg = "_muted_85lir_3", Xg = "_ok_85lir_3", Og = "_warn_85lir_3", zg = "_danger_85lir_3", Hg = "_center_85lir_9", Wg = "_legend_85lir_10", Fg = "_name_85lir_13", Kg = "_val_85lir_14", Vg = "_pct_85lir_15", Ug = "_dot_accent_85lir_16", Gg = "_dot_muted_85lir_17", Yg = "_dot_ok_85lir_18", Qg = "_dot_warn_85lir_19", Jg = "_dot_danger_85lir_20", lt = {
  wrap: jg,
  track: Ig,
  accent: Rg,
  muted: Pg,
  ok: Xg,
  warn: Og,
  danger: zg,
  center: Hg,
  legend: Wg,
  name: Fg,
  val: Kg,
  pct: Vg,
  dot_accent: Ug,
  dot_muted: Gg,
  dot_ok: Yg,
  dot_warn: Qg,
  dot_danger: Jg
}, Ia = 40, Wr = 2 * Math.PI * Ia;
function zN({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: lt.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: lt.track, cx: "50", cy: "50", r: Ia }), l > 0 && e.map((i) => {
    var d;
    const m = Math.max(0, i.value) / l * Wr, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: lt[(d = i.tone) != null ? d : "accent"],
        cx: "50",
        cy: "50",
        r: Ia,
        strokeDasharray: `${m} ${Wr - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: lt.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: lt.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: lt[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: lt.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: lt.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: lt.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Zg = "_wrap_1b8ll_1", e1 = "_track_1b8ll_2", t1 = "_compact_1b8ll_3", n1 = "_fill_1b8ll_4", a1 = "_accent_1b8ll_5", r1 = "_muted_1b8ll_6", o1 = "_ok_1b8ll_7", s1 = "_warn_1b8ll_8", l1 = "_danger_1b8ll_9", c1 = "_num_1b8ll_10", i1 = "_none_1b8ll_12", Bt = {
  wrap: Zg,
  track: e1,
  compact: t1,
  fill: n1,
  accent: a1,
  muted: r1,
  ok: o1,
  warn: s1,
  danger: l1,
  num: c1,
  none: i1
};
function HN({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Bt.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Bt.wrap, r ? Bt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: Bt.track }, /* @__PURE__ */ n.createElement("span", { className: `${Bt.fill} ${Bt[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Bt.num }, o, "%")
  );
}
const u1 = { day: 28, week: 10, month: 3 };
function Pt(e, t) {
  return aa(e, t);
}
function Ra(e, t) {
  return Nt(t) - Nt(e) + 1;
}
function Ho(e) {
  return Ga(e);
}
const Fr = (e) => {
  const t = Ho(e);
  return t === 0 || t === 6;
};
function Jt(e, t, a, r) {
  const o = [], s = Ra(e, t);
  for (let l = 0; l < s; l++) {
    const c = Pt(e, l), i = a(c), m = o[o.length - 1];
    m && m.key === i ? m.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function m1(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Jt(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Jt(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Pt(l, -((Ho(l) + 6) % 7));
    return {
      top: Jt(e, t, r, o),
      bottom: Jt(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Jt(e, t, r, o),
    bottom: Jt(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function Na(e, t, a, r) {
  if (a === "move") return { start: Pt(e, r), end: Pt(t, r) };
  if (a === "start") {
    const s = Pt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Pt(t, r);
  return { start: e, end: o < e ? e : o };
}
const d1 = "_gantt_1smka_3", f1 = "_scroll_1smka_15", p1 = "_canvas_1smka_21", _1 = "_head_1smka_24", y1 = "_headLabel_1smka_32", h1 = "_headTrack_1smka_43", E1 = "_band_1smka_44", b1 = "_seg_1smka_46", g1 = "_tick_1smka_59", v1 = "_tickOff_1smka_60", k1 = "_body_1smka_62", w1 = "_overlay_1smka_65", N1 = "_weekend_1smka_66", $1 = "_holiday_1smka_66", x1 = "_today_1smka_68", A1 = "_row_1smka_70", D1 = "_label_1smka_76", S1 = "_sel_1smka_77", C1 = "_track_1smka_77", M1 = "_dim_1smka_78", T1 = "_labelText_1smka_95", B1 = "_dot_1smka_96", q1 = "_warn_1smka_97", L1 = "_err_1smka_98", j1 = "_bar_1smka_113", I1 = "_can_1smka_21", R1 = "_dragging_1smka_126", P1 = "_fill_1smka_127", X1 = "_late_1smka_128", O1 = "_summary_1smka_130", z1 = "_handle_1smka_133", H1 = "_hL_1smka_134", W1 = "_hR_1smka_135", F1 = "_mark_1smka_137", K1 = "_barText_1smka_138", V1 = "_empty_1smka_147", U1 = "_srOnly_1smka_150", ae = {
  gantt: d1,
  scroll: f1,
  canvas: p1,
  head: _1,
  headLabel: y1,
  headTrack: h1,
  band: E1,
  seg: b1,
  tick: g1,
  tickOff: v1,
  body: k1,
  overlay: w1,
  weekend: N1,
  holiday: $1,
  today: x1,
  row: A1,
  label: D1,
  sel: S1,
  track: C1,
  dim: M1,
  labelText: T1,
  dot: B1,
  warn: q1,
  err: L1,
  bar: j1,
  can: I1,
  dragging: R1,
  fill: P1,
  late: X1,
  summary: O1,
  handle: z1,
  hL: H1,
  hR: W1,
  mark: F1,
  barText: K1,
  empty: V1,
  srOnly: U1
}, Kr = 28, Vr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let G1 = 0;
function WN({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: d,
  lockedReason: _,
  scrollMemory: p,
  className: y = "",
  style: f,
  "aria-label": b
}) {
  const g = j("");
  g.current || (g.current = `axe-gantt-keys-${++G1}`);
  const N = u1[r], E = Math.max(Ra(t, a), 1), $ = Nt(t), k = E * N, w = _e(() => m1(t, a, r), [t, a, r]), v = _e(() => {
    const h = [];
    for (let S = 0; S < E; S++) {
      const P = Pt(t, S), H = P in o;
      if (!H && !Fr(P)) continue;
      const J = h[h.length - 1];
      J && J.offset + J.days === S && J.holiday === H ? J.days++ : h.push({ offset: S, days: 1, holiday: H });
    }
    return h;
  }, [t, E, o]), [A, C] = D(null), M = j(null), B = (h) => !!c && !h.locked && !h.summary && !!h.start && !!h.end, I = (h, S, P) => {
    if (!B(S) || h.button !== 0) return;
    h.stopPropagation(), h.currentTarget.setPointerCapture(h.pointerId);
    const H = { id: S.id, mode: P, x: h.clientX, delta: 0, moved: !1 };
    M.current = H, C(H);
  }, T = (h) => {
    const S = M.current;
    if (!S) return;
    const P = Math.round((h.clientX - S.x) / N), H = S.moved || Math.abs(h.clientX - S.x) > 3;
    if (P !== S.delta || H !== S.moved) {
      const J = { ...S, delta: P, moved: H };
      M.current = J, C(J);
    }
  }, z = (h) => {
    const S = M.current;
    if (M.current = null, C(null), !!S) {
      if (!S.moved) {
        i == null || i(h);
        return;
      }
      S.delta !== 0 && h.start && h.end && (c == null || c(h, Na(h.start, h.end, S.mode, S.delta), S.mode));
    }
  }, G = () => {
    M.current = null, C(null);
  }, K = (h, S) => {
    if (h.key === "Escape" && M.current) {
      G();
      return;
    }
    if (h.key === "Enter") {
      i == null || i(S);
      return;
    }
    if (!B(S) || h.key !== "ArrowLeft" && h.key !== "ArrowRight") return;
    h.preventDefault();
    const P = h.key === "ArrowLeft" ? -1 : 1, H = h.shiftKey ? "end" : h.altKey ? "start" : "move";
    c == null || c(S, Na(S.start, S.end, H, P), H);
  }, R = s ? Nt(s) - $ : -1, ne = j(null), te = j(null);
  return ge(() => {
    const h = ne.current;
    if (h && (p != null && p.current) && te.current === null) {
      te.current = r, h.scrollLeft = p.current.left, h.scrollTop = p.current.top;
      return;
    }
    if (!l || !h || R < 0 || R >= E || te.current === r) return;
    te.current = r;
    const S = Math.max(h.clientWidth - u, 0);
    h.scrollLeft = Math.max(0, R * N + N / 2 - S / 3);
  }, [l, r, R, E, N, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ae.gantt, y].filter(Boolean).join(" "),
      style: f,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (h) => {
        h.key === "Escape" && M.current && G();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: g.current, className: ae.srOnly }, Vr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ae.scroll,
        onScroll: p ? (h) => {
          p.current = { left: h.currentTarget.scrollLeft, top: h.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ae.canvas, style: { width: u + k } }, /* @__PURE__ */ n.createElement("div", { className: ae.head, style: { gridTemplateColumns: `${u}px ${k}px` } }, /* @__PURE__ */ n.createElement("div", { className: ae.headLabel }, d), /* @__PURE__ */ n.createElement("div", { className: ae.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ae.band }, w.top.map((h) => /* @__PURE__ */ n.createElement("span", { key: h.key, className: ae.seg, style: { left: h.offset * N, width: h.days * N }, title: h.label }, h.label))), /* @__PURE__ */ n.createElement("div", { className: ae.band }, w.bottom.map((h) => {
        var P;
        const S = r === "day" && (h.key in o || Fr(h.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: h.key,
            className: [ae.seg, ae.tick, S ? ae.tickOff : ""].filter(Boolean).join(" "),
            style: { left: h.offset * N, width: h.days * N },
            title: (P = o[h.key]) != null ? P : h.key
          },
          h.days * N >= 16 ? h.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ae.body, style: { minHeight: Kr } }, /* @__PURE__ */ n.createElement("div", { className: ae.overlay, style: { left: u, width: k }, "aria-hidden": "true" }, v.map((h) => /* @__PURE__ */ n.createElement("span", { key: h.offset, className: h.holiday ? ae.holiday : ae.weekend, style: { left: h.offset * N, width: h.days * N } })), R >= 0 && R < E && /* @__PURE__ */ n.createElement("span", { className: ae.today, style: { left: R * N + N / 2 }, title: "오늘" })), e.map((h) => {
        var W, V, ie, Oe;
        const S = !!h.start && !!h.end && h.start <= h.end, P = A && A.id === h.id ? A : null, H = S && P && P.delta !== 0 ? Na(h.start, h.end, P.mode, P.delta) : S ? { start: h.start, end: h.end } : null, J = H ? (Nt(H.start) - $) * N : 0, q = H ? Ra(H.start, H.end) * N : 0, Q = Math.max(0, Math.min(100, (W = h.progress) != null ? W : 0)), X = m != null && m === h.id, F = B(h), Z = !F && c && H ? _ == null ? void 0 : _(h) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: h.id,
            className: [ae.row, X ? ae.sel : "", h.dim ? ae.dim : ""].filter(Boolean).join(" "),
            style: { height: Kr }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ae.label,
              style: { width: u },
              title: h.name,
              onClick: () => i == null ? void 0 : i(h)
            },
            /* @__PURE__ */ n.createElement("span", { className: ae.labelText }, h.label),
            h.marked && /* @__PURE__ */ n.createElement("span", { className: ae.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            h.warn && /* @__PURE__ */ n.createElement("span", { className: ae.warn, title: h.warn, "aria-label": h.warn }, "⚠"),
            h.error && /* @__PURE__ */ n.createElement("span", { className: ae.err, title: h.error, "aria-label": h.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ae.track, style: { width: k }, onClick: () => !P && (i == null ? void 0 : i(h)) }, H ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ae.bar, h.summary ? ae.summary : "", h.late ? ae.late : "", F ? ae.can : "", P ? ae.dragging : ""].filter(Boolean).join(" "),
              style: { left: J, width: Math.max(q, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(V = h.name) != null ? V : ""} ${H.start} ~ ${H.end}${h.progress != null ? ` ${Q}%` : ""}${h.late ? " 지연" : ""}${Z ? ` 잠김: ${Z}` : ""}`,
              "aria-describedby": F ? g.current : void 0,
              title: `${H.start} ~ ${H.end}${h.progress != null ? ` · ${Q}%` : ""}${h.late ? " · 지연" : ""}${F ? `
끌어 옮기기·양 끝 조절
${Vr}` : ""}${Z ? `
잠김: ${Z}` : ""}`,
              onPointerDown: (xe) => I(xe, h, "move"),
              onPointerMove: T,
              onPointerUp: () => z(h),
              onPointerCancel: G,
              onClick: (xe) => xe.stopPropagation(),
              onKeyDown: (xe) => K(xe, h)
            },
            h.progress != null && /* @__PURE__ */ n.createElement("span", { className: ae.fill, style: { width: `${Q}%` } }),
            F && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ae.handle} ${ae.hL}`, onPointerDown: (xe) => I(xe, h, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ae.handle} ${ae.hR}`, onPointerDown: (xe) => I(xe, h, "end") }))
          ), h.markDate && h.markDate >= t && h.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ae.mark, style: { left: (Nt(h.markDate) - $ + 1) * N - 1 }, title: (ie = h.markLabel) != null ? ie : h.markDate }), h.barText && /* @__PURE__ */ n.createElement("span", { className: ae.barText, style: { left: J + Math.max(q, 2) + 4 } }, h.barText)) : /* @__PURE__ */ n.createElement("span", { className: ae.empty }, (Oe = h.emptyText) != null ? Oe : "기간 없음"))
        );
      })))
    )
  );
}
const Y1 = "_board_192fl_3", Q1 = "_col_192fl_15", J1 = "_over_192fl_23", Z1 = "_head_192fl_25", ev = "_title_192fl_33", tv = "_count_192fl_34", nv = "_hint_192fl_43", av = "_list_192fl_45", rv = "_empty_192fl_54", ov = "_card_192fl_56", sv = "_sel_192fl_68", lv = "_dragging_192fl_69", cv = "_hasErr_192fl_70", iv = "_dot_192fl_71", uv = "_err_192fl_72", Te = {
  board: Y1,
  col: Q1,
  over: J1,
  head: Z1,
  title: ev,
  count: tv,
  hint: nv,
  list: av,
  empty: rv,
  card: ov,
  sel: sv,
  dragging: lv,
  hasErr: cv,
  dot: iv,
  err: uv
}, $a = "application/x-axerp-kanban";
function FN({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: d,
  emptyText: _ = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: f,
  "aria-label": b
}) {
  const g = Ht("axe-kb"), [N, E] = D(null), [$, k] = D(null), w = new Map(t.map((B) => [String(a(B)), B])), v = j(null), A = j(null);
  U(() => {
    var T, z;
    const B = A.current;
    if (!B) return;
    if (Date.now() > B.until) {
      A.current = null;
      return;
    }
    const I = Array.from((z = (T = v.current) == null ? void 0 : T.querySelectorAll("[data-kanban-key]")) != null ? z : []).find((G) => G.dataset.kanbanKey === B.key);
    I && document.activeElement !== I && I.focus(), A.current = null;
  });
  const C = (B, I) => {
    B.preventDefault(), E(null), k(null);
    const T = B.dataTransfer.getData($a), z = w.get(T);
    z && r(z) !== I && (l == null || l(z, I));
  }, M = (B, I) => {
    if (B.key === "Enter" || B.key === " ") {
      B.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !B.altKey || B.key !== "ArrowLeft" && B.key !== "ArrowRight" || d != null && d(I)) return;
    B.preventDefault();
    const T = e.findIndex((G) => G.key === r(I)), z = T + (B.key === "ArrowLeft" ? -1 : 1);
    T >= 0 && z >= 0 && z < e.length && (A.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[z].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: v, className: [Te.board, y].filter(Boolean).join(" "), style: f, role: "region", "aria-label": b != null ? b : "보드" }, e.map((B) => {
    const I = t.filter((T) => r(T) === B.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: B.key,
        className: [Te.col, N === B.key ? Te.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof B.title == "string" ? B.title : void 0,
        onDragOver: l ? (T) => {
          T.dataTransfer.types.includes($a) && (T.preventDefault(), E(B.key));
        } : void 0,
        onDragLeave: l ? (T) => {
          T.currentTarget.contains(T.relatedTarget) || E((z) => z === B.key ? null : z);
        } : void 0,
        onDrop: l ? (T) => C(T, B.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Te.head }, /* @__PURE__ */ n.createElement("span", { className: Te.title }, B.title), /* @__PURE__ */ n.createElement("span", { className: Te.count }, I.length), B.hint && /* @__PURE__ */ n.createElement("span", { className: Te.hint }, B.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Te.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Te.empty }, _), I.map((T) => {
        const z = a(T), G = d == null ? void 0 : d(T), K = u == null ? void 0 : u(T), R = !!l && !G, ne = G != null ? G : R ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: z,
            className: [Te.card, i === z ? Te.sel : "", $ === z ? Te.dragging : "", K ? Te.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(z),
            role: "button",
            "aria-label": s == null ? void 0 : s(T),
            "aria-keyshortcuts": R ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${g}-h-${String(z)}` : void 0,
            draggable: R,
            onDragStart: R ? (te) => {
              te.dataTransfer.setData($a, String(z)), te.dataTransfer.effectAllowed = "move", k(z);
            } : void 0,
            onDragEnd: () => {
              k(null), E(null);
            },
            onClick: () => c == null ? void 0 : c(T),
            onKeyDown: (te) => M(te, T)
          },
          ne && /* @__PURE__ */ n.createElement(yo, { id: `${g}-h-${String(z)}` }, ne),
          (m == null ? void 0 : m(T)) && /* @__PURE__ */ n.createElement("span", { className: Te.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(T),
          K && /* @__PURE__ */ n.createElement("p", { className: Te.err, role: "alert" }, K)
        );
      }))
    );
  }));
}
const mv = "_list_1aqum_2", dv = "_empty_1aqum_3", fv = "_item_1aqum_5", pv = "_row_block_1aqum_6", _v = "_row_warn_1aqum_7", yv = "_head_1aqum_9", hv = "_mark_1aqum_16", Ev = "_msg_1aqum_17", bv = "_count_1aqum_18", gv = "_aside_1aqum_19", vv = "_caret_1aqum_20", kv = "_block_1aqum_22", wv = "_warn_1aqum_23", Nv = "_info_1aqum_24", $v = "_body_1aqum_29", xv = "_actions_1aqum_30", Be = {
  list: mv,
  empty: dv,
  item: fv,
  row_block: pv,
  row_warn: _v,
  head: yv,
  mark: hv,
  msg: Ev,
  count: bv,
  aside: gv,
  caret: vv,
  block: kv,
  warn: wv,
  info: Nv,
  body: $v,
  actions: xv
}, Av = { block: "■", warn: "▲", info: "●" }, Dv = { block: "차단", warn: "경고", info: "정보" };
function KN({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = D({}), [l, c] = D(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Be.list} ${r}` }, e.map((i) => {
    var _;
    const m = !!i.detail || !!i.actions, u = m && ((_ = o[i.key]) != null ? _ : a.includes(i.tone)), d = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Be.mark} ${Be[i.tone]}`, "aria-label": Dv[i.tone], role: "img" }, Av[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Be.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Be.count} ${Be[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Be.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Be.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Be.item} ${Be[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Be.head,
        "aria-expanded": u,
        onClick: () => s((p) => ({ ...p, [i.key]: !u }))
      },
      d
    ) : /* @__PURE__ */ n.createElement("div", { className: Be.head }, d), u && /* @__PURE__ */ n.createElement("div", { className: Be.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Be.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Be.empty} ${r}` }, t);
}
function Sv(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function Cv(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function VN(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function UN(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const Mv = "_nav_14weo_1", Tv = "_list_14weo_3", Bv = "_btn_14weo_4", qv = "_cur_14weo_13", Lv = "_gap_14weo_15", jv = "_total_14weo_16", Iv = "_jump_14weo_17", Rv = "_go_14weo_20", Pv = "_size_14weo_22", Xv = "_sizeBtn_14weo_23", Ov = "_more_14weo_24", zv = "_moreBtn_14weo_25", Hv = "_moreN_14weo_29", he = {
  nav: Mv,
  list: Tv,
  btn: Bv,
  cur: qv,
  gap: Lv,
  total: jv,
  jump: Iv,
  in: "_in_14weo_18",
  go: Rv,
  size: Pv,
  sizeBtn: Xv,
  more: Ov,
  moreBtn: zv,
  moreN: Hv
};
function GN({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [d, _] = D(String(u));
  U(() => _(String(u)), [u]);
  const p = (f) => {
    f !== u && f >= 1 && f <= m && a(f);
  }, y = () => {
    const f = Cv(d, m);
    if (f === null) {
      _(String(u));
      return;
    }
    _(String(f)), p(f);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [he.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: he.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: he.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), Sv(u, m).map((f, b) => f === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: he.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: f }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [he.btn, f === u ? he.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(f),
      "aria-current": f === u ? "page" : void 0,
      "aria-label": `${f}쪽`
    },
    f
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: he.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: he.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: he.in,
      inputMode: "numeric",
      value: d,
      "aria-label": "이동할 쪽 번호",
      onChange: (f) => _(f.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (f) => {
        f.key === "Enter" && (f.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: he.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("span", { className: he.size }, "쪽당", /* @__PURE__ */ n.createElement(
    Ie,
    {
      className: he.sizeBtn,
      value: String(s),
      label: "쪽당 건수",
      onChange: (f) => l(Number(f)),
      options: o.map((f) => ({ value: String(f), label: `${f}건` }))
    }
  )));
}
function YN({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [he.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: he.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const Wv = "_ol_fbatg_1", Fv = "_li_fbatg_2", Kv = "_done_fbatg_5", Vv = "_now_fbatg_5", Uv = "_item_fbatg_6", Gv = "_dot_fbatg_12", Yv = "_label_fbatg_19", Qv = "_opt_fbatg_21", Jv = "_sr_fbatg_22", ct = {
  ol: Wv,
  li: Fv,
  done: Kv,
  now: Vv,
  item: Uv,
  dot: Gv,
  label: Yv,
  opt: Qv,
  sr: Jv
};
function QN({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [ct.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ct.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: ct.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: ct.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: ct.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [ct.li, ct[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: ct.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: ct.item }, c));
  }));
}
const Zv = "_root_7y5bc_5", e0 = "_block_7y5bc_6", t0 = "_svg_7y5bc_7", n0 = "_sm_7y5bc_8", a0 = "_md_7y5bc_9", r0 = "_lg_7y5bc_10", o0 = "_track_7y5bc_11", s0 = "_bar_7y5bc_12", l0 = "_spin_7y5bc_13", c0 = "_txt_7y5bc_15", kt = {
  root: Zv,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: e0,
  svg: t0,
  sm: n0,
  md: a0,
  lg: r0,
  track: o0,
  bar: s0,
  spin: l0,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: c0,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function JN({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [kt.root, o ? kt.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [kt.svg, kt[e], l ? "" : kt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: kt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: kt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: kt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const i0 = "_group_vdqk6_1", u0 = "_legend_vdqk6_2", m0 = "_req_vdqk6_3", d0 = "_opts_vdqk6_4", f0 = "_inline_vdqk6_5", p0 = "_all_vdqk6_6", _0 = "_opt_vdqk6_4", y0 = "_compact_vdqk6_11", h0 = "_dis_vdqk6_13", E0 = "_radio_vdqk6_14", b0 = "_check_vdqk6_14", g0 = "_text_vdqk6_16", v0 = "_hint_vdqk6_17", k0 = "_err_vdqk6_18", w0 = "_srOnly_vdqk6_20", me = {
  group: i0,
  legend: u0,
  req: m0,
  opts: d0,
  inline: f0,
  all: p0,
  opt: _0,
  compact: y0,
  dis: h0,
  radio: E0,
  check: b0,
  text: g0,
  hint: v0,
  err: k0,
  srOnly: w0
};
function Wo({ legend: e, required: t, hidden: a }) {
  return /* @__PURE__ */ n.createElement("legend", { className: [me.legend, a ? me.srOnly : ""].filter(Boolean).join(" ") }, e, t && /* @__PURE__ */ n.createElement("span", { className: me.req }, " (필수)"));
}
function ZN({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: m = "", legendHidden: u = !1 }) {
  const d = Ht("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? d : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Wo, { legend: t, required: s, hidden: u }),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, i ? me.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((_) => /* @__PURE__ */ n.createElement("label", { key: _.value, className: [me.opt, _.disabled ? me.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: me.radio,
        name: e,
        value: _.value,
        checked: r === _.value,
        disabled: _.disabled,
        required: s,
        onChange: () => o(_.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: me.text }, _.label, _.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, _.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: d, className: me.err }, c)
  );
}
function Ur({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "", compact: l = !1, title: c }) {
  return /* @__PURE__ */ n.createElement("label", { title: c, className: [me.opt, l ? me.compact : "", r ? me.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: me.check,
      checked: e,
      disabled: r,
      ref: (i) => {
        i && (i.indeterminate = t && !e);
      },
      onChange: (i) => a(i.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: me.text }, o));
}
function e2({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Ht("axe-cg-err"), d = t.filter((f) => !f.disabled).map((f) => f.value), _ = d.length > 0 && d.every((f) => a.includes(f)), p = d.some((f) => a.includes(f)), y = (f, b) => r(b ? [...a, f] : a.filter((g) => g !== f));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Wo, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: me.all }, /* @__PURE__ */ n.createElement(
      Ur,
      {
        checked: _,
        indeterminate: p && !_,
        onChange: (f) => r(f ? Array.from(/* @__PURE__ */ new Set([...a, ...d])) : a.filter((b) => !d.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, c ? me.inline : ""].filter(Boolean).join(" ") }, t.map((f) => /* @__PURE__ */ n.createElement(Ur, { key: f.value, checked: a.includes(f.value), disabled: f.disabled, onChange: (b) => y(f.value, b) }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, f.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: me.err }, l)
  );
}
const N0 = "_list_13vw7_1", $0 = "_tag_13vw7_2", x0 = "_main_13vw7_3", A0 = "_x_13vw7_6", D0 = "_t_muted_13vw7_10", S0 = "_t_accent_13vw7_11", C0 = "_t_ok_13vw7_12", M0 = "_t_warn_13vw7_13", T0 = "_t_danger_13vw7_14", B0 = "_sel_13vw7_16", qt = {
  list: N0,
  tag: $0,
  main: x0,
  x: A0,
  t_muted: D0,
  t_accent: S0,
  t_ok: C0,
  t_warn: M0,
  t_danger: T0,
  sel: B0
};
function t2({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [qt.tag, qt[`t_${t}`], a ? qt.sel : "", c].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: qt.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: qt.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: qt.x, onClick: o, disabled: l, "aria-label": m }, "✕"));
}
function n2({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [qt.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const q0 = "_acc_1lmty_1", L0 = "_item_1lmty_2", j0 = "_h_1lmty_3", I0 = "_btn_1lmty_4", R0 = "_title_1lmty_8", P0 = "_meta_1lmty_9", X0 = "_chev_1lmty_10", O0 = "_open_1lmty_11", z0 = "_body_1lmty_12", it = {
  acc: q0,
  item: L0,
  h: j0,
  btn: I0,
  title: R0,
  meta: P0,
  chev: X0,
  open: O0,
  body: z0
};
function a2({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = D(a), m = r != null ? r : c, u = Ht("axe-acc"), d = `h${s}`, _ = (p) => {
    const y = m.includes(p) ? m.filter((f) => f !== p) : t ? [p] : [...m, p];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [it.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = m.includes(p.key), f = `${u}-b-${p.key}`, b = `${u}-p-${p.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: p.key, className: [it.item, y ? it.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(d, { className: it.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: f,
        className: it.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => _(p.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: it.title }, p.title),
      p.meta && /* @__PURE__ */ n.createElement("span", { className: it.meta }, p.meta),
      /* @__PURE__ */ n.createElement("span", { className: it.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": f, hidden: !y, className: it.body }, p.content));
  }));
}
const H0 = "_stack_1u83j_2", W0 = "_toast_1u83j_3", F0 = "_t_danger_1u83j_9", K0 = "_ico_1u83j_10", V0 = "_t_ok_1u83j_11", U0 = "_msg_1u83j_12", G0 = "_act_1u83j_13", Y0 = "_x_1u83j_15", Lt = {
  stack: H0,
  toast: W0,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: F0,
  ico: K0,
  t_ok: V0,
  msg: U0,
  act: G0,
  x: Y0
}, Fo = na(null);
let Q0 = 0;
function r2() {
  const e = ta(Fo);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function J0({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = D(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  U(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Lt.toast, Lt[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Lt.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Lt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Lt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Lt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function o2({ children: e }) {
  const [t, a] = D([]), r = j(t);
  r.current = t;
  const o = oe((c) => a((i) => i.filter((m) => m.id !== c)), []), s = oe((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((d) => d.message === i.message);
    if (m)
      return a((d) => d.map((_) => _.id === m.id ? { ..._, ...i } : _)), m.id;
    const u = ++Q0;
    return a((d) => [...d, { ...i, id: u }].slice(-3)), u;
  }, []), l = _e(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(Fo.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Lt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(J0, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const Z0 = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function ek(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const tk = "_grid_yplhe_1", nk = "_group_yplhe_2", ak = "_h_yplhe_3", rk = "_list_yplhe_4", ok = "_row_yplhe_5", sk = "_keys_yplhe_6", lk = "_text_yplhe_7", ck = "_or_yplhe_8", ik = "_kbd_yplhe_9", ut = {
  grid: tk,
  group: nk,
  h: ak,
  list: rk,
  row: ok,
  keys: sk,
  text: lk,
  or: ck,
  kbd: ik
};
function uk({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...Z0];
  return /* @__PURE__ */ n.createElement(ca, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ut.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ut.group }, /* @__PURE__ */ n.createElement("h3", { className: ut.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ut.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: ut.row }, /* @__PURE__ */ n.createElement("dt", { className: ut.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ut.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ut.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ut.text }, o.text))))))));
}
function mk(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function s2(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = D(!1);
  return U(() => {
    if (!t) return;
    const s = (l) => {
      ek(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, mk(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(uk, { extra: a, onClose: () => o(!1) }) : null };
}
const Gr = 30, dk = BigInt(10);
function an(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * dk;
  return t;
}
function ft(e, t = 0) {
  return { u: e, s: t };
}
const Ko = ft(BigInt(0));
function Vo(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * an(a - e.s), t.u * an(a - t.s), a];
}
function Sn(e, t) {
  const [a, r, o] = Vo(e, t);
  return ft(a + r, o);
}
function er(e, t) {
  const [a, r, o] = Vo(e, t);
  return ft(a - r, o);
}
function nt(e, t) {
  return ft(e.u * t.u, e.s + t.s);
}
function Ot(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * an(t.s + Gr), r = t.u * an(e.s);
  return ft(a / r, Gr);
}
function Uo(e) {
  return ft(-e.u, e.s);
}
function pt(e, t, a) {
  if (t >= e.s)
    return ft(e.u * an(t - e.s), t);
  const r = an(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, ft(o ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return ft(a ? -c : c, l);
}
function tr(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : Ko);
}
function Ye(e, t = e.s, a = !1) {
  const r = pt(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function Pa(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Zt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function Go(e, t) {
  const a = Zt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function Yo(e, t, a = "exclude-first") {
  const r = Zt(e) > Zt(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Zt(s) - Zt(o) + (l ? 1 : 0), i = l ? Go(s, 1) : s;
  let m = i.y - o.y, u = i.m - o.m, d = i.d - o.d;
  if (d < 0) {
    u -= 1;
    const _ = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    d += Le(p, _);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d, swapped: r };
}
function ea(e, t) {
  return Go(e, t);
}
function Yr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const fk = ["월", "화", "수", "목", "금", "토", "일"];
function Xa(e) {
  return fk[Zt(e) % 7];
}
function He(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const pn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], xa = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Qr(e) {
  var t;
  return (t = xa[e]) != null ? t : e in xa ? xa[e] : null;
}
function Oa(e, t) {
  return e.find((a) => a.code === t);
}
function Qo(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Jo(e, t, a, r) {
  const o = Oa(e, a), s = Oa(e, r);
  if (!o || !s) return null;
  const l = be(o.krw), c = be(s.krw), i = be(String(o.per)), m = be(String(s.per));
  if (!l || !c || !i || !m) return null;
  const u = Ot(nt(t, l), i);
  if (!u) return null;
  const d = Ot(nt(u, m), c);
  return d ? {
    value: pt(d, 2, "half"),
    notice: `${Qo(o)} · 참고용 환율`
  } : null;
}
function pk(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? Uo(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = Sn(a, o.value);
          break;
        case "-":
          a = er(a, o.value);
          break;
        case "*":
          a = nt(a, o.value);
          break;
        default: {
          const s = Ot(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : Ko;
  return { ok: !0, value: t ? pt(r, t.digits, t.mode) : r };
}
const Jr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
], Zo = [
  { value: "half", label: "반올림" },
  { value: "up", label: "올림" },
  { value: "down", label: "버림" }
];
function gn() {
  return { sign: "+", text: "" };
}
function _k(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function yk(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function hk(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, m = j([]), u = Math.min(r, t.length - 1);
  U(() => {
    var E;
    (E = m.current[u]) == null || E.focus();
  }, [u, t.length]);
  const d = pk(yk(t), { digits: s, mode: c }), _ = d.ok ? Ye(d.value, s, !0) : "0으로 나눌 수 없음", p = (E, $) => {
    a(t.map((k, w) => w === E ? { ...k, ...$ } : k));
  }, y = (E = t.length, $ = "") => {
    const k = [...t];
    k.splice(E, 0, { ...gn(), text: $ }), a(k), o(E);
  }, f = (E) => {
    if (t.length === 1) {
      a([gn()]);
      return;
    }
    a(t.filter(($, k) => k !== E)), o(Math.max(0, E - 1));
  }, b = () => {
    d.ok && y(t.length, Ye(d.value, s, !0));
  }, g = (E, $) => {
    const k = E.key, w = Ek(k);
    if (w && !(k === "-" && t[$].text === "")) {
      E.preventDefault(), p($, { sign: w });
      return;
    }
    if (k === "v" || k === "V") {
      E.preventDefault(), b();
      return;
    }
    k === "Enter" ? (E.preventDefault(), $ === t.length - 1 ? y() : o($ + 1)) : k === "ArrowDown" ? (E.preventDefault(), o(Math.min($ + 1, t.length - 1))) : k === "ArrowUp" ? (E.preventDefault(), o(Math.max($ - 1, 0))) : k === "Insert" ? (E.preventDefault(), y($ + 1)) : k === "Delete" && t[$].text === "" ? (E.preventDefault(), f($)) : k === "F4" && (E.preventDefault(), N());
  }, N = () => {
    a([gn()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => f(u) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: N }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, Jr.map((E) => {
    var $;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: E.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": (($ = t[u]) == null ? void 0 : $.sign) === E.key,
        onClick: () => p(u, { sign: E.key })
      },
      E.label,
      " (",
      E.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "결과값 자리수",
      className: "bical-select",
      value: String(s),
      onChange: (E) => l(Number(E)),
      options: [0, 1, 2, 3, 4].map((E) => ({ value: String(E), label: String(E) }))
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement(Ie, { label: "표기방법", className: "bical-select", value: c, onChange: (E) => i(E), options: Zo })), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((E, $) => {
    var k;
    return /* @__PURE__ */ n.createElement("div", { key: $, className: `bical-line${$ === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, $ === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (k = Jr.find((w) => w.key === E.sign)) == null ? void 0 : k.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (w) => {
          m.current[$] = w;
        },
        value: E.text,
        inputMode: "decimal",
        "aria-label": `${$ + 1}번째 금액`,
        onFocus: () => o($),
        onChange: (w) => p($, { text: _k(w.target.value) }),
        onKeyDown: (w) => g(w, $)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, _))));
}
function Ek(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function bk(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = be(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class gk {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? Sn(t.value, r.value) : er(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: nt(t.value, r.value) };
      else {
        const o = Ot(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Uo(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function vk(e) {
  const t = bk(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new gk(t).parse();
}
const vn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], kk = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function wk(e, t) {
  return e.replace(/오늘/g, He(t)).replace(/내일/g, He(ea(t, 1))).replace(/어제/g, He(ea(t, -1)));
}
function Nk(e) {
  const t = [];
  for (const a of e.matchAll(kk)) {
    const r = Pa(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const $k = /부터|까지|에서|일수|며칠|기간|차이|~/;
function xk(e, t) {
  if (t.length < 2 || !$k.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Yo(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${He(t[0])} ~ ${He(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const Ak = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Dk(e, t) {
  if (t.length !== 1) return null;
  const a = Ak.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = ea(l, s) : a[2] === "주" ? c = ea(l, s * 7) : a[2] === "년" ? c = Yr(l, s * 12) : c = Yr(l, s), {
    ok: !0,
    explain: `${He(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${He(c)} (${Xa(c)})`
  };
}
function Sk(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? es(a[2]) : null, o = be(a[1]);
  if (!o) return null;
  const s = r ? nt(o, r) : o, l = Qr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : Qr(Ck(e));
  if (!i || i === l) return null;
  const m = Jo(t, s, l, i);
  return m ? {
    ok: !0,
    explain: `${Ye(s, s.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ye(m.value, 2, !0)} ${i}`
  } : null;
}
function Ck(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Mk = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function es(e) {
  var t;
  return (t = be(Mk[e])) != null ? t : tr(1);
}
const Tk = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Bk = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function qk(e) {
  return e.replace(Tk, (t) => {
    let a = be("0"), r = !1;
    for (const o of t.matchAll(Bk)) {
      const s = be(o[1]);
      s && (r = !0, a = Sn(a, o[2] ? nt(s, es(o[2])) : s));
    }
    return r ? Ye(a, a.s) : t;
  });
}
const Lk = /원화|원|엔|씩|개월|개|명|건/g;
function jk(e) {
  return qk(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Lk, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Ik = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Rk(e, t, a) {
  const r = be("1"), o = Ye(nt(t, tr(100)), 0);
  if (a === "add")
    return {
      value: pt(nt(e, Sn(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = Ot(nt(e, t), Sn(r, t));
  return {
    value: s ? pt(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Pk(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: vn };
  const r = wk(a, t.today), o = Nk(r), s = xk(r, o);
  if (s) return s;
  const l = Dk(r, o);
  if (l) return l;
  const c = Sk(r, (i = t.rates) != null ? i : []);
  return c || Xk(r, t);
}
function Xk(e, t) {
  var m, u;
  const a = Ik.exec(e), r = a ? e.slice(0, a.index) : e, o = jk(r);
  if (!o) return { ok: !1, supported: vn };
  const s = vk(o);
  if (!s.ok)
    return { ok: !1, supported: vn };
  if (!a)
    return { ok: !0, explain: o, value: Zr(s.value), expr: o };
  const l = (u = (m = Ok(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...vn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Rk(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: Zr(i.value),
    expr: o
  };
}
function Ok(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = Ot(t, tr(100))) != null ? a : null;
}
function Zr(e) {
  const t = pt(e, 2, "half"), a = pt(t, 0, "down");
  return er(t, a).u === BigInt(0) ? Ye(t, 0, !0) : Ye(t, 2, !0);
}
const Ue = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function eo(e, t) {
  const a = Ue[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function zk(e, t, a, r, o = 4, s = "half") {
  const l = eo(e, t), c = eo(e, a);
  if (!l || !c) return null;
  const i = Ot(nt(r, l), c);
  return i ? pt(i, o, s) : null;
}
const Hk = [0, 1, 2, 3, 4, 6], Wk = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Fk(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = D(() => r == null ? [gn()] : [{ sign: "+", text: Ye(Jk(r), 0, !0) }]), [m, u] = D(0), [d, _] = D(0), [p, y] = D("half"), f = j(null);
  U(() => {
    const g = (N) => {
      N.key === "Escape" && (N.preventDefault(), o());
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [o]), U(() => {
    var g, N;
    (N = (g = f.current) == null ? void 0 : g.querySelector("[data-autofocus]")) == null || N.focus();
  }, [t]);
  const b = (g) => {
    const N = [...c.filter((E) => E.text !== ""), { sign: "+", text: g }, gn()];
    i(N), u(N.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: f }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, Wk.map((g) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: g.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": g.key === t,
      onClick: () => a(g.key)
    },
    g.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Uk, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    hk,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: d,
      onDigits: _,
      mode: p,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Gk, null), t === "unit" && /* @__PURE__ */ n.createElement(Yk, null), t === "fx" && /* @__PURE__ */ n.createElement(Qk, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const Kk = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Vk = 20;
function Uk({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = D(""), [s, l] = D(null), [c, i] = D(!1), [m, u] = D(!1), d = j(!1), _ = _e(nr, []), p = (f) => {
    o(f), u(!1);
    const b = Pk(f, { today: _, rates: pn, taxRate: null });
    l(b), f.trim() && t([f, ...e.filter((g) => g !== f)].slice(0, Vk));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (f) => o(f.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (f) => {
        f.key === "Enter" && !f.shiftKey && !d.current && !f.nativeEvent.isComposing && (f.preventDefault(), p(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Kk.map((f) => /* @__PURE__ */ n.createElement("button", { key: f, type: "button", className: "bical-chip", onClick: () => p(f) }, f))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var f;
        (f = navigator.clipboard) == null || f.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : vn).map((f) => /* @__PURE__ */ n.createElement("li", { key: f }, f))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((f) => !f) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((f) => /* @__PURE__ */ n.createElement("li", { key: f }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => p(f) }, f))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Gk() {
  const e = _e(nr, []), [t, a] = D(He(e)), [r, o] = D(He(e)), [s, l] = D("exclude-first"), c = Pa(t), i = Pa(r), m = c && i ? Yo(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "계산 방식",
      className: "bical-select",
      value: s,
      onChange: (u) => l(u),
      options: [{ value: "exclude-first", label: "초일불산입 말일산입" }, { value: "include-first", label: "초일산입 말일산입" }]
    }
  )), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => o(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, He(c), "(", Xa(c), ") ~ ", He(i), "(", Xa(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Yk() {
  const [e, t] = D("area"), [a, r] = D(Ue.area.units[0].key), [o, s] = D(Ue.area.units[4].key), [l, c] = D(""), [i, m] = D(4), [u, d] = D("half"), _ = (f) => {
    t(f), r(Ue[f].units[0].key), s(Ue[f].units[1].key), c("");
  }, p = be(l), y = p ? zk(e, a, o, p, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "분류",
      className: "bical-select",
      value: e,
      onChange: (f) => _(f),
      options: Object.keys(Ue).map((f) => ({ value: f, label: Ue[f].label }))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", Ue[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (f) => c(f.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "변환 전 단위",
      className: "bical-select",
      value: a,
      onChange: r,
      options: Ue[e].units.map((f) => ({ value: f.key, label: f.label }))
    }
  ), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "변환 후 단위",
      className: "bical-select",
      value: o,
      onChange: s,
      options: Ue[e].units.map((f) => ({ value: f.key, label: f.label }))
    }
  )), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "자리수",
      className: "bical-select",
      value: String(i),
      onChange: (f) => m(Number(f)),
      options: Hk.map((f) => ({ value: String(f), label: String(f) }))
    }
  ), /* @__PURE__ */ n.createElement(Ie, { label: "표기 방법", className: "bical-select", value: u, onChange: (f) => d(f), options: Zo })), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, to(e, a), " → ", to(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ye(y, i, !0) : "—")));
}
function to(e, t) {
  var a, r;
  return (r = (a = Ue[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Qk() {
  const e = _e(nr, []), [t, a] = D(He(e)), [r, o] = D("JPY"), [s, l] = D("KRW"), [c, i] = D(""), m = be(c), u = m ? Jo(pn, m, r, s) : null, d = Oa(pn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "변환 전 통화",
      className: "bical-select",
      value: r,
      onChange: o,
      options: pn.map((_) => ({ value: _.code, label: `${_.code} (${_.label})` }))
    }
  ), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement(
    Ie,
    {
      label: "변환 후 통화",
      className: "bical-select",
      value: s,
      onChange: l,
      options: pn.map((_) => ({ value: _.code, label: `${_.code} (${_.label})` }))
    }
  )), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, d ? Qo(d) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ye(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function nr() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Jk(e) {
  var t;
  return pt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const ts = na(null);
function l2({ children: e }) {
  const [t, a] = D(!1), [r, o] = D("text"), [s, l] = D(null), [c, i] = D([]), [m, u] = D(0), d = _e(() => ({
    open: (_) => {
      var p, y;
      o((p = _ == null ? void 0 : _.tab) != null ? p : "text"), l((y = _ == null ? void 0 : _.seed) != null ? y : null), u((f) => f + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(ts.Provider, { value: d }, e, t && /* @__PURE__ */ n.createElement(
    Fk,
    {
      key: m,
      tab: r,
      onTab: o,
      seed: s,
      onClose: d.close,
      history: c,
      onHistory: i
    }
  ));
}
function c2() {
  var e;
  return (e = ta(ts)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class i2 extends no {
  constructor() {
    super(...arguments), this.rootRef = rs(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new uo(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  LN as $,
  n_ as A,
  Sw as B,
  Fk as C,
  Do as D,
  zo as E,
  $N as F,
  zc as G,
  yN as H,
  Iy as I,
  lN as J,
  mN as K,
  nN as L,
  aN as M,
  WN as N,
  ww as O,
  Ws as P,
  Sa as Q,
  Vn as R,
  kw as S,
  wn as T,
  Da as U,
  EN as V,
  FN as W,
  AN as X,
  DN as Y,
  Ha as Z,
  YN as _,
  a2 as a,
  Z0 as a$,
  IN as a0,
  RN as a1,
  Fw as a2,
  ca as a3,
  Kw as a4,
  b_ as a5,
  bN as a6,
  Gw as a7,
  jN as a8,
  bs as a9,
  JN as aA,
  hw as aB,
  xN as aC,
  hn as aD,
  QN as aE,
  jw as aF,
  Ew as aG,
  _N as aH,
  io as aI,
  t2 as aJ,
  n2 as aK,
  oy as aL,
  Os as aM,
  o2 as aN,
  oN as aO,
  zt as aP,
  Mw as aQ,
  Uw as aR,
  Aw as aS,
  yo as aT,
  XN as aU,
  PN as aV,
  No as aW,
  v_ as aX,
  Kb as aY,
  ua as aZ,
  AE as a_,
  cw as aa,
  fN as ab,
  GN as ac,
  vw as ad,
  uw as ae,
  HN as af,
  TN as ag,
  qN as ah,
  GE as ai,
  BN as aj,
  dy as ak,
  SN as al,
  ZN as am,
  rN as an,
  gw as ao,
  fw as ap,
  bw as aq,
  sy as ar,
  uk as as,
  pw as at,
  yw as au,
  _w as av,
  Iw as aw,
  qw as ax,
  Lw as ay,
  Bw as az,
  ml as b,
  Eg as b$,
  ow as b0,
  sw as b1,
  lw as b2,
  rw as b3,
  ds as b4,
  Kn as b5,
  ro as b6,
  ps as b7,
  nw as b8,
  aw as b9,
  Qh as bA,
  ul as bB,
  iw as bC,
  oi as bD,
  Wa as bE,
  UN as bF,
  Sv as bG,
  Cv as bH,
  Jn as bI,
  Yt as bJ,
  iy as bK,
  un as bL,
  Mo as bM,
  uy as bN,
  xr as bO,
  Ow as bP,
  hu as bQ,
  mu as bR,
  _y as bS,
  Bo as bT,
  Wy as bU,
  ri as bV,
  mo as bW,
  ai as bX,
  ql as bY,
  Oy as bZ,
  VN as b_,
  bo as ba,
  rn as bb,
  i2 as bc,
  uo as bd,
  wa as be,
  Fa as bf,
  Vw as bg,
  zd as bh,
  MN as bi,
  py as bj,
  Ca as bk,
  Gu as bl,
  Yu as bm,
  fo as bn,
  Ry as bo,
  jh as bp,
  Rr as bq,
  Lh as br,
  qh as bs,
  Oo as bt,
  To as bu,
  Zc as bv,
  gN as bw,
  Co as bx,
  ek as by,
  si as bz,
  mw as c,
  fs as c0,
  en as c1,
  qo as c2,
  go as c3,
  Hw as c4,
  Bd as c5,
  _s as c6,
  Td as c7,
  $i as c8,
  xw as c9,
  Zn as cA,
  Ah as cB,
  Dh as cC,
  kb as cD,
  Xt as cE,
  La as cF,
  Ja as cG,
  Ch as cH,
  gh as cI,
  vN as cJ,
  Za as cK,
  ia as cL,
  xh as cM,
  Mn as cN,
  Yw as cO,
  Dn as cP,
  jo as cQ,
  En as cR,
  NN as cS,
  kN as cT,
  Ro as cU,
  bh as cV,
  wN as cW,
  Ar as cX,
  kh as cY,
  Io as cZ,
  $w as ca,
  Ni as cb,
  Dw as cc,
  uu as cd,
  Eo as ce,
  yy as cf,
  c2 as cg,
  Jw as ch,
  k_ as ci,
  sN as cj,
  sh as ck,
  Wt as cl,
  Qw as cm,
  tN as cn,
  eN as co,
  CN as cp,
  Tw as cq,
  Zw as cr,
  s2 as cs,
  dw as ct,
  r2 as cu,
  Cw as cv,
  Ht as cw,
  Sh as cx,
  Xo as cy,
  Eh as cz,
  Nw as d,
  fn as e,
  ON as f,
  Fe as g,
  l2 as h,
  Ww as i,
  Va as j,
  e2 as k,
  KN as l,
  Ur as m,
  uN as n,
  Xw as o,
  Pw as p,
  pN as q,
  Rw as r,
  cN as s,
  iN as t,
  dN as u,
  hr as v,
  zw as w,
  zN as x,
  hN as y,
  Ie as z
};
